const raw = {
  "members": {
    "140796": {
      "local_score": 5677,
      "last_star_ts": 1671825833,
      "stars": 38,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 0,
            "get_star_ts": 1669870946
          },
          "2": {
            "get_star_ts": 1669871024,
            "star_index": 1460
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669957674,
            "star_index": 268594
          },
          "2": {
            "star_index": 296929,
            "get_star_ts": 1669960288
          }
        },
        "3": {
          "1": {
            "star_index": 578898,
            "get_star_ts": 1670044100
          },
          "2": {
            "star_index": 582666,
            "get_star_ts": 1670044395
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670130310,
            "star_index": 847827
          },
          "2": {
            "star_index": 848456,
            "get_star_ts": 1670130349
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670218809,
            "star_index": 1152554
          },
          "2": {
            "get_star_ts": 1670219048,
            "star_index": 1154281
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670303301,
            "star_index": 1445513
          },
          "2": {
            "get_star_ts": 1670303401,
            "star_index": 1448001
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670463937,
            "star_index": 1942322
          },
          "2": {
            "star_index": 1942705,
            "get_star_ts": 1670464234
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670500052,
            "star_index": 2040380
          },
          "2": {
            "star_index": 2047792,
            "get_star_ts": 1670502917
          }
        },
        "9": {
          "1": {
            "star_index": 2249706,
            "get_star_ts": 1670590514
          },
          "2": {
            "get_star_ts": 1670592647,
            "star_index": 2254641
          }
        },
        "10": {
          "1": {
            "star_index": 2446300,
            "get_star_ts": 1670684333
          },
          "2": {
            "star_index": 2449856,
            "get_star_ts": 1670685841
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670767619,
            "star_index": 2599545
          },
          "2": {
            "star_index": 2957913,
            "get_star_ts": 1670982907
          }
        },
        "12": {
          "1": {
            "star_index": 2752642,
            "get_star_ts": 1670852101
          },
          "2": {
            "star_index": 2753055,
            "get_star_ts": 1670852311
          }
        },
        "13": {
          "1": {
            "star_index": 2887924,
            "get_star_ts": 1670935277
          },
          "2": {
            "star_index": 2888566,
            "get_star_ts": 1670935673
          }
        },
        "14": {
          "1": {
            "star_index": 3011829,
            "get_star_ts": 1671020677
          },
          "2": {
            "get_star_ts": 1671022554,
            "star_index": 3014461
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671131806,
            "star_index": 3152622
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1671415574,
            "star_index": 3396601
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671418881,
            "star_index": 3397870
          },
          "2": {
            "get_star_ts": 1671424909,
            "star_index": 3400181
          }
        },
        "20": {
          "1": {
            "star_index": 3626670,
            "get_star_ts": 1671726285
          },
          "2": {
            "get_star_ts": 1671726605,
            "star_index": 3626908
          }
        },
        "21": {
          "1": {
            "star_index": 3562495,
            "get_star_ts": 1671632541
          },
          "2": {
            "get_star_ts": 1671718257,
            "star_index": 3620488
          }
        },
        "23": {
          "1": {
            "star_index": 3694616,
            "get_star_ts": 1671825500
          },
          "2": {
            "get_star_ts": 1671825833,
            "star_index": 3694858
          }
        }
      },
      "global_score": 0,
      "name": "Donnie Mattingly",
      "id": 140796
    },
    "186556": {
      "id": 186556,
      "name": "Chad Orwig",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 106773,
            "get_star_ts": 1669897314
          },
          "2": {
            "star_index": 110628,
            "get_star_ts": 1669898490
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669989651,
            "star_index": 436311
          },
          "2": {
            "get_star_ts": 1669995753,
            "star_index": 463323
          }
        },
        "3": {
          "1": {
            "star_index": 706757,
            "get_star_ts": 1670073739
          },
          "2": {
            "get_star_ts": 1670075763,
            "star_index": 714274
          }
        },
        "4": {
          "1": {
            "star_index": 970955,
            "get_star_ts": 1670155723
          },
          "2": {
            "star_index": 972018,
            "get_star_ts": 1670155961
          }
        },
        "5": {
          "1": {
            "star_index": 1288719,
            "get_star_ts": 1670250929
          },
          "2": {
            "get_star_ts": 1670251834,
            "star_index": 1292526
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670334536,
            "star_index": 1600493
          },
          "2": {
            "star_index": 1602861,
            "get_star_ts": 1670335120
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670424731,
            "star_index": 1843142
          },
          "2": {
            "star_index": 1844769,
            "get_star_ts": 1670425272
          }
        },
        "8": {
          "1": {
            "star_index": 2138293,
            "get_star_ts": 1670536347
          },
          "2": {
            "get_star_ts": 1670560129,
            "star_index": 2169742
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670594017,
            "star_index": 2258218
          },
          "2": {
            "get_star_ts": 1670599374,
            "star_index": 2271871
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670686831,
            "star_index": 2452164
          },
          "2": {
            "get_star_ts": 1670696075,
            "star_index": 2472731
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670784058,
            "star_index": 2637333
          },
          "2": {
            "get_star_ts": 1670785264,
            "star_index": 2639957
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670856920,
            "star_index": 2761929
          },
          "2": {
            "star_index": 2764137,
            "get_star_ts": 1670858041
          }
        },
        "13": {
          "1": {
            "star_index": 2923933,
            "get_star_ts": 1670957262
          },
          "2": {
            "star_index": 2930576,
            "get_star_ts": 1670961423
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671041869,
            "star_index": 3043582
          },
          "2": {
            "star_index": 3044732,
            "get_star_ts": 1671042679
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671131725,
            "star_index": 3152521
          },
          "2": {
            "get_star_ts": 1671138280,
            "star_index": 3161733
          }
        },
        "16": {
          "1": {
            "star_index": 3218279,
            "get_star_ts": 1671206089
          },
          "2": {
            "star_index": 3229747,
            "get_star_ts": 1671217392
          }
        },
        "17": {
          "1": {
            "star_index": 3310773,
            "get_star_ts": 1671315830
          },
          "2": {
            "star_index": 3320917,
            "get_star_ts": 1671331975
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671369976,
            "star_index": 3357596
          },
          "2": {
            "get_star_ts": 1671382537,
            "star_index": 3370190
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1671478338,
            "star_index": 3439769
          },
          "2": {
            "star_index": 3447891,
            "get_star_ts": 1671486854
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1671553312,
            "star_index": 3497285
          },
          "2": {
            "get_star_ts": 1671591494,
            "star_index": 3524883
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1671631642,
            "star_index": 3561623
          },
          "2": {
            "get_star_ts": 1671643638,
            "star_index": 3572765
          }
        },
        "22": {
          "1": {
            "star_index": 3627274,
            "get_star_ts": 1671727090
          },
          "2": {
            "get_star_ts": 1671740298,
            "star_index": 3636918
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1671827714,
            "star_index": 3696121
          },
          "2": {
            "get_star_ts": 1671827965,
            "star_index": 3696300
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1671911273,
            "star_index": 3741284
          },
          "2": {
            "star_index": 3741430,
            "get_star_ts": 1671911607
          }
        },
        "25": {
          "1": {
            "star_index": 3756069,
            "get_star_ts": 1671946092
          },
          "2": {
            "star_index": 3756074,
            "get_star_ts": 1671946096
          }
        }
      },
      "last_star_ts": 1671946096,
      "stars": 50,
      "local_score": 7150
    },
    "188249": {
      "id": 188249,
      "name": "Austin Assavavallop",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 5267,
            "get_star_ts": 1669871216
          },
          "2": {
            "get_star_ts": 1669871293,
            "star_index": 6598
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669958402,
            "star_index": 279918
          },
          "2": {
            "get_star_ts": 1669959053,
            "star_index": 287613
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670299585,
            "star_index": 1432952
          },
          "2": {
            "get_star_ts": 1670300192,
            "star_index": 1433700
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670300991,
            "star_index": 1434598
          },
          "2": {
            "star_index": 1434711,
            "get_star_ts": 1670301081
          }
        },
        "5": {
          "1": {
            "star_index": 1459373,
            "get_star_ts": 1670304045
          },
          "2": {
            "get_star_ts": 1670305048,
            "star_index": 1469021
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670305723,
            "star_index": 1473415
          },
          "2": {
            "star_index": 1473645,
            "get_star_ts": 1670305762
          }
        },
        "8": {
          "1": {
            "star_index": 2158140,
            "get_star_ts": 1670547659
          },
          "2": {
            "get_star_ts": 1670560142,
            "star_index": 2169762
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671664217,
            "star_index": 3589534
          }
        },
        "10": {
          "1": {
            "star_index": 3594791,
            "get_star_ts": 1671676405
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1671776835,
            "star_index": 3658281
          }
        }
      },
      "stars": 17,
      "last_star_ts": 1671776835,
      "local_score": 1938
    },
    "188251": {
      "last_star_ts": 1673568190,
      "stars": 31,
      "local_score": 2985,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1362009,
            "get_star_ts": 1670269786
          },
          "2": {
            "star_index": 1363378,
            "get_star_ts": 1670270139
          }
        },
        "2": {
          "1": {
            "star_index": 1371311,
            "get_star_ts": 1670272143
          },
          "2": {
            "star_index": 1386329,
            "get_star_ts": 1670276067
          }
        },
        "3": {
          "1": {
            "star_index": 1708776,
            "get_star_ts": 1670367487
          },
          "2": {
            "star_index": 1712214,
            "get_star_ts": 1670369211
          }
        },
        "4": {
          "1": {
            "star_index": 1719602,
            "get_star_ts": 1670374072
          },
          "2": {
            "star_index": 1720559,
            "get_star_ts": 1670374796
          }
        },
        "5": {
          "1": {
            "star_index": 1725273,
            "get_star_ts": 1670378663
          },
          "2": {
            "get_star_ts": 1670378990,
            "star_index": 1725579
          }
        },
        "6": {
          "1": {
            "star_index": 1726706,
            "get_star_ts": 1670379960
          },
          "2": {
            "get_star_ts": 1670380066,
            "star_index": 1726832
          }
        },
        "7": {
          "1": {
            "star_index": 3898201,
            "get_star_ts": 1672373726
          },
          "2": {
            "star_index": 3898283,
            "get_star_ts": 1672374449
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1672431067,
            "star_index": 3910318
          },
          "2": {
            "get_star_ts": 1672431574,
            "star_index": 3910476
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1672510896,
            "star_index": 3923669
          },
          "2": {
            "get_star_ts": 1672511763,
            "star_index": 3923802
          }
        },
        "10": {
          "1": {
            "star_index": 3924088,
            "get_star_ts": 1672513693
          },
          "2": {
            "star_index": 3924451,
            "get_star_ts": 1672515933
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1672519921,
            "star_index": 3925073
          },
          "2": {
            "star_index": 3966544,
            "get_star_ts": 1672808294
          }
        },
        "12": {
          "1": {
            "star_index": 3988496,
            "get_star_ts": 1672982608
          },
          "2": {
            "star_index": 3988551,
            "get_star_ts": 1672983430
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1673292655,
            "star_index": 4019309
          },
          "2": {
            "get_star_ts": 1673302847,
            "star_index": 4020652
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1673313971,
            "star_index": 4021592
          },
          "2": {
            "get_star_ts": 1673322671,
            "star_index": 4022051
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1673368137,
            "star_index": 4025519
          },
          "2": {
            "star_index": 4036156,
            "get_star_ts": 1673499131
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1673568190,
            "star_index": 4041598
          }
        }
      },
      "name": "Basil Udoudoh",
      "id": 188251
    },
    "188257": {
      "id": 188257,
      "name": "G. Hamilton Evans",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669898016,
            "star_index": 109098
          },
          "2": {
            "get_star_ts": 1669898141,
            "star_index": 109469
          }
        },
        "2": {
          "1": {
            "star_index": 464916,
            "get_star_ts": 1669996103
          },
          "2": {
            "get_star_ts": 1669996844,
            "star_index": 468154
          }
        },
        "3": {
          "1": {
            "star_index": 714257,
            "get_star_ts": 1670075759
          },
          "2": {
            "get_star_ts": 1670076453,
            "star_index": 716784
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670161385,
            "star_index": 994562
          },
          "2": {
            "get_star_ts": 1670161637,
            "star_index": 995584
          }
        },
        "5": {
          "1": {
            "star_index": 1261118,
            "get_star_ts": 1670243803
          },
          "2": {
            "star_index": 1262891,
            "get_star_ts": 1670244290
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670334082,
            "star_index": 1598731
          },
          "2": {
            "star_index": 1598918,
            "get_star_ts": 1670334140
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670516800,
            "star_index": 2086979
          },
          "2": {
            "star_index": 2089286,
            "get_star_ts": 1670517636
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670593798,
            "star_index": 2257621
          },
          "2": {
            "star_index": 2260825,
            "get_star_ts": 1670595038
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670599403,
            "star_index": 2271955
          },
          "2": {
            "get_star_ts": 1670680780,
            "star_index": 2437680
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670682505,
            "star_index": 2441869
          },
          "2": {
            "star_index": 2469768,
            "get_star_ts": 1670694644
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670769726,
            "star_index": 2604454
          },
          "2": {
            "get_star_ts": 1670774344,
            "star_index": 2615151
          }
        },
        "12": {
          "1": {
            "star_index": 2756007,
            "get_star_ts": 1670853873
          },
          "2": {
            "star_index": 2756618,
            "get_star_ts": 1670854197
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1670854197,
      "local_score": 3124,
      "stars": 24
    },
    "189285": {
      "name": "Steven Porter",
      "id": 189285,
      "last_star_ts": 1669909867,
      "local_score": 205,
      "stars": 2,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 149947,
            "get_star_ts": 1669909404
          },
          "2": {
            "get_star_ts": 1669909867,
            "star_index": 151678
          }
        }
      }
    },
    "250536": {
      "last_star_ts": 1671295882,
      "local_score": 4606,
      "stars": 31,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669871315,
            "star_index": 6926
          },
          "2": {
            "star_index": 9354,
            "get_star_ts": 1669871493
          }
        },
        "2": {
          "1": {
            "star_index": 268971,
            "get_star_ts": 1669957702
          },
          "2": {
            "get_star_ts": 1669958075,
            "star_index": 274825
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670044729,
            "star_index": 587067
          },
          "2": {
            "get_star_ts": 1670045120,
            "star_index": 591398
          }
        },
        "4": {
          "1": {
            "star_index": 861021,
            "get_star_ts": 1670131098
          },
          "2": {
            "star_index": 864700,
            "get_star_ts": 1670131420
          }
        },
        "5": {
          "1": {
            "star_index": 1278048,
            "get_star_ts": 1670248213
          },
          "2": {
            "get_star_ts": 1670248715,
            "star_index": 1280035
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670306478,
            "star_index": 1477506
          },
          "2": {
            "get_star_ts": 1670306990,
            "star_index": 1479989
          }
        },
        "7": {
          "1": {
            "star_index": 1759904,
            "get_star_ts": 1670395456
          },
          "2": {
            "star_index": 1762315,
            "get_star_ts": 1670396214
          }
        },
        "8": {
          "1": {
            "star_index": 1961043,
            "get_star_ts": 1670476916
          },
          "2": {
            "star_index": 1971573,
            "get_star_ts": 1670478576
          }
        },
        "9": {
          "1": {
            "star_index": 2190924,
            "get_star_ts": 1670566947
          },
          "2": {
            "star_index": 2195278,
            "get_star_ts": 1670568489
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670649159,
            "star_index": 2352253
          },
          "2": {
            "get_star_ts": 1670650646,
            "star_index": 2362119
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670736664,
            "star_index": 2530647
          },
          "2": {
            "get_star_ts": 1670938884,
            "star_index": 2893572
          }
        },
        "12": {
          "1": {
            "star_index": 2958525,
            "get_star_ts": 1670983891
          },
          "2": {
            "get_star_ts": 1670984404,
            "star_index": 2958848
          }
        },
        "13": {
          "1": {
            "star_index": 2962022,
            "get_star_ts": 1670989370
          },
          "2": {
            "star_index": 2964129,
            "get_star_ts": 1670992732
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1670998010,
            "star_index": 2975709
          },
          "2": {
            "get_star_ts": 1670998402,
            "star_index": 2976760
          }
        },
        "15": {
          "1": {
            "star_index": 3088237,
            "get_star_ts": 1671083508
          },
          "2": {
            "get_star_ts": 1671152951,
            "star_index": 3177181
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1671295882,
            "star_index": 3291689
          }
        }
      },
      "name": "Jeremy Lizza",
      "id": 250536
    },
    "254702": {
      "id": 254702,
      "name": "Brian O'Connor",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669991334,
            "star_index": 443595
          },
          "2": {
            "star_index": 443723,
            "get_star_ts": 1669991360
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669993080,
            "star_index": 451541
          },
          "2": {
            "get_star_ts": 1669996255,
            "star_index": 465582
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670255047,
            "star_index": 1305556
          },
          "2": {
            "get_star_ts": 1670256453,
            "star_index": 1311396
          }
        },
        "4": {
          "1": {
            "star_index": 1320484,
            "get_star_ts": 1670258680
          },
          "2": {
            "star_index": 1321807,
            "get_star_ts": 1670258998
          }
        },
        "5": {
          "1": {
            "star_index": 2296700,
            "get_star_ts": 1670610361
          },
          "2": {
            "get_star_ts": 1670610456,
            "star_index": 2296895
          }
        },
        "6": {
          "1": {
            "star_index": 2299711,
            "get_star_ts": 1670611841
          },
          "2": {
            "star_index": 2299803,
            "get_star_ts": 1670611886
          }
        },
        "7": {
          "1": {
            "star_index": 2305468,
            "get_star_ts": 1670614759
          },
          "2": {
            "get_star_ts": 1670615373,
            "star_index": 2306744
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670630808,
            "star_index": 2335123
          },
          "2": {
            "star_index": 2906748,
            "get_star_ts": 1670946780
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670951787,
            "star_index": 2915035
          },
          "2": {
            "star_index": 3139571,
            "get_star_ts": 1671121505
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1671557146,
            "star_index": 3500891
          },
          "2": {
            "get_star_ts": 1671559531,
            "star_index": 3502909
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1671565159,
            "star_index": 3507635
          },
          "2": {
            "get_star_ts": 1671629738,
            "star_index": 3559878
          }
        },
        "14": {
          "1": {
            "star_index": 3588491,
            "get_star_ts": 1671662743
          },
          "2": {
            "star_index": 3588771,
            "get_star_ts": 1671663123
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671677222,
            "star_index": 3595068
          },
          "2": {
            "get_star_ts": 1671718073,
            "star_index": 3620346
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1671727948,
            "star_index": 3627943
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1673562454,
            "star_index": 4041187
          }
        }
      },
      "last_star_ts": 1673562454,
      "local_score": 2877,
      "stars": 28
    },
    "273518": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 100755,
            "get_star_ts": 1669895451
          },
          "2": {
            "star_index": 102930,
            "get_star_ts": 1669896138
          }
        },
        "2": {
          "1": {
            "star_index": 430274,
            "get_star_ts": 1669988210
          },
          "2": {
            "star_index": 434746,
            "get_star_ts": 1669989278
          }
        },
        "3": {
          "1": {
            "star_index": 781884,
            "get_star_ts": 1670095600
          },
          "2": {
            "get_star_ts": 1670097211,
            "star_index": 786634
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670162195,
            "star_index": 997903
          },
          "2": {
            "star_index": 999378,
            "get_star_ts": 1670162557
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670335035,
            "star_index": 1602493
          },
          "2": {
            "star_index": 1605191,
            "get_star_ts": 1670335715
          }
        },
        "6": {
          "1": {
            "star_index": 1608991,
            "get_star_ts": 1670336688
          },
          "2": {
            "star_index": 1611376,
            "get_star_ts": 1670337272
          }
        },
        "7": {
          "1": {
            "star_index": 1827979,
            "get_star_ts": 1670419375
          },
          "2": {
            "get_star_ts": 1670421040,
            "star_index": 1832518
          }
        },
        "8": {
          "1": {
            "star_index": 2052129,
            "get_star_ts": 1670504545
          },
          "2": {
            "star_index": 2055708,
            "get_star_ts": 1670505900
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670594624,
            "star_index": 2259787
          },
          "2": {
            "get_star_ts": 1670601492,
            "star_index": 2277140
          }
        },
        "10": {
          "1": {
            "star_index": 2435536,
            "get_star_ts": 1670679874
          },
          "2": {
            "star_index": 2437116,
            "get_star_ts": 1670680537
          }
        },
        "11": {
          "1": {
            "star_index": 2613763,
            "get_star_ts": 1670773757
          },
          "2": {
            "star_index": 2616215,
            "get_star_ts": 1670774799
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670852567,
            "star_index": 2753529
          },
          "2": {
            "star_index": 2755788,
            "get_star_ts": 1670853762
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670939543,
            "star_index": 2894623
          },
          "2": {
            "star_index": 2896721,
            "get_star_ts": 1670940830
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671026950,
            "star_index": 3020957
          },
          "2": {
            "star_index": 3022872,
            "get_star_ts": 1671028155
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671102190,
            "star_index": 3114678
          },
          "2": {
            "star_index": 3117153,
            "get_star_ts": 1671104260
          }
        },
        "16": {
          "1": {
            "star_index": 3209366,
            "get_star_ts": 1671197645
          },
          "2": {
            "star_index": 3212399,
            "get_star_ts": 1671200624
          }
        },
        "17": {
          "1": {
            "star_index": 3432652,
            "get_star_ts": 1671469795
          },
          "2": {
            "get_star_ts": 1671493330,
            "star_index": 3453347
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671388748,
            "star_index": 3375360
          },
          "2": {
            "get_star_ts": 1671390268,
            "star_index": 3376725
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1671462429,
            "star_index": 3425916
          },
          "2": {
            "star_index": 3427425,
            "get_star_ts": 1671464142
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1671543123,
            "star_index": 3488099
          },
          "2": {
            "star_index": 3490002,
            "get_star_ts": 1671545321
          }
        },
        "21": {
          "1": {
            "star_index": 3562057,
            "get_star_ts": 1671632103
          },
          "2": {
            "star_index": 3564812,
            "get_star_ts": 1671634935
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1671718623,
            "star_index": 3620783
          },
          "2": {
            "star_index": 3632913,
            "get_star_ts": 1671734744
          }
        },
        "23": {
          "1": {
            "star_index": 3682304,
            "get_star_ts": 1671809110
          },
          "2": {
            "star_index": 3706677,
            "get_star_ts": 1671845682
          }
        },
        "24": {
          "1": {
            "star_index": 3714930,
            "get_star_ts": 1671864223
          },
          "2": {
            "get_star_ts": 1672155814,
            "star_index": 3839500
          }
        },
        "25": {
          "1": {
            "star_index": 3841219,
            "get_star_ts": 1672159877
          },
          "2": {
            "star_index": 3841223,
            "get_star_ts": 1672159882
          }
        }
      },
      "last_star_ts": 1672159882,
      "stars": 50,
      "local_score": 7154,
      "id": 273518,
      "name": "chastainalexandra"
    },
    "330030": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 153748,
            "get_star_ts": 1669910423
          },
          "2": {
            "star_index": 158820,
            "get_star_ts": 1669911835
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670008516,
            "star_index": 510092
          },
          "2": {
            "get_star_ts": 1670008984,
            "star_index": 511490
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670083303,
            "star_index": 741355
          },
          "2": {
            "get_star_ts": 1670083788,
            "star_index": 742926
          }
        },
        "4": {
          "1": {
            "star_index": 1015180,
            "get_star_ts": 1670166524
          },
          "2": {
            "get_star_ts": 1670166821,
            "star_index": 1016259
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670259241,
            "star_index": 1322720
          },
          "2": {
            "get_star_ts": 1670262709,
            "star_index": 1335657
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670352469,
            "star_index": 1663003
          },
          "2": {
            "star_index": 1663640,
            "get_star_ts": 1670352667
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670426524,
            "star_index": 1848408
          },
          "2": {
            "get_star_ts": 1670439891,
            "star_index": 1886182
          }
        },
        "8": {
          "1": {
            "star_index": 2104482,
            "get_star_ts": 1670523489
          },
          "2": {
            "star_index": 2322480,
            "get_star_ts": 1670623235
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670615372,
            "star_index": 2306739
          }
        },
        "10": {
          "1": {
            "star_index": 2684470,
            "get_star_ts": 1670811472
          },
          "2": {
            "star_index": 2819060,
            "get_star_ts": 1670886283
          }
        },
        "11": {
          "1": {
            "star_index": 2611737,
            "get_star_ts": 1670772890
          },
          "2": {
            "get_star_ts": 1670787063,
            "star_index": 2644023
          }
        },
        "12": {
          "1": {
            "star_index": 2921500,
            "get_star_ts": 1670955788
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1670955788,
      "local_score": 2588,
      "stars": 22,
      "id": 330030,
      "name": "Kevin Wright"
    },
    "372160": {
      "stars": 12,
      "last_star_ts": 1672685048,
      "local_score": 823,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 155328,
            "get_star_ts": 1669910862
          },
          "2": {
            "star_index": 157674,
            "get_star_ts": 1669911526
          }
        },
        "2": {
          "1": {
            "star_index": 553399,
            "get_star_ts": 1670024058
          },
          "2": {
            "star_index": 558265,
            "get_star_ts": 1670026877
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1672087784,
            "star_index": 3820030
          },
          "2": {
            "get_star_ts": 1672088876,
            "star_index": 3820546
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1672370746,
            "star_index": 3897858
          },
          "2": {
            "get_star_ts": 1672370776,
            "star_index": 3897864
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1672670848,
            "star_index": 3944613
          },
          "2": {
            "star_index": 3944652,
            "get_star_ts": 1672671085
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1672684091,
            "star_index": 3947394
          },
          "2": {
            "get_star_ts": 1672685048,
            "star_index": 3947554
          }
        }
      },
      "name": "Alex Consunji",
      "id": 372160
    },
    "372360": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 10658,
            "get_star_ts": 1669871606
          },
          "2": {
            "star_index": 13429,
            "get_star_ts": 1669871919
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670000861,
            "star_index": 484287
          },
          "2": {
            "get_star_ts": 1670001097,
            "star_index": 485195
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670078374,
            "star_index": 723841
          },
          "2": {
            "star_index": 726508,
            "get_star_ts": 1670079112
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670165160,
            "star_index": 1009753
          },
          "2": {
            "star_index": 1010679,
            "get_star_ts": 1670165389
          }
        },
        "5": {
          "1": {
            "star_index": 1283788,
            "get_star_ts": 1670249671
          },
          "2": {
            "get_star_ts": 1670250019,
            "star_index": 1285127
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670337611,
            "star_index": 1612718
          },
          "2": {
            "star_index": 1613222,
            "get_star_ts": 1670337738
          }
        },
        "7": {
          "1": {
            "star_index": 1844822,
            "get_star_ts": 1670425293
          },
          "2": {
            "get_star_ts": 1670426110,
            "star_index": 1847194
          }
        },
        "8": {
          "1": {
            "star_index": 2073306,
            "get_star_ts": 1670512066
          },
          "2": {
            "get_star_ts": 1670513090,
            "star_index": 2076338
          }
        },
        "9": {
          "1": {
            "star_index": 2267632,
            "get_star_ts": 1670597683
          },
          "2": {
            "star_index": 2280775,
            "get_star_ts": 1670602995
          }
        },
        "10": {
          "1": {
            "star_index": 2518471,
            "get_star_ts": 1670722907
          },
          "2": {
            "get_star_ts": 1670729766,
            "star_index": 2523744
          }
        },
        "11": {
          "1": {
            "star_index": 2683735,
            "get_star_ts": 1670810624
          },
          "2": {
            "get_star_ts": 1670855107,
            "star_index": 2758333
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670864312,
            "star_index": 2776497
          },
          "2": {
            "get_star_ts": 1670864673,
            "star_index": 2777177
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670953854,
            "star_index": 2918427
          },
          "2": {
            "star_index": 2919203,
            "get_star_ts": 1670954363
          }
        },
        "14": {
          "1": {
            "star_index": 3027352,
            "get_star_ts": 1671031076
          },
          "2": {
            "star_index": 3028156,
            "get_star_ts": 1671031596
          }
        },
        "15": {
          "1": {
            "star_index": 3139181,
            "get_star_ts": 1671121195
          },
          "2": {
            "get_star_ts": 1671138348,
            "star_index": 3161826
          }
        },
        "16": {
          "1": {
            "star_index": 3238784,
            "get_star_ts": 1671226178
          },
          "2": {
            "star_index": 3299418,
            "get_star_ts": 1671304039
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1671337185,
            "star_index": 3322883
          },
          "2": {
            "get_star_ts": 1671552846,
            "star_index": 3496861
          }
        },
        "18": {
          "1": {
            "star_index": 3329771,
            "get_star_ts": 1671342165
          },
          "2": {
            "star_index": 3504226,
            "get_star_ts": 1671561138
          }
        },
        "19": {
          "1": {
            "star_index": 3583630,
            "get_star_ts": 1671656899
          },
          "2": {
            "star_index": 3621526,
            "get_star_ts": 1671719633
          }
        },
        "20": {
          "1": {
            "star_index": 3567099,
            "get_star_ts": 1671637364
          },
          "2": {
            "get_star_ts": 1671638093,
            "star_index": 3567831
          }
        },
        "21": {
          "1": {
            "star_index": 3568817,
            "get_star_ts": 1671639123
          },
          "2": {
            "star_index": 3571710,
            "get_star_ts": 1671642399
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1671733680,
            "star_index": 3632152
          },
          "2": {
            "get_star_ts": 1671746298,
            "star_index": 3641499
          }
        },
        "23": {
          "1": {
            "star_index": 3687839,
            "get_star_ts": 1671815927
          },
          "2": {
            "star_index": 3696659,
            "get_star_ts": 1671828408
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1671910054,
            "star_index": 3740744
          },
          "2": {
            "star_index": 3741381,
            "get_star_ts": 1671911492
          }
        },
        "25": {
          "1": {
            "star_index": 3841107,
            "get_star_ts": 1672159614
          },
          "2": {
            "get_star_ts": 1672159634,
            "star_index": 3841125
          }
        }
      },
      "last_star_ts": 1672159634,
      "local_score": 7044,
      "stars": 50,
      "id": 372360,
      "name": "Corey Lamb"
    },
    "372419": {
      "last_star_ts": 1670803623,
      "local_score": 1521,
      "stars": 13,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 118229,
            "get_star_ts": 1669900819
          },
          "2": {
            "get_star_ts": 1669900923,
            "star_index": 118569
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669988037,
            "star_index": 429547
          },
          "2": {
            "star_index": 447450,
            "get_star_ts": 1669992189
          }
        },
        "3": {
          "1": {
            "star_index": 729486,
            "get_star_ts": 1670079938
          },
          "2": {
            "star_index": 748222,
            "get_star_ts": 1670085330
          }
        },
        "4": {
          "1": {
            "star_index": 1016366,
            "get_star_ts": 1670166853
          },
          "2": {
            "star_index": 1016628,
            "get_star_ts": 1670166927
          }
        },
        "5": {
          "1": {
            "star_index": 1402233,
            "get_star_ts": 1670280691
          },
          "2": {
            "get_star_ts": 1670297173,
            "star_index": 1429959
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670334252,
            "star_index": 1599366
          },
          "2": {
            "star_index": 1599669,
            "get_star_ts": 1670334327
          }
        },
        "10": {
          "1": {
            "star_index": 2676853,
            "get_star_ts": 1670803623
          }
        }
      },
      "global_score": 0,
      "name": "Kevin Campbell",
      "id": 372419
    },
    "389033": {
      "name": "Joshua Angeley",
      "id": 389033,
      "last_star_ts": 1673042869,
      "stars": 22,
      "local_score": 2374,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669874163,
            "star_index": 23700
          },
          "2": {
            "star_index": 24475,
            "get_star_ts": 1669874400
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670087730,
            "star_index": 756462
          },
          "2": {
            "star_index": 759178,
            "get_star_ts": 1670088533
          }
        },
        "3": {
          "1": {
            "star_index": 821210,
            "get_star_ts": 1670109889
          },
          "2": {
            "get_star_ts": 1670111089,
            "star_index": 823541
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670171391,
            "star_index": 1032634
          },
          "2": {
            "star_index": 1124956,
            "get_star_ts": 1670206094
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670296952,
            "star_index": 1429683
          },
          "2": {
            "get_star_ts": 1670298705,
            "star_index": 1431911
          }
        },
        "6": {
          "1": {
            "star_index": 1724540,
            "get_star_ts": 1670378106
          },
          "2": {
            "get_star_ts": 1670378207,
            "star_index": 1724671
          }
        },
        "8": {
          "1": {
            "star_index": 2480162,
            "get_star_ts": 1670699662
          },
          "2": {
            "star_index": 2487691,
            "get_star_ts": 1670703544
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670717920,
            "star_index": 2513318
          },
          "2": {
            "get_star_ts": 1670731225,
            "star_index": 2524760
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1672772739,
            "star_index": 3961449
          },
          "2": {
            "get_star_ts": 1672779907,
            "star_index": 3962885
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1672805849,
            "star_index": 3966337
          },
          "2": {
            "star_index": 3982678,
            "get_star_ts": 1672934407
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1672934860,
            "star_index": 3982749
          }
        },
        "14": {
          "1": {
            "star_index": 3995932,
            "get_star_ts": 1673042869
          }
        }
      },
      "global_score": 0
    },
    "453980": {
      "name": "Scott Hankinson",
      "id": 453980,
      "last_star_ts": 1671810595,
      "stars": 27,
      "local_score": 2319,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 2473908,
            "get_star_ts": 1670696632
          },
          "2": {
            "get_star_ts": 1670696707,
            "star_index": 2474056
          }
        },
        "2": {
          "1": {
            "star_index": 3433288,
            "get_star_ts": 1671470537
          },
          "2": {
            "get_star_ts": 1671471081,
            "star_index": 3433732
          }
        },
        "3": {
          "1": {
            "star_index": 3562558,
            "get_star_ts": 1671632601
          },
          "2": {
            "star_index": 3563108,
            "get_star_ts": 1671633202
          }
        },
        "4": {
          "1": {
            "star_index": 3563614,
            "get_star_ts": 1671633696
          },
          "2": {
            "star_index": 3563933,
            "get_star_ts": 1671634011
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1671636077,
            "star_index": 3565859
          },
          "2": {
            "get_star_ts": 1671636349,
            "star_index": 3566133
          }
        },
        "6": {
          "1": {
            "star_index": 3566956,
            "get_star_ts": 1671637223
          },
          "2": {
            "star_index": 3567314,
            "get_star_ts": 1671637574
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1671643505,
            "star_index": 3572649
          },
          "2": {
            "star_index": 3572932,
            "get_star_ts": 1671643857
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1671647118,
            "star_index": 3575515
          },
          "2": {
            "get_star_ts": 1671647736,
            "star_index": 3576017
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671649536,
            "star_index": 3577472
          },
          "2": {
            "star_index": 3583508,
            "get_star_ts": 1671656768
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1671657932,
            "star_index": 3584474
          },
          "2": {
            "star_index": 3585843,
            "get_star_ts": 1671659502
          }
        },
        "11": {
          "1": {
            "star_index": 3621136,
            "get_star_ts": 1671719112
          },
          "2": {
            "star_index": 3621601,
            "get_star_ts": 1671719740
          }
        },
        "12": {
          "1": {
            "star_index": 3649109,
            "get_star_ts": 1671760397
          },
          "2": {
            "get_star_ts": 1671761486,
            "star_index": 3649429
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671802769,
            "star_index": 3677256
          },
          "2": {
            "get_star_ts": 1671806052,
            "star_index": 3679868
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671810595,
            "star_index": 3683561
          }
        }
      }
    },
    "456457": {
      "local_score": 2850,
      "last_star_ts": 1671163729,
      "stars": 24,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669906876,
            "star_index": 140416
          },
          "2": {
            "get_star_ts": 1669907139,
            "star_index": 141391
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669990356,
            "star_index": 439282
          },
          "2": {
            "star_index": 442201,
            "get_star_ts": 1669991030
          }
        },
        "3": {
          "1": {
            "star_index": 724743,
            "get_star_ts": 1670078623
          },
          "2": {
            "star_index": 726636,
            "get_star_ts": 1670079149
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670168426,
            "star_index": 1022165
          },
          "2": {
            "get_star_ts": 1670168486,
            "star_index": 1022393
          }
        },
        "5": {
          "1": {
            "star_index": 1349151,
            "get_star_ts": 1670266389
          },
          "2": {
            "get_star_ts": 1670267202,
            "star_index": 1352228
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670338076,
            "star_index": 1614506
          },
          "2": {
            "get_star_ts": 1670341193,
            "star_index": 1626178
          }
        },
        "7": {
          "1": {
            "star_index": 2113351,
            "get_star_ts": 1670526983
          },
          "2": {
            "star_index": 2138321,
            "get_star_ts": 1670536359
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670719199,
            "star_index": 2514768
          },
          "2": {
            "get_star_ts": 1670725030,
            "star_index": 2520151
          }
        },
        "9": {
          "1": {
            "star_index": 2524828,
            "get_star_ts": 1670731348
          },
          "2": {
            "get_star_ts": 1670733979,
            "star_index": 2526623
          }
        },
        "10": {
          "1": {
            "star_index": 2528562,
            "get_star_ts": 1670736028
          },
          "2": {
            "get_star_ts": 1670776003,
            "star_index": 2619068
          }
        },
        "11": {
          "1": {
            "star_index": 2639402,
            "get_star_ts": 1670785004
          },
          "2": {
            "star_index": 2961901,
            "get_star_ts": 1670989192
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1671158030,
            "star_index": 3179853
          },
          "2": {
            "get_star_ts": 1671163729,
            "star_index": 3182697
          }
        }
      },
      "global_score": 0,
      "name": "Matt Collins",
      "id": 456457
    },
    "484824": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1670019386,
            "star_index": 542492
          },
          "2": {
            "get_star_ts": 1670019772,
            "star_index": 543523
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670105318,
            "star_index": 810018
          },
          "2": {
            "get_star_ts": 1670184214,
            "star_index": 1076278
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670186312,
            "star_index": 1083292
          },
          "2": {
            "get_star_ts": 1670188103,
            "star_index": 1089186
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670366200,
            "star_index": 1705687
          },
          "2": {
            "get_star_ts": 1670366627,
            "star_index": 1706748
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670787272,
            "star_index": 2644512
          },
          "2": {
            "star_index": 2645733,
            "get_star_ts": 1670787819
          }
        },
        "6": {
          "1": {
            "star_index": 2650296,
            "get_star_ts": 1670789783
          },
          "2": {
            "star_index": 2650843,
            "get_star_ts": 1670790015
          }
        },
        "7": {
          "1": {
            "star_index": 3992365,
            "get_star_ts": 1673019152
          },
          "2": {
            "get_star_ts": 1673035267,
            "star_index": 3994731
          }
        },
        "8": {
          "1": {
            "star_index": 3157110,
            "get_star_ts": 1671135086
          },
          "2": {
            "get_star_ts": 1671141170,
            "star_index": 3165866
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671550671,
            "star_index": 3494831
          },
          "2": {
            "star_index": 3511965,
            "get_star_ts": 1671569939
          }
        },
        "10": {
          "1": {
            "star_index": 3567860,
            "get_star_ts": 1671638125
          },
          "2": {
            "star_index": 3580727,
            "get_star_ts": 1671653455
          }
        },
        "12": {
          "1": {
            "star_index": 4039021,
            "get_star_ts": 1673540537
          },
          "2": {
            "get_star_ts": 1673625362,
            "star_index": 4045052
          }
        }
      },
      "last_star_ts": 1673625362,
      "stars": 22,
      "local_score": 1869,
      "id": 484824,
      "name": "Donny Cheng"
    },
    "496775": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669905308,
            "star_index": 134342
          },
          "2": {
            "star_index": 137095,
            "get_star_ts": 1669906026
          }
        },
        "2": {
          "1": {
            "star_index": 453107,
            "get_star_ts": 1669993427
          },
          "2": {
            "get_star_ts": 1669994596,
            "star_index": 458256
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1671051651,
            "star_index": 3057675
          }
        }
      },
      "stars": 5,
      "last_star_ts": 1671051651,
      "local_score": 487,
      "id": 496775,
      "name": "Andrew B. McIntosh"
    },
    "502805": {
      "name": "Brenton Bazemore",
      "id": 502805,
      "stars": 50,
      "last_star_ts": 1671981316,
      "local_score": 7780,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1724,
            "get_star_ts": 1669871038
          },
          "2": {
            "get_star_ts": 1669871154,
            "star_index": 4110
          }
        },
        "2": {
          "1": {
            "star_index": 281968,
            "get_star_ts": 1669958553
          },
          "2": {
            "get_star_ts": 1669958880,
            "star_index": 285877
          }
        },
        "3": {
          "1": {
            "star_index": 579829,
            "get_star_ts": 1670044177
          },
          "2": {
            "get_star_ts": 1670044555,
            "star_index": 584855
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670130317,
            "star_index": 847938
          },
          "2": {
            "get_star_ts": 1670130605,
            "star_index": 853328
          }
        },
        "5": {
          "1": {
            "star_index": 1141529,
            "get_star_ts": 1670217546
          },
          "2": {
            "star_index": 1144549,
            "get_star_ts": 1670217880
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670303129,
            "star_index": 1440832
          },
          "2": {
            "star_index": 1446533,
            "get_star_ts": 1670303343
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670392025,
            "star_index": 1746057
          },
          "2": {
            "get_star_ts": 1670392589,
            "star_index": 1748709
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670477231,
            "star_index": 1963218
          },
          "2": {
            "star_index": 1965358,
            "get_star_ts": 1670477545
          }
        },
        "9": {
          "1": {
            "star_index": 2178477,
            "get_star_ts": 1670563916
          },
          "2": {
            "get_star_ts": 1670564792,
            "star_index": 2182889
          }
        },
        "10": {
          "1": {
            "star_index": 2354425,
            "get_star_ts": 1670649469
          },
          "2": {
            "get_star_ts": 1670650033,
            "star_index": 2358453
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670736821,
            "star_index": 2531346
          },
          "2": {
            "star_index": 2545863,
            "get_star_ts": 1670741654
          }
        },
        "12": {
          "1": {
            "star_index": 2725595,
            "get_star_ts": 1670837081
          },
          "2": {
            "get_star_ts": 1670837426,
            "star_index": 2726280
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670910183,
            "star_index": 2844570
          },
          "2": {
            "get_star_ts": 1670910664,
            "star_index": 2845952
          }
        },
        "14": {
          "1": {
            "star_index": 2972598,
            "get_star_ts": 1670996914
          },
          "2": {
            "star_index": 2974576,
            "get_star_ts": 1670997567
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671083292,
            "star_index": 3087623
          },
          "2": {
            "star_index": 3094720,
            "get_star_ts": 1671087063
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1671179908,
            "star_index": 3193969
          },
          "2": {
            "star_index": 3246343,
            "get_star_ts": 1671234016
          }
        },
        "17": {
          "1": {
            "star_index": 3302857,
            "get_star_ts": 1671307705
          },
          "2": {
            "get_star_ts": 1671316363,
            "star_index": 3311300
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671341429,
            "star_index": 3328480
          },
          "2": {
            "star_index": 3334861,
            "get_star_ts": 1671347228
          }
        },
        "19": {
          "1": {
            "star_index": 3464149,
            "get_star_ts": 1671515162
          },
          "2": {
            "get_star_ts": 1671550077,
            "star_index": 3494322
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1671596279,
            "star_index": 3526518
          },
          "2": {
            "get_star_ts": 1671597739,
            "star_index": 3526990
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1671600050,
            "star_index": 3530073
          },
          "2": {
            "get_star_ts": 1671610773,
            "star_index": 3542566
          }
        },
        "22": {
          "1": {
            "star_index": 3602200,
            "get_star_ts": 1671691306
          },
          "2": {
            "star_index": 3610663,
            "get_star_ts": 1671703879
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1671777862,
            "star_index": 3659325
          },
          "2": {
            "get_star_ts": 1671778114,
            "star_index": 3659533
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1671865065,
            "star_index": 3715484
          },
          "2": {
            "get_star_ts": 1671868679,
            "star_index": 3717623
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1671981310,
            "star_index": 3778695
          },
          "2": {
            "get_star_ts": 1671981316,
            "star_index": 3778700
          }
        }
      }
    },
    "506833": {
      "name": "Carl Newton",
      "id": 506833,
      "last_star_ts": 1671970855,
      "stars": 50,
      "local_score": 6928,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669902772,
            "star_index": 125019
          },
          "2": {
            "star_index": 125188,
            "get_star_ts": 1669902825
          }
        },
        "2": {
          "1": {
            "star_index": 417877,
            "get_star_ts": 1669985100
          },
          "2": {
            "star_index": 438068,
            "get_star_ts": 1669990069
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670067737,
            "star_index": 684118
          },
          "2": {
            "get_star_ts": 1670174604,
            "star_index": 1044027
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670177536,
            "star_index": 1054307
          },
          "2": {
            "get_star_ts": 1670178249,
            "star_index": 1056710
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670290332,
            "star_index": 1420678
          },
          "2": {
            "get_star_ts": 1670291703,
            "star_index": 1422570
          }
        },
        "6": {
          "1": {
            "star_index": 1574018,
            "get_star_ts": 1670327133
          },
          "2": {
            "star_index": 1575870,
            "get_star_ts": 1670327682
          }
        },
        "7": {
          "1": {
            "star_index": 1880351,
            "get_star_ts": 1670437807
          },
          "2": {
            "star_index": 1880398,
            "get_star_ts": 1670437823
          }
        },
        "8": {
          "1": {
            "star_index": 2161312,
            "get_star_ts": 1670550934
          },
          "2": {
            "star_index": 2226829,
            "get_star_ts": 1670580862
          }
        },
        "9": {
          "1": {
            "star_index": 2259666,
            "get_star_ts": 1670594574
          },
          "2": {
            "star_index": 2305381,
            "get_star_ts": 1670614713
          }
        },
        "10": {
          "1": {
            "star_index": 2582340,
            "get_star_ts": 1670759984
          },
          "2": {
            "get_star_ts": 1670763963,
            "star_index": 2591246
          }
        },
        "11": {
          "1": {
            "star_index": 2626367,
            "get_star_ts": 1670779135
          },
          "2": {
            "get_star_ts": 1670785515,
            "star_index": 2640565
          }
        },
        "12": {
          "1": {
            "star_index": 2825118,
            "get_star_ts": 1670891117
          },
          "2": {
            "get_star_ts": 1670893204,
            "star_index": 2826974
          }
        },
        "13": {
          "1": {
            "star_index": 2880935,
            "get_star_ts": 1670930533
          },
          "2": {
            "star_index": 2891837,
            "get_star_ts": 1670937792
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671066746,
            "star_index": 3074668
          },
          "2": {
            "get_star_ts": 1671068310,
            "star_index": 3075697
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671109927,
            "star_index": 3123919
          },
          "2": {
            "star_index": 3180502,
            "get_star_ts": 1671159288
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1671211971,
            "star_index": 3224421
          },
          "2": {
            "get_star_ts": 1671364156,
            "star_index": 3351705
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1671391472,
            "star_index": 3377843
          },
          "2": {
            "get_star_ts": 1671881019,
            "star_index": 3724623
          }
        },
        "18": {
          "1": {
            "star_index": 3416855,
            "get_star_ts": 1671451076
          },
          "2": {
            "get_star_ts": 1671458780,
            "star_index": 3422756
          }
        },
        "19": {
          "1": {
            "star_index": 3486608,
            "get_star_ts": 1671541331
          },
          "2": {
            "star_index": 3768322,
            "get_star_ts": 1671963063
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1671617829,
            "star_index": 3549554
          },
          "2": {
            "star_index": 3555459,
            "get_star_ts": 1671624458
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1671643650,
            "star_index": 3572772
          },
          "2": {
            "star_index": 3586079,
            "get_star_ts": 1671659786
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1671708564,
            "star_index": 3613894
          },
          "2": {
            "star_index": 3700446,
            "get_star_ts": 1671833678
          }
        },
        "23": {
          "1": {
            "star_index": 3681727,
            "get_star_ts": 1671808381
          },
          "2": {
            "get_star_ts": 1671809077,
            "star_index": 3682278
          }
        },
        "24": {
          "1": {
            "star_index": 3724845,
            "get_star_ts": 1671881415
          },
          "2": {
            "star_index": 3734798,
            "get_star_ts": 1671898811
          }
        },
        "25": {
          "1": {
            "star_index": 3773078,
            "get_star_ts": 1671970835
          },
          "2": {
            "star_index": 3773100,
            "get_star_ts": 1671970855
          }
        }
      }
    },
    "542205": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1670955298,
            "star_index": 2920724
          },
          "2": {
            "get_star_ts": 1670955395,
            "star_index": 2920864
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670957281,
            "star_index": 2923971
          },
          "2": {
            "get_star_ts": 1671027272,
            "star_index": 3021481
          }
        }
      },
      "last_star_ts": 1671027272,
      "stars": 4,
      "local_score": 154,
      "id": 542205,
      "name": "Jeffrey Box"
    },
    "619828": {
      "last_star_ts": 1673123616,
      "local_score": 3891,
      "stars": 33,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 176585,
            "get_star_ts": 1669916841
          },
          "2": {
            "star_index": 210037,
            "get_star_ts": 1669926788
          }
        },
        "2": {
          "1": {
            "star_index": 491615,
            "get_star_ts": 1670002859
          },
          "2": {
            "get_star_ts": 1670003688,
            "star_index": 494495
          }
        },
        "3": {
          "1": {
            "star_index": 726926,
            "get_star_ts": 1670079239
          },
          "2": {
            "get_star_ts": 1670084870,
            "star_index": 746586
          }
        },
        "4": {
          "1": {
            "star_index": 1000183,
            "get_star_ts": 1670162748
          },
          "2": {
            "get_star_ts": 1670163789,
            "star_index": 1004305
          }
        },
        "5": {
          "1": {
            "star_index": 1341377,
            "get_star_ts": 1670264302
          },
          "2": {
            "star_index": 1343563,
            "get_star_ts": 1670264887
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670348432,
            "star_index": 1650478
          },
          "2": {
            "star_index": 1651277,
            "get_star_ts": 1670348682
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670556684,
            "star_index": 2166746
          },
          "2": {
            "get_star_ts": 1670609834,
            "star_index": 2295587
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670640305,
            "star_index": 2344089
          },
          "2": {
            "star_index": 2346441,
            "get_star_ts": 1670643536
          }
        },
        "9": {
          "1": {
            "star_index": 2451371,
            "get_star_ts": 1670686493
          },
          "2": {
            "get_star_ts": 1670791457,
            "star_index": 2654237
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670817899,
            "star_index": 2689457
          },
          "2": {
            "get_star_ts": 1670820145,
            "star_index": 2691095
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670898803,
            "star_index": 2831428
          },
          "2": {
            "star_index": 2834878,
            "get_star_ts": 1670903382
          }
        },
        "12": {
          "1": {
            "star_index": 3916212,
            "get_star_ts": 1672460472
          },
          "2": {
            "star_index": 3916519,
            "get_star_ts": 1672463401
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1672525299,
            "star_index": 3925838
          },
          "2": {
            "get_star_ts": 1672528268,
            "star_index": 3926258
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671634217,
            "star_index": 3564127
          },
          "2": {
            "get_star_ts": 1672589287,
            "star_index": 3932424
          }
        },
        "15": {
          "1": {
            "star_index": 3965882,
            "get_star_ts": 1672801215
          },
          "2": {
            "get_star_ts": 1672804364,
            "star_index": 3966200
          }
        },
        "18": {
          "1": {
            "star_index": 3973525,
            "get_star_ts": 1672858053
          },
          "2": {
            "get_star_ts": 1673123616,
            "star_index": 4003472
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1673117079,
            "star_index": 4002636
          }
        }
      },
      "name": "Raz-SB",
      "id": 619828
    },
    "621633": {
      "id": 621633,
      "name": "Carrie Flaspohler",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 195874,
            "get_star_ts": 1669922560
          },
          "2": {
            "star_index": 196020,
            "get_star_ts": 1669922597
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669993133,
            "star_index": 451800
          },
          "2": {
            "star_index": 503881,
            "get_star_ts": 1670006527
          }
        }
      },
      "global_score": 0,
      "local_score": 335,
      "last_star_ts": 1670006527,
      "stars": 4
    },
    "621663": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 142002,
            "get_star_ts": 1669907299
          },
          "2": {
            "star_index": 150253,
            "get_star_ts": 1669909479
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669998701,
            "star_index": 475801
          },
          "2": {
            "star_index": 478335,
            "get_star_ts": 1669999323
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670277406,
            "star_index": 1391262
          },
          "2": {
            "star_index": 2162118,
            "get_star_ts": 1670551812
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670553082,
            "star_index": 2163327
          },
          "2": {
            "get_star_ts": 1670553618,
            "star_index": 2163828
          }
        },
        "5": {
          "1": {
            "star_index": 2893759,
            "get_star_ts": 1670939008
          },
          "2": {
            "get_star_ts": 1670939839,
            "star_index": 2895129
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670980426,
            "star_index": 2956313
          },
          "2": {
            "get_star_ts": 1670980554,
            "star_index": 2956408
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1670980554,
      "stars": 12,
      "local_score": 948,
      "id": 621663,
      "name": "Rachel Lieberman"
    },
    "621765": {
      "name": "brandon-myers-009",
      "id": 621765,
      "last_star_ts": 1673409631,
      "local_score": 500,
      "stars": 10,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 3076876,
            "get_star_ts": 1671070358
          },
          "2": {
            "get_star_ts": 1671070493,
            "star_index": 3076950
          }
        },
        "2": {
          "1": {
            "star_index": 3079914,
            "get_star_ts": 1671075579
          },
          "2": {
            "get_star_ts": 1671077719,
            "star_index": 3081205
          }
        },
        "3": {
          "1": {
            "star_index": 4014172,
            "get_star_ts": 1673235677
          },
          "2": {
            "get_star_ts": 1673240658,
            "star_index": 4014487
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1673244328,
            "star_index": 4014708
          },
          "2": {
            "get_star_ts": 1673290983,
            "star_index": 4019107
          }
        },
        "5": {
          "1": {
            "star_index": 4029153,
            "get_star_ts": 1673406561
          },
          "2": {
            "star_index": 4029309,
            "get_star_ts": 1673409631
          }
        }
      }
    },
    "622289": {
      "stars": 14,
      "last_star_ts": 1670948791,
      "local_score": 1522,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669934519,
            "star_index": 233978
          },
          "2": {
            "get_star_ts": 1669934740,
            "star_index": 234584
          }
        },
        "2": {
          "1": {
            "star_index": 547676,
            "get_star_ts": 1670021443
          },
          "2": {
            "get_star_ts": 1670024631,
            "star_index": 554472
          }
        },
        "3": {
          "1": {
            "star_index": 711492,
            "get_star_ts": 1670075002
          },
          "2": {
            "star_index": 722920,
            "get_star_ts": 1670078131
          }
        },
        "4": {
          "1": {
            "star_index": 1021236,
            "get_star_ts": 1670168169
          },
          "2": {
            "star_index": 1022582,
            "get_star_ts": 1670168534
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670355399,
            "star_index": 1672267
          },
          "2": {
            "star_index": 1672811,
            "get_star_ts": 1670355562
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670684248,
            "star_index": 2446106
          }
        },
        "11": {
          "1": {
            "star_index": 2794016,
            "get_star_ts": 1670873631
          }
        },
        "13": {
          "1": {
            "star_index": 2907390,
            "get_star_ts": 1670947147
          },
          "2": {
            "get_star_ts": 1670948791,
            "star_index": 2910123
          }
        }
      },
      "name": "KenStillings",
      "id": 622289
    },
    "623312": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 161900,
            "get_star_ts": 1669912679
          },
          "2": {
            "get_star_ts": 1669912705,
            "star_index": 161979
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669977491,
            "star_index": 386433
          },
          "2": {
            "star_index": 389746,
            "get_star_ts": 1669978188
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670093140,
            "star_index": 774290
          },
          "2": {
            "star_index": 786328,
            "get_star_ts": 1670097105
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670165219,
            "star_index": 1009990
          },
          "2": {
            "get_star_ts": 1670165329,
            "star_index": 1010467
          }
        },
        "5": {
          "1": {
            "star_index": 1142330,
            "get_star_ts": 1670217637
          },
          "2": {
            "get_star_ts": 1670217913,
            "star_index": 1144848
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670379084,
            "star_index": 1725682
          },
          "2": {
            "star_index": 1726006,
            "get_star_ts": 1670379377
          }
        }
      },
      "stars": 12,
      "last_star_ts": 1670379377,
      "local_score": 1405,
      "id": 623312,
      "name": "dickiesanders"
    },
    "627414": {
      "local_score": 7086,
      "last_star_ts": 1672892161,
      "stars": 50,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 11754,
            "get_star_ts": 1669871718
          },
          "2": {
            "star_index": 15221,
            "get_star_ts": 1669872180
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669958162,
            "star_index": 276232
          },
          "2": {
            "get_star_ts": 1669959145,
            "star_index": 288473
          }
        },
        "3": {
          "1": {
            "star_index": 601721,
            "get_star_ts": 1670046459
          },
          "2": {
            "star_index": 607940,
            "get_star_ts": 1670047765
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670132372,
            "star_index": 872276
          },
          "2": {
            "star_index": 872891,
            "get_star_ts": 1670132472
          }
        },
        "5": {
          "1": {
            "star_index": 1164407,
            "get_star_ts": 1670220731
          },
          "2": {
            "get_star_ts": 1670221009,
            "star_index": 1165829
          }
        },
        "6": {
          "1": {
            "star_index": 1453717,
            "get_star_ts": 1670303669
          },
          "2": {
            "get_star_ts": 1670303992,
            "star_index": 1458671
          }
        },
        "7": {
          "1": {
            "star_index": 1777927,
            "get_star_ts": 1670401610
          },
          "2": {
            "get_star_ts": 1670402830,
            "star_index": 1781498
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670526537,
            "star_index": 2112244
          },
          "2": {
            "star_index": 2129823,
            "get_star_ts": 1670533195
          }
        },
        "9": {
          "1": {
            "star_index": 2199776,
            "get_star_ts": 1670570270
          },
          "2": {
            "get_star_ts": 1670572539,
            "star_index": 2205326
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670697931,
            "star_index": 2476568
          },
          "2": {
            "star_index": 2507234,
            "get_star_ts": 1670713690
          }
        },
        "11": {
          "1": {
            "star_index": 2772872,
            "get_star_ts": 1670862453
          },
          "2": {
            "star_index": 2782814,
            "get_star_ts": 1670867723
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1671345066,
            "star_index": 3332996
          },
          "2": {
            "star_index": 3337478,
            "get_star_ts": 1671350349
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671584414,
            "star_index": 3522354
          },
          "2": {
            "get_star_ts": 1671590654,
            "star_index": 3524588
          }
        },
        "14": {
          "1": {
            "star_index": 3752395,
            "get_star_ts": 1671939507
          },
          "2": {
            "get_star_ts": 1671952371,
            "star_index": 3761914
          }
        },
        "15": {
          "1": {
            "star_index": 3796587,
            "get_star_ts": 1672014206
          },
          "2": {
            "star_index": 3801280,
            "get_star_ts": 1672033725
          }
        },
        "16": {
          "1": {
            "star_index": 3816611,
            "get_star_ts": 1672080111
          },
          "2": {
            "star_index": 3822664,
            "get_star_ts": 1672093228
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1672340566,
            "star_index": 3890430
          },
          "2": {
            "get_star_ts": 1672345561,
            "star_index": 3892013
          }
        },
        "18": {
          "1": {
            "star_index": 3898546,
            "get_star_ts": 1672376793
          },
          "2": {
            "get_star_ts": 1672431365,
            "star_index": 3910408
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1672468112,
            "star_index": 3916957
          },
          "2": {
            "star_index": 3917049,
            "get_star_ts": 1672469131
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1672509423,
            "star_index": 3923383
          },
          "2": {
            "star_index": 3923520,
            "get_star_ts": 1672510157
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1672514618,
            "star_index": 3924231
          },
          "2": {
            "star_index": 3928318,
            "get_star_ts": 1672551416
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1672633891,
            "star_index": 3939770
          },
          "2": {
            "get_star_ts": 1672693783,
            "star_index": 3949456
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1672812541,
            "star_index": 3966844
          },
          "2": {
            "get_star_ts": 1672812630,
            "star_index": 3966852
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1672853501,
            "star_index": 3972811
          },
          "2": {
            "star_index": 3976556,
            "get_star_ts": 1672875610
          }
        },
        "25": {
          "1": {
            "star_index": 3978025,
            "get_star_ts": 1672892138
          },
          "2": {
            "get_star_ts": 1672892161,
            "star_index": 3978029
          }
        }
      },
      "name": "Joshua Gohlke",
      "id": 627414
    },
    "712873": {
      "last_star_ts": 1670990494,
      "stars": 5,
      "local_score": 245,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 234650,
            "get_star_ts": 1669934766
          },
          "2": {
            "get_star_ts": 1670899687,
            "star_index": 2832106
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670901225,
            "star_index": 2833275
          },
          "2": {
            "star_index": 2833944,
            "get_star_ts": 1670902170
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670990494,
            "star_index": 2962785
          }
        }
      },
      "global_score": 0,
      "name": "dr-sly",
      "id": 712873
    },
    "793969": {
      "id": 793969,
      "name": "Clay Y",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 513791,
            "get_star_ts": 1670009724
          },
          "2": {
            "get_star_ts": 1670010203,
            "star_index": 515271
          }
        },
        "2": {
          "1": {
            "star_index": 781913,
            "get_star_ts": 1670095612
          },
          "2": {
            "star_index": 784542,
            "get_star_ts": 1670096507
          }
        },
        "3": {
          "1": {
            "star_index": 793512,
            "get_star_ts": 1670099525
          },
          "2": {
            "star_index": 795992,
            "get_star_ts": 1670100373
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670185107,
            "star_index": 1079307
          },
          "2": {
            "get_star_ts": 1670186103,
            "star_index": 1082619
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670250458,
            "star_index": 1286880
          },
          "2": {
            "get_star_ts": 1670273009,
            "star_index": 1374672
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670323878,
            "star_index": 1562335
          },
          "2": {
            "star_index": 1563777,
            "get_star_ts": 1670324259
          }
        },
        "7": {
          "1": {
            "star_index": 1836433,
            "get_star_ts": 1670422447
          },
          "2": {
            "star_index": 1850544,
            "get_star_ts": 1670427245
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670519369,
            "star_index": 2094038
          },
          "2": {
            "get_star_ts": 1670524017,
            "star_index": 2105819
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670591254,
            "star_index": 2251407
          }
        }
      },
      "global_score": 0,
      "stars": 17,
      "last_star_ts": 1670591254,
      "local_score": 1843
    },
    "802113": {
      "id": 802113,
      "name": "penultimateman",
      "global_score": 0,
      "completion_day_level": {},
      "last_star_ts": 0,
      "stars": 0,
      "local_score": 0
    },
    "810441": {
      "global_score": 0,
      "completion_day_level": {},
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "id": 810441,
      "name": "Charli X"
    },
    "856597": {
      "name": "Zach Guthrie",
      "id": 856597,
      "stars": 22,
      "last_star_ts": 1671073748,
      "local_score": 2091,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1692879,
            "get_star_ts": 1670361803
          },
          "2": {
            "star_index": 1694226,
            "get_star_ts": 1670362234
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670363398,
            "star_index": 1697850
          },
          "2": {
            "star_index": 1699222,
            "get_star_ts": 1670363846
          }
        },
        "3": {
          "1": {
            "star_index": 1708810,
            "get_star_ts": 1670367506
          },
          "2": {
            "star_index": 1711017,
            "get_star_ts": 1670368582
          }
        },
        "4": {
          "1": {
            "star_index": 1715871,
            "get_star_ts": 1670371421
          },
          "2": {
            "star_index": 1716927,
            "get_star_ts": 1670372140
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670377773,
            "star_index": 1724118
          },
          "2": {
            "get_star_ts": 1670381503,
            "star_index": 1728410
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670382247,
            "star_index": 1729329
          },
          "2": {
            "get_star_ts": 1670382408,
            "star_index": 1729503
          }
        },
        "7": {
          "1": {
            "star_index": 1904301,
            "get_star_ts": 1670446209
          },
          "2": {
            "get_star_ts": 1670447026,
            "star_index": 1906959
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670481231,
            "star_index": 1983031
          },
          "2": {
            "star_index": 1991132,
            "get_star_ts": 1670483745
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671055046,
            "star_index": 3062880
          },
          "2": {
            "star_index": 3071556,
            "get_star_ts": 1671062339
          }
        },
        "10": {
          "1": {
            "star_index": 3073737,
            "get_star_ts": 1671065235
          },
          "2": {
            "star_index": 3074813,
            "get_star_ts": 1671066936
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1671071217,
            "star_index": 3077364
          },
          "2": {
            "get_star_ts": 1671073748,
            "star_index": 3078844
          }
        }
      }
    },
    "876817": {
      "name": "Jessica Jestings",
      "id": 876817,
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "completion_day_level": {},
      "global_score": 0
    },
    "953447": {
      "name": "Austin Leal",
      "id": 953447,
      "local_score": 5500,
      "last_star_ts": 1671946723,
      "stars": 36,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669871972,
            "star_index": 13806
          },
          "2": {
            "star_index": 14721,
            "get_star_ts": 1669872103
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669970663,
            "star_index": 348656
          },
          "2": {
            "star_index": 355208,
            "get_star_ts": 1669971760
          }
        },
        "3": {
          "1": {
            "star_index": 583773,
            "get_star_ts": 1670044476
          },
          "2": {
            "star_index": 605317,
            "get_star_ts": 1670047158
          }
        },
        "4": {
          "1": {
            "star_index": 855053,
            "get_star_ts": 1670130701
          },
          "2": {
            "star_index": 857617,
            "get_star_ts": 1670130859
          }
        },
        "5": {
          "1": {
            "star_index": 1149018,
            "get_star_ts": 1670218375
          },
          "2": {
            "star_index": 1157505,
            "get_star_ts": 1670219505
          }
        },
        "6": {
          "1": {
            "star_index": 1451241,
            "get_star_ts": 1670303547
          },
          "2": {
            "star_index": 1451944,
            "get_star_ts": 1670303579
          }
        },
        "7": {
          "1": {
            "star_index": 1751302,
            "get_star_ts": 1670393172
          },
          "2": {
            "star_index": 1753127,
            "get_star_ts": 1670393612
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670476705,
            "star_index": 1959601
          },
          "2": {
            "star_index": 1968512,
            "get_star_ts": 1670478034
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670564935,
            "star_index": 2183481
          },
          "2": {
            "get_star_ts": 1670565405,
            "star_index": 2185484
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670653711,
            "star_index": 2373163
          },
          "2": {
            "get_star_ts": 1670654538,
            "star_index": 2375074
          }
        },
        "11": {
          "1": {
            "star_index": 2533259,
            "get_star_ts": 1670737269
          },
          "2": {
            "star_index": 2541375,
            "get_star_ts": 1670739714
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670824407,
            "star_index": 2700949
          },
          "2": {
            "get_star_ts": 1670824634,
            "star_index": 2701568
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670911268,
            "star_index": 2847607
          },
          "2": {
            "star_index": 2849720,
            "get_star_ts": 1670912144
          }
        },
        "14": {
          "1": {
            "star_index": 2971507,
            "get_star_ts": 1670996571
          },
          "2": {
            "get_star_ts": 1670998010,
            "star_index": 2975710
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671083442,
            "star_index": 3088061
          },
          "2": {
            "star_index": 3096007,
            "get_star_ts": 1671087934
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1671178876,
            "star_index": 3193153
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671374446,
            "star_index": 3362255
          }
        },
        "21": {
          "1": {
            "star_index": 3533886,
            "get_star_ts": 1671602113
          },
          "2": {
            "star_index": 3538643,
            "get_star_ts": 1671606586
          }
        },
        "22": {
          "1": {
            "star_index": 3634710,
            "get_star_ts": 1671737272
          }
        },
        "25": {
          "1": {
            "star_index": 3757083,
            "get_star_ts": 1671946723
          }
        }
      }
    },
    "953450": {
      "id": 953450,
      "name": "Edd Purcell",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669872389,
            "star_index": 16437
          },
          "2": {
            "get_star_ts": 1669873056,
            "star_index": 19624
          }
        },
        "2": {
          "1": {
            "star_index": 437771,
            "get_star_ts": 1669989999
          },
          "2": {
            "get_star_ts": 1669990766,
            "star_index": 441044
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670047827,
            "star_index": 608189
          },
          "2": {
            "get_star_ts": 1670051134,
            "star_index": 619727
          }
        },
        "4": {
          "1": {
            "star_index": 981146,
            "get_star_ts": 1670158119
          },
          "2": {
            "star_index": 981985,
            "get_star_ts": 1670158316
          }
        },
        "5": {
          "1": {
            "star_index": 1257297,
            "get_star_ts": 1670242770
          },
          "2": {
            "get_star_ts": 1670243211,
            "star_index": 1258921
          }
        },
        "6": {
          "1": {
            "star_index": 1580743,
            "get_star_ts": 1670329143
          },
          "2": {
            "get_star_ts": 1670329311,
            "star_index": 1581329
          }
        },
        "7": {
          "1": {
            "star_index": 1881865,
            "get_star_ts": 1670438376
          },
          "2": {
            "get_star_ts": 1670439548,
            "star_index": 1885160
          }
        },
        "8": {
          "1": {
            "star_index": 2060043,
            "get_star_ts": 1670507415
          },
          "2": {
            "star_index": 2073889,
            "get_star_ts": 1670512269
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670620721,
            "star_index": 2317657
          },
          "2": {
            "star_index": 2591207,
            "get_star_ts": 1670763946
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670766260,
            "star_index": 2596483
          },
          "2": {
            "get_star_ts": 1670767953,
            "star_index": 2600322
          }
        },
        "11": {
          "1": {
            "star_index": 2632995,
            "get_star_ts": 1670782100
          },
          "2": {
            "star_index": 2760914,
            "get_star_ts": 1670856395
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1671210106,
            "star_index": 3222580
          },
          "2": {
            "get_star_ts": 1671211570,
            "star_index": 3224053
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671334388,
            "star_index": 3321900
          },
          "2": {
            "get_star_ts": 1671335875,
            "star_index": 3322421
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671377079,
            "star_index": 3364872
          },
          "2": {
            "star_index": 3368651,
            "get_star_ts": 1671380967
          }
        },
        "15": {
          "1": {
            "star_index": 3397043,
            "get_star_ts": 1671416714
          },
          "2": {
            "star_index": 3434414,
            "get_star_ts": 1671471978
          }
        }
      },
      "local_score": 4024,
      "last_star_ts": 1671471978,
      "stars": 30
    },
    "953508": {
      "name": "Kendra B",
      "id": 953508,
      "local_score": 4412,
      "last_star_ts": 1671376796,
      "stars": 34,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 140486,
            "get_star_ts": 1669906894
          },
          "2": {
            "star_index": 142439,
            "get_star_ts": 1669907421
          }
        },
        "2": {
          "1": {
            "star_index": 457826,
            "get_star_ts": 1669994500
          },
          "2": {
            "get_star_ts": 1669995097,
            "star_index": 460499
          }
        },
        "3": {
          "1": {
            "star_index": 593763,
            "get_star_ts": 1670045364
          },
          "2": {
            "get_star_ts": 1670045981,
            "star_index": 598667
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670196918,
            "star_index": 1112189
          },
          "2": {
            "get_star_ts": 1670197080,
            "star_index": 1112494
          }
        },
        "5": {
          "1": {
            "star_index": 1389354,
            "get_star_ts": 1670276887
          },
          "2": {
            "get_star_ts": 1670277169,
            "star_index": 1390379
          }
        },
        "6": {
          "1": {
            "star_index": 1616797,
            "get_star_ts": 1670338651
          },
          "2": {
            "star_index": 1617025,
            "get_star_ts": 1670338714
          }
        },
        "7": {
          "1": {
            "star_index": 1948356,
            "get_star_ts": 1670469113
          },
          "2": {
            "get_star_ts": 1670471030,
            "star_index": 1950485
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670516799,
            "star_index": 2086975
          },
          "2": {
            "get_star_ts": 1670557494,
            "star_index": 2167481
          }
        },
        "9": {
          "1": {
            "star_index": 2297209,
            "get_star_ts": 1670610608
          },
          "2": {
            "get_star_ts": 1670611582,
            "star_index": 2299181
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670727627,
            "star_index": 2522125
          },
          "2": {
            "get_star_ts": 1670731668,
            "star_index": 2525040
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670779893,
            "star_index": 2628127
          },
          "2": {
            "star_index": 2631405,
            "get_star_ts": 1670781385
          }
        },
        "12": {
          "1": {
            "star_index": 2759788,
            "get_star_ts": 1670855818
          },
          "2": {
            "get_star_ts": 1670856063,
            "star_index": 2760251
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670991949,
            "star_index": 2963643
          },
          "2": {
            "star_index": 2964183,
            "get_star_ts": 1670992803
          }
        },
        "14": {
          "1": {
            "star_index": 3080394,
            "get_star_ts": 1671076391
          },
          "2": {
            "get_star_ts": 1671077017,
            "star_index": 3080795
          }
        },
        "15": {
          "1": {
            "star_index": 3138914,
            "get_star_ts": 1671120993
          },
          "2": {
            "star_index": 3181332,
            "get_star_ts": 1671160903
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1671250630,
            "star_index": 3254558
          },
          "2": {
            "get_star_ts": 1671374149,
            "star_index": 3361970
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671375269,
            "star_index": 3363139
          },
          "2": {
            "star_index": 3364604,
            "get_star_ts": 1671376796
          }
        }
      }
    },
    "953987": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669948092,
            "star_index": 255532
          },
          "2": {
            "get_star_ts": 1669948756,
            "star_index": 256359
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670000645,
            "star_index": 483534
          },
          "2": {
            "get_star_ts": 1670001194,
            "star_index": 485563
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670239517,
            "star_index": 1245201
          },
          "2": {
            "star_index": 1246507,
            "get_star_ts": 1670239873
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670241713,
            "star_index": 1253442
          },
          "2": {
            "star_index": 1253997,
            "get_star_ts": 1670241865
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670379318,
            "star_index": 1725951
          },
          "2": {
            "star_index": 1726891,
            "get_star_ts": 1670380119
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670380993,
            "star_index": 1727815
          },
          "2": {
            "get_star_ts": 1670381557,
            "star_index": 1728471
          }
        }
      },
      "last_star_ts": 1670381557,
      "local_score": 979,
      "stars": 12,
      "id": 953987,
      "name": "Alex Dykstra"
    },
    "955279": {
      "name": "Neo Zhou",
      "id": 955279,
      "local_score": 114,
      "last_star_ts": 1671293458,
      "stars": 1,
      "completion_day_level": {
        "11": {
          "1": {
            "star_index": 3289314,
            "get_star_ts": 1671293458
          }
        }
      },
      "global_score": 0
    },
    "964573": {
      "id": 964573,
      "name": "Christian Curry",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 7138,
            "get_star_ts": 1669871329
          },
          "2": {
            "star_index": 15539,
            "get_star_ts": 1669872232
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669958091,
            "star_index": 275081
          },
          "2": {
            "get_star_ts": 1669959199,
            "star_index": 289009
          }
        },
        "3": {
          "1": {
            "star_index": 590994,
            "get_star_ts": 1670045080
          },
          "2": {
            "star_index": 595931,
            "get_star_ts": 1670045616
          }
        },
        "4": {
          "1": {
            "star_index": 855104,
            "get_star_ts": 1670130705
          },
          "2": {
            "star_index": 858165,
            "get_star_ts": 1670130895
          }
        },
        "5": {
          "1": {
            "star_index": 1155053,
            "get_star_ts": 1670219153
          },
          "2": {
            "get_star_ts": 1670219490,
            "star_index": 1157413
          }
        },
        "6": {
          "1": {
            "star_index": 1450402,
            "get_star_ts": 1670303509
          },
          "2": {
            "get_star_ts": 1670303623,
            "star_index": 1452848
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670392794,
            "star_index": 1749680
          },
          "2": {
            "star_index": 1753228,
            "get_star_ts": 1670393637
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670515108,
            "star_index": 2082206
          },
          "2": {
            "get_star_ts": 1670516793,
            "star_index": 2086952
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670607537,
            "star_index": 2290990
          },
          "2": {
            "star_index": 2305344,
            "get_star_ts": 1670614691
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670686962,
            "star_index": 2452467
          },
          "2": {
            "get_star_ts": 1670689834,
            "star_index": 2459071
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670777722,
            "star_index": 2623071
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1670777722,
      "local_score": 3111,
      "stars": 21
    },
    "992409": {
      "name": "Dominique Bashizi",
      "id": 992409,
      "stars": 18,
      "last_star_ts": 1671439404,
      "local_score": 2228,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 205179,
            "get_star_ts": 1669925310
          },
          "2": {
            "get_star_ts": 1669925521,
            "star_index": 205856
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669968433,
            "star_index": 336008
          },
          "2": {
            "star_index": 346086,
            "get_star_ts": 1669970231
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670045157,
            "star_index": 591770
          },
          "2": {
            "get_star_ts": 1670047087,
            "star_index": 604994
          }
        },
        "4": {
          "1": {
            "star_index": 871472,
            "get_star_ts": 1670132251
          },
          "2": {
            "get_star_ts": 1670133285,
            "star_index": 877283
          }
        },
        "5": {
          "1": {
            "star_index": 1156609,
            "get_star_ts": 1670219371
          },
          "2": {
            "star_index": 1161731,
            "get_star_ts": 1670220227
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670303476,
            "star_index": 1449701
          },
          "2": {
            "star_index": 1452021,
            "get_star_ts": 1670303583
          }
        },
        "7": {
          "1": {
            "star_index": 2339139,
            "get_star_ts": 1670634412
          },
          "2": {
            "star_index": 2339575,
            "get_star_ts": 1670634894
          }
        },
        "8": {
          "1": {
            "star_index": 2344639,
            "get_star_ts": 1670641080
          },
          "2": {
            "star_index": 3181027,
            "get_star_ts": 1671160346
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671410155,
            "star_index": 3394270
          },
          "2": {
            "star_index": 3408721,
            "get_star_ts": 1671439404
          }
        }
      }
    },
    "1079762": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 2251545,
            "get_star_ts": 1670591310
          },
          "2": {
            "star_index": 2252922,
            "get_star_ts": 1670591901
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670593947,
            "star_index": 2258016
          },
          "2": {
            "get_star_ts": 1670594474,
            "star_index": 2259427
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670601650,
            "star_index": 2277526
          },
          "2": {
            "get_star_ts": 1672761062,
            "star_index": 3959094
          }
        },
        "4": {
          "1": {
            "star_index": 3959553,
            "get_star_ts": 1672763315
          },
          "2": {
            "star_index": 3959656,
            "get_star_ts": 1672763681
          }
        },
        "5": {
          "1": {
            "star_index": 4039400,
            "get_star_ts": 1673544500
          },
          "2": {
            "get_star_ts": 1673544570,
            "star_index": 4039408
          }
        },
        "6": {
          "1": {
            "star_index": 4038976,
            "get_star_ts": 1673540164
          },
          "2": {
            "get_star_ts": 1673540226,
            "star_index": 4038989
          }
        }
      },
      "last_star_ts": 1673544570,
      "stars": 12,
      "local_score": 648,
      "id": 1079762,
      "name": "Barry Ervin"
    },
    "1128251": {
      "name": "Jelena Fordella",
      "id": 1128251,
      "stars": 0,
      "last_star_ts": 0,
      "local_score": 0,
      "global_score": 0,
      "completion_day_level": {}
    },
    "1131015": {
      "id": 1131015,
      "name": "ericpass",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 18588,
            "get_star_ts": 1669872822
          },
          "2": {
            "get_star_ts": 1669906551,
            "star_index": 139200
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669963033,
            "star_index": 310144
          },
          "2": {
            "get_star_ts": 1669965894,
            "star_index": 322916
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670175876,
            "star_index": 1048552
          },
          "2": {
            "get_star_ts": 1670179599,
            "star_index": 1061108
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670182527,
            "star_index": 1070767
          },
          "2": {
            "get_star_ts": 1670184047,
            "star_index": 1075744
          }
        },
        "5": {
          "1": {
            "star_index": 1172518,
            "get_star_ts": 1670222549
          },
          "2": {
            "star_index": 1176917,
            "get_star_ts": 1670223697
          }
        },
        "6": {
          "1": {
            "star_index": 1488837,
            "get_star_ts": 1670308910
          },
          "2": {
            "get_star_ts": 1670309458,
            "star_index": 1491497
          }
        }
      },
      "local_score": 1472,
      "last_star_ts": 1670309458,
      "stars": 12
    },
    "1287384": {
      "stars": 32,
      "last_star_ts": 1671415495,
      "local_score": 4429,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 16258,
            "get_star_ts": 1669872358
          },
          "2": {
            "get_star_ts": 1669873038,
            "star_index": 19546
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669958494,
            "star_index": 281182
          },
          "2": {
            "get_star_ts": 1669959358,
            "star_index": 290369
          }
        },
        "3": {
          "1": {
            "star_index": 588904,
            "get_star_ts": 1670044886
          },
          "2": {
            "star_index": 600798,
            "get_star_ts": 1670046310
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670130789,
            "star_index": 856493
          },
          "2": {
            "get_star_ts": 1670131042,
            "star_index": 860256
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670260619,
            "star_index": 1327998
          },
          "2": {
            "get_star_ts": 1670262170,
            "star_index": 1333731
          }
        },
        "6": {
          "1": {
            "star_index": 1638272,
            "get_star_ts": 1670344664
          },
          "2": {
            "get_star_ts": 1670344997,
            "star_index": 1639350
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670443149,
            "star_index": 1895686
          },
          "2": {
            "get_star_ts": 1670444017,
            "star_index": 1898197
          }
        },
        "8": {
          "1": {
            "star_index": 2133576,
            "get_star_ts": 1670534589
          },
          "2": {
            "star_index": 2145095,
            "get_star_ts": 1670539185
          }
        },
        "9": {
          "1": {
            "star_index": 2345878,
            "get_star_ts": 1670642722
          },
          "2": {
            "star_index": 2380094,
            "get_star_ts": 1670656919
          }
        },
        "10": {
          "1": {
            "star_index": 2464947,
            "get_star_ts": 1670692437
          },
          "2": {
            "get_star_ts": 1670697484,
            "star_index": 2475627
          }
        },
        "11": {
          "1": {
            "star_index": 2634346,
            "get_star_ts": 1670782696
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670884621,
            "star_index": 2816345
          },
          "2": {
            "get_star_ts": 1670885944,
            "star_index": 2818504
          }
        },
        "13": {
          "1": {
            "star_index": 2942858,
            "get_star_ts": 1670968463
          },
          "2": {
            "star_index": 2946647,
            "get_star_ts": 1670970838
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671046450,
            "star_index": 3050083
          },
          "2": {
            "star_index": 3058590,
            "get_star_ts": 1671052284
          }
        },
        "15": {
          "1": {
            "star_index": 3182498,
            "get_star_ts": 1671163297
          },
          "2": {
            "star_index": 3185459,
            "get_star_ts": 1671169126
          }
        },
        "17": {
          "1": {
            "star_index": 3321685,
            "get_star_ts": 1671333863
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671406304,
            "star_index": 3392149
          },
          "2": {
            "star_index": 3396567,
            "get_star_ts": 1671415495
          }
        }
      },
      "global_score": 0,
      "name": "Mark Hirons",
      "id": 1287384
    },
    "1331139": {
      "name": "knomenot",
      "id": 1331139,
      "last_star_ts": 1670284426,
      "local_score": 199,
      "stars": 4,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1670280320,
            "star_index": 1401101
          },
          "2": {
            "star_index": 1402851,
            "get_star_ts": 1670280905
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670283431,
            "star_index": 1409223
          },
          "2": {
            "get_star_ts": 1670284426,
            "star_index": 1411282
          }
        }
      }
    },
    "1336133": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 15282,
            "get_star_ts": 1669872190
          },
          "2": {
            "star_index": 16251,
            "get_star_ts": 1669872357
          }
        },
        "2": {
          "1": {
            "star_index": 304257,
            "get_star_ts": 1669961728
          },
          "2": {
            "star_index": 309072,
            "get_star_ts": 1669962788
          }
        },
        "3": {
          "1": {
            "star_index": 775205,
            "get_star_ts": 1670093421
          },
          "2": {
            "get_star_ts": 1670095761,
            "star_index": 782347
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670134153,
            "star_index": 880917
          },
          "2": {
            "get_star_ts": 1670134323,
            "star_index": 881571
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670295520,
            "star_index": 1427793
          },
          "2": {
            "get_star_ts": 1670295691,
            "star_index": 1428031
          }
        },
        "6": {
          "1": {
            "star_index": 1686975,
            "get_star_ts": 1670359975
          },
          "2": {
            "star_index": 1687718,
            "get_star_ts": 1670360208
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670465159,
            "star_index": 1943819
          },
          "2": {
            "get_star_ts": 1670465551,
            "star_index": 1944293
          }
        },
        "8": {
          "1": {
            "star_index": 2163339,
            "get_star_ts": 1670553092
          },
          "2": {
            "get_star_ts": 1670555153,
            "star_index": 2165257
          }
        },
        "9": {
          "1": {
            "star_index": 2519795,
            "get_star_ts": 1670724573
          },
          "2": {
            "star_index": 2520027,
            "get_star_ts": 1670724858
          }
        },
        "10": {
          "1": {
            "star_index": 2959141,
            "get_star_ts": 1670984859
          },
          "2": {
            "get_star_ts": 1670986747,
            "star_index": 2960300
          }
        }
      },
      "last_star_ts": 1670986747,
      "local_score": 2416,
      "stars": 20,
      "id": 1336133,
      "name": "Mahdi Albori"
    },
    "1491389": {
      "name": "tomloizzo1",
      "id": 1491389,
      "stars": 5,
      "last_star_ts": 1670252561,
      "local_score": 307,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 415415,
            "get_star_ts": 1669984471
          },
          "2": {
            "star_index": 416899,
            "get_star_ts": 1669984849
          }
        },
        "2": {
          "1": {
            "star_index": 1004392,
            "get_star_ts": 1670163808
          },
          "2": {
            "get_star_ts": 1670164757,
            "star_index": 1008175
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670252561,
            "star_index": 1295549
          }
        }
      }
    },
    "1492817": {
      "name": "Kelly Tabler",
      "id": 1492817,
      "stars": 24,
      "last_star_ts": 1671652148,
      "local_score": 2796,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669897751,
            "star_index": 108238
          },
          "2": {
            "get_star_ts": 1669897871,
            "star_index": 108603
          }
        },
        "2": {
          "1": {
            "star_index": 420922,
            "get_star_ts": 1669985901
          },
          "2": {
            "get_star_ts": 1669986295,
            "star_index": 422498
          }
        },
        "3": {
          "1": {
            "star_index": 700714,
            "get_star_ts": 1670072102
          },
          "2": {
            "get_star_ts": 1670076197,
            "star_index": 715908
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670189343,
            "star_index": 1093117
          },
          "2": {
            "star_index": 1093859,
            "get_star_ts": 1670189585
          }
        },
        "5": {
          "1": {
            "star_index": 1406651,
            "get_star_ts": 1670282354
          },
          "2": {
            "get_star_ts": 1670282569,
            "star_index": 1407176
          }
        },
        "6": {
          "1": {
            "star_index": 1617127,
            "get_star_ts": 1670338743
          },
          "2": {
            "star_index": 1617364,
            "get_star_ts": 1670338810
          }
        },
        "7": {
          "1": {
            "star_index": 1943392,
            "get_star_ts": 1670464797
          },
          "2": {
            "star_index": 1944815,
            "get_star_ts": 1670466017
          }
        },
        "8": {
          "1": {
            "star_index": 3578983,
            "get_star_ts": 1671651364
          },
          "2": {
            "get_star_ts": 1671652148,
            "star_index": 3579632
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1671462575,
            "star_index": 3426045
          },
          "2": {
            "get_star_ts": 1671463642,
            "star_index": 3426948
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1671470146,
            "star_index": 3432962
          },
          "2": {
            "star_index": 3436659,
            "get_star_ts": 1671474654
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671492752,
            "star_index": 3452952
          },
          "2": {
            "get_star_ts": 1671494028,
            "star_index": 3453731
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671592201,
            "star_index": 3525116
          },
          "2": {
            "star_index": 3562298,
            "get_star_ts": 1671632343
          }
        }
      },
      "global_score": 0
    },
    "1494672": {
      "name": "RyWerth",
      "id": 1494672,
      "stars": 28,
      "last_star_ts": 1671114992,
      "local_score": 3468,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 172688,
            "get_star_ts": 1669915744
          },
          "2": {
            "star_index": 177297,
            "get_star_ts": 1669917042
          }
        },
        "2": {
          "1": {
            "star_index": 494172,
            "get_star_ts": 1670003594
          },
          "2": {
            "get_star_ts": 1670003837,
            "star_index": 495003
          }
        },
        "3": {
          "1": {
            "star_index": 889959,
            "get_star_ts": 1670136791
          },
          "2": {
            "star_index": 893445,
            "get_star_ts": 1670137920
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670195539,
            "star_index": 1109638
          },
          "2": {
            "star_index": 1110657,
            "get_star_ts": 1670196067
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670252574,
            "star_index": 1295606
          },
          "2": {
            "star_index": 1297677,
            "get_star_ts": 1670253091
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670337628,
            "star_index": 1612807
          },
          "2": {
            "get_star_ts": 1670337725,
            "star_index": 1613162
          }
        },
        "7": {
          "1": {
            "star_index": 1905793,
            "get_star_ts": 1670446665
          },
          "2": {
            "get_star_ts": 1670447581,
            "star_index": 1908732
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670523566,
            "star_index": 2104683
          },
          "2": {
            "get_star_ts": 1670525656,
            "star_index": 2110085
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670598086,
            "star_index": 2268673
          },
          "2": {
            "get_star_ts": 1670602469,
            "star_index": 2279552
          }
        },
        "10": {
          "1": {
            "star_index": 2466748,
            "get_star_ts": 1670693257
          },
          "2": {
            "star_index": 2471019,
            "get_star_ts": 1670695233
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670793445,
            "star_index": 2658764
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670873738,
            "star_index": 2794207
          },
          "2": {
            "star_index": 2795347,
            "get_star_ts": 1670874297
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670947428,
            "star_index": 2907871
          },
          "2": {
            "get_star_ts": 1670950404,
            "star_index": 2912790
          }
        },
        "14": {
          "1": {
            "star_index": 3032592,
            "get_star_ts": 1671034474
          },
          "2": {
            "star_index": 3035324,
            "get_star_ts": 1671036163
          }
        },
        "15": {
          "1": {
            "star_index": 3130646,
            "get_star_ts": 1671114992
          }
        }
      }
    },
    "1505785": {
      "id": 1505785,
      "name": "Ramanan Somaskanda",
      "completion_day_level": {},
      "global_score": 0,
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0
    },
    "1505924": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 200995,
            "get_star_ts": 1669924091
          },
          "2": {
            "get_star_ts": 1669924178,
            "star_index": 201288
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670021678,
            "star_index": 548277
          },
          "2": {
            "get_star_ts": 1670022285,
            "star_index": 549690
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670094931,
            "star_index": 779875
          },
          "2": {
            "get_star_ts": 1670101716,
            "star_index": 799824
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670168881,
            "star_index": 1023821
          },
          "2": {
            "star_index": 1029821,
            "get_star_ts": 1670170581
          }
        },
        "6": {
          "1": {
            "star_index": 1667476,
            "get_star_ts": 1670353864
          },
          "2": {
            "get_star_ts": 1670366730,
            "star_index": 1707007
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670540461,
            "star_index": 2147750
          }
        },
        "10": {
          "1": {
            "star_index": 2475077,
            "get_star_ts": 1670697216
          }
        }
      },
      "global_score": 0,
      "stars": 12,
      "last_star_ts": 1670697216,
      "local_score": 1178,
      "id": 1505924,
      "name": "Benjamin Mokotoff"
    },
    "1506620": {
      "name": "Ozzy Campos",
      "id": 1506620,
      "last_star_ts": 1670546656,
      "stars": 14,
      "local_score": 1475,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669929033,
            "star_index": 217221
          },
          "2": {
            "star_index": 218526,
            "get_star_ts": 1669929456
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669992829,
            "star_index": 450390
          },
          "2": {
            "star_index": 517861,
            "get_star_ts": 1670011021
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670086481,
            "star_index": 752165
          },
          "2": {
            "get_star_ts": 1670087677,
            "star_index": 756260
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670165844,
            "star_index": 1012508
          },
          "2": {
            "get_star_ts": 1670168747,
            "star_index": 1023333
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670246558,
            "star_index": 1271586
          },
          "2": {
            "get_star_ts": 1670246680,
            "star_index": 1272090
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670370952,
            "star_index": 1715173
          },
          "2": {
            "get_star_ts": 1670371403,
            "star_index": 1715834
          }
        },
        "7": {
          "1": {
            "star_index": 2082300,
            "get_star_ts": 1670515145
          },
          "2": {
            "star_index": 2157032,
            "get_star_ts": 1670546656
          }
        }
      }
    },
    "1512095": {
      "last_star_ts": 1671811451,
      "stars": 38,
      "local_score": 5491,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669896513,
            "star_index": 104091
          },
          "2": {
            "star_index": 104569,
            "get_star_ts": 1669896664
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669983619,
            "star_index": 412021
          },
          "2": {
            "get_star_ts": 1669983927,
            "star_index": 413258
          }
        },
        "3": {
          "1": {
            "star_index": 714487,
            "get_star_ts": 1670075820
          },
          "2": {
            "get_star_ts": 1670076319,
            "star_index": 716343
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670158903,
            "star_index": 984423
          },
          "2": {
            "star_index": 985033,
            "get_star_ts": 1670159048
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670244586,
            "star_index": 1263994
          },
          "2": {
            "star_index": 1264283,
            "get_star_ts": 1670244661
          }
        },
        "6": {
          "1": {
            "star_index": 1592873,
            "get_star_ts": 1670332521
          },
          "2": {
            "star_index": 1593292,
            "get_star_ts": 1670332635
          }
        },
        "7": {
          "1": {
            "star_index": 1826354,
            "get_star_ts": 1670418768
          },
          "2": {
            "get_star_ts": 1670422989,
            "star_index": 1837984
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670502136,
            "star_index": 2045811
          },
          "2": {
            "get_star_ts": 1670503145,
            "star_index": 2048370
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670589989,
            "star_index": 2248408
          },
          "2": {
            "star_index": 2255647,
            "get_star_ts": 1670593041
          }
        },
        "10": {
          "1": {
            "star_index": 2428484,
            "get_star_ts": 1670676892
          },
          "2": {
            "get_star_ts": 1670678143,
            "star_index": 2431404
          }
        },
        "11": {
          "1": {
            "star_index": 2597097,
            "get_star_ts": 1670766531
          },
          "2": {
            "get_star_ts": 1670771396,
            "star_index": 2608280
          }
        },
        "12": {
          "1": {
            "star_index": 2747351,
            "get_star_ts": 1670849246
          },
          "2": {
            "star_index": 2748373,
            "get_star_ts": 1670849792
          }
        },
        "13": {
          "1": {
            "star_index": 2899468,
            "get_star_ts": 1670942484
          },
          "2": {
            "star_index": 2903442,
            "get_star_ts": 1670944867
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671023674,
            "star_index": 3016080
          },
          "2": {
            "star_index": 3022427,
            "get_star_ts": 1671027879
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671119527,
            "star_index": 3136946
          },
          "2": {
            "star_index": 3178311,
            "get_star_ts": 1671154996
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671399181,
            "star_index": 3385791
          },
          "2": {
            "star_index": 3391582,
            "get_star_ts": 1671405466
          }
        },
        "20": {
          "1": {
            "star_index": 3507041,
            "get_star_ts": 1671564481
          },
          "2": {
            "get_star_ts": 1671566370,
            "star_index": 3508708
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1671628265,
            "star_index": 3558573
          },
          "2": {
            "star_index": 3569887,
            "get_star_ts": 1671640329
          }
        },
        "23": {
          "1": {
            "star_index": 3684033,
            "get_star_ts": 1671811162
          },
          "2": {
            "star_index": 3684244,
            "get_star_ts": 1671811451
          }
        }
      },
      "name": "Mike Eilbacher",
      "id": 1512095
    },
    "1513819": {
      "local_score": 5882,
      "last_star_ts": 1672956157,
      "stars": 45,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669920645,
            "star_index": 189639
          },
          "2": {
            "star_index": 191055,
            "get_star_ts": 1669921071
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669993885,
            "star_index": 455166
          },
          "2": {
            "star_index": 459215,
            "get_star_ts": 1669994808
          }
        },
        "3": {
          "1": {
            "star_index": 1306331,
            "get_star_ts": 1670255224
          },
          "2": {
            "star_index": 1315705,
            "get_star_ts": 1670257506
          }
        },
        "4": {
          "1": {
            "star_index": 1317750,
            "get_star_ts": 1670258024
          },
          "2": {
            "get_star_ts": 1670259693,
            "star_index": 1324485
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670261275,
            "star_index": 1330450
          },
          "2": {
            "get_star_ts": 1670261759,
            "star_index": 1332253
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670335593,
            "star_index": 1604719
          },
          "2": {
            "star_index": 1605774,
            "get_star_ts": 1670335872
          }
        },
        "7": {
          "1": {
            "star_index": 1891476,
            "get_star_ts": 1670441708
          },
          "2": {
            "star_index": 1893039,
            "get_star_ts": 1670442225
          }
        },
        "8": {
          "1": {
            "star_index": 2096061,
            "get_star_ts": 1670520157
          },
          "2": {
            "star_index": 2098374,
            "get_star_ts": 1670521046
          }
        },
        "9": {
          "1": {
            "star_index": 2319612,
            "get_star_ts": 1670621733
          },
          "2": {
            "get_star_ts": 1670646885,
            "star_index": 2348840
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670688924,
            "star_index": 2457002
          },
          "2": {
            "get_star_ts": 1670705254,
            "star_index": 2491006
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670790236,
            "star_index": 2651363
          },
          "2": {
            "star_index": 2654626,
            "get_star_ts": 1670791624
          }
        },
        "12": {
          "1": {
            "star_index": 2936443,
            "get_star_ts": 1670964787
          },
          "2": {
            "get_star_ts": 1670983449,
            "star_index": 2958247
          }
        },
        "13": {
          "1": {
            "star_index": 3028313,
            "get_star_ts": 1671031696
          },
          "2": {
            "star_index": 3029069,
            "get_star_ts": 1671032200
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671039343,
            "star_index": 3040012
          },
          "2": {
            "get_star_ts": 1671041019,
            "star_index": 3042430
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671116964,
            "star_index": 3133411
          },
          "2": {
            "get_star_ts": 1671160505,
            "star_index": 3181107
          }
        },
        "16": {
          "1": {
            "get_star_ts": 1671467640,
            "star_index": 3430729
          }
        },
        "17": {
          "1": {
            "star_index": 3448684,
            "get_star_ts": 1671487683
          },
          "2": {
            "get_star_ts": 1671556135,
            "star_index": 3499959
          }
        },
        "18": {
          "1": {
            "star_index": 3502251,
            "get_star_ts": 1671558719
          }
        },
        "19": {
          "1": {
            "star_index": 3728181,
            "get_star_ts": 1671887492
          }
        },
        "20": {
          "1": {
            "star_index": 3688630,
            "get_star_ts": 1671817024
          },
          "2": {
            "get_star_ts": 1671817412,
            "star_index": 3688905
          }
        },
        "21": {
          "1": {
            "star_index": 3592986,
            "get_star_ts": 1671671264
          },
          "2": {
            "get_star_ts": 1671676276,
            "star_index": 3594752
          }
        },
        "22": {
          "1": {
            "star_index": 3648638,
            "get_star_ts": 1671758975
          }
        },
        "23": {
          "1": {
            "star_index": 3685255,
            "get_star_ts": 1671812782
          },
          "2": {
            "get_star_ts": 1671813145,
            "star_index": 3685534
          }
        },
        "24": {
          "1": {
            "star_index": 3982751,
            "get_star_ts": 1672934868
          },
          "2": {
            "get_star_ts": 1672938406,
            "star_index": 3983369
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1672956157,
            "star_index": 3986111
          }
        }
      },
      "name": "Patrick Clements",
      "id": 1513819
    },
    "1517289": {
      "id": 1517289,
      "name": "Annie Kong",
      "global_score": 0,
      "completion_day_level": {},
      "last_star_ts": 0,
      "local_score": 0,
      "stars": 0
    },
    "1517659": {
      "id": 1517659,
      "name": "CliffJumper",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 73874,
            "get_star_ts": 1669887982
          },
          "2": {
            "get_star_ts": 1669888337,
            "star_index": 75368
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670003337,
            "star_index": 493336
          },
          "2": {
            "get_star_ts": 1670004699,
            "star_index": 497909
          }
        },
        "3": {
          "1": {
            "star_index": 688407,
            "get_star_ts": 1670068846
          },
          "2": {
            "get_star_ts": 1670070576,
            "star_index": 695066
          }
        },
        "4": {
          "1": {
            "star_index": 1004739,
            "get_star_ts": 1670163894
          },
          "2": {
            "star_index": 1005741,
            "get_star_ts": 1670164149
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670284939,
            "star_index": 1412224
          },
          "2": {
            "get_star_ts": 1670285978,
            "star_index": 1414031
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670380112,
            "star_index": 1726883
          },
          "2": {
            "star_index": 1727048,
            "get_star_ts": 1670380259
          }
        },
        "7": {
          "1": {
            "star_index": 2335894,
            "get_star_ts": 1670631425
          },
          "2": {
            "star_index": 2335908,
            "get_star_ts": 1670631433
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670789904,
            "star_index": 2650585
          },
          "2": {
            "star_index": 2651698,
            "get_star_ts": 1670790377
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670802428,
            "star_index": 2675449
          },
          "2": {
            "star_index": 3206173,
            "get_star_ts": 1671194321
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1671198612,
            "star_index": 3210330
          },
          "2": {
            "star_index": 3211615,
            "get_star_ts": 1671199903
          }
        },
        "11": {
          "1": {
            "star_index": 3219515,
            "get_star_ts": 1671207222
          },
          "2": {
            "star_index": 3226384,
            "get_star_ts": 1671214006
          }
        },
        "12": {
          "1": {
            "star_index": 3235555,
            "get_star_ts": 1671223092
          },
          "2": {
            "star_index": 3238900,
            "get_star_ts": 1671226269
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671639503,
            "star_index": 3569155
          },
          "2": {
            "star_index": 3569238,
            "get_star_ts": 1671639608
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671677682,
            "star_index": 3595208
          },
          "2": {
            "star_index": 3595254,
            "get_star_ts": 1671677824
          }
        },
        "15": {
          "1": {
            "star_index": 3747980,
            "get_star_ts": 1671924625
          },
          "2": {
            "get_star_ts": 1671925199,
            "star_index": 3748223
          }
        }
      },
      "stars": 30,
      "last_star_ts": 1671925199,
      "local_score": 3487
    },
    "1542459": {
      "name": "Patrick Green",
      "id": 1542459,
      "last_star_ts": 0,
      "local_score": 0,
      "stars": 0,
      "completion_day_level": {},
      "global_score": 0
    },
    "1543143": {
      "id": 1543143,
      "name": "Dave Barrett",
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 118992,
            "get_star_ts": 1669901051
          },
          "2": {
            "get_star_ts": 1669902417,
            "star_index": 123782
          }
        },
        "2": {
          "1": {
            "star_index": 520150,
            "get_star_ts": 1670011790
          },
          "2": {
            "get_star_ts": 1670012429,
            "star_index": 522118
          }
        },
        "3": {
          "1": {
            "star_index": 1002635,
            "get_star_ts": 1670163353
          },
          "2": {
            "get_star_ts": 1670164448,
            "star_index": 1006891
          }
        },
        "4": {
          "1": {
            "star_index": 1018679,
            "get_star_ts": 1670167488
          },
          "2": {
            "get_star_ts": 1670168165,
            "star_index": 1021224
          }
        },
        "5": {
          "1": {
            "star_index": 1316038,
            "get_star_ts": 1670257595
          },
          "2": {
            "get_star_ts": 1670258595,
            "star_index": 1320126
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670339490,
            "star_index": 1619894
          },
          "2": {
            "get_star_ts": 1670339710,
            "star_index": 1620724
          }
        },
        "7": {
          "1": {
            "star_index": 2327232,
            "get_star_ts": 1670625827
          },
          "2": {
            "get_star_ts": 1670627937,
            "star_index": 2330913
          }
        },
        "8": {
          "1": {
            "star_index": 2336768,
            "get_star_ts": 1670632180
          },
          "2": {
            "star_index": 2339826,
            "get_star_ts": 1670635140
          }
        },
        "9": {
          "1": {
            "star_index": 2345418,
            "get_star_ts": 1670642108
          },
          "2": {
            "star_index": 2810601,
            "get_star_ts": 1670881690
          }
        },
        "10": {
          "1": {
            "star_index": 2814867,
            "get_star_ts": 1670883822
          },
          "2": {
            "get_star_ts": 1670941179,
            "star_index": 2897254
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670962188,
            "star_index": 2931849
          },
          "2": {
            "star_index": 2934540,
            "get_star_ts": 1670963742
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1671154751,
            "star_index": 3178199
          },
          "2": {
            "star_index": 3178995,
            "get_star_ts": 1671156296
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1671156296,
      "stars": 24,
      "local_score": 2720
    },
    "1549336": {
      "name": "Brian G. Shacklett",
      "id": 1549336,
      "last_star_ts": 1669950404,
      "local_score": 116,
      "stars": 2,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 258309,
            "get_star_ts": 1669950323
          },
          "2": {
            "star_index": 258402,
            "get_star_ts": 1669950404
          }
        }
      },
      "global_score": 0
    },
    "1549949": {
      "id": 1549949,
      "name": "Patrick Hade",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669873046,
            "star_index": 19579
          },
          "2": {
            "get_star_ts": 1669898995,
            "star_index": 112210
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669989333,
            "star_index": 434962
          },
          "2": {
            "star_index": 438535,
            "get_star_ts": 1669990176
          }
        },
        "3": {
          "1": {
            "star_index": 589570,
            "get_star_ts": 1670044950
          },
          "2": {
            "star_index": 594261,
            "get_star_ts": 1670045420
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670170008,
            "star_index": 1027692
          },
          "2": {
            "get_star_ts": 1670170377,
            "star_index": 1029085
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670256228,
            "star_index": 1310482
          },
          "2": {
            "get_star_ts": 1670256353,
            "star_index": 1310986
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670304412,
            "star_index": 1463658
          },
          "2": {
            "star_index": 1465343,
            "get_star_ts": 1670304593
          }
        },
        "8": {
          "1": {
            "star_index": 2929509,
            "get_star_ts": 1670960776
          },
          "2": {
            "star_index": 2939921,
            "get_star_ts": 1670966780
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670971574,
            "star_index": 2947713
          },
          "2": {
            "get_star_ts": 1671020163,
            "star_index": 3011120
          }
        }
      },
      "global_score": 0,
      "local_score": 1987,
      "last_star_ts": 1671020163,
      "stars": 16
    },
    "1550261": {
      "stars": 2,
      "last_star_ts": 1670214421,
      "local_score": 97,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1133960,
            "get_star_ts": 1670214009
          },
          "2": {
            "star_index": 1134403,
            "get_star_ts": 1670214421
          }
        }
      },
      "global_score": 0,
      "name": "Karen A. Loscocco",
      "id": 1550261
    },
    "1550444": {
      "name": "James Majors",
      "id": 1550444,
      "stars": 14,
      "last_star_ts": 1671033054,
      "local_score": 923,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 2783213,
            "get_star_ts": 1670867929
          },
          "2": {
            "get_star_ts": 1670868212,
            "star_index": 2783715
          }
        },
        "2": {
          "1": {
            "star_index": 2787077,
            "get_star_ts": 1670870028
          },
          "2": {
            "get_star_ts": 1670873652,
            "star_index": 2794050
          }
        },
        "3": {
          "1": {
            "star_index": 2800705,
            "get_star_ts": 1670876913
          },
          "2": {
            "get_star_ts": 1670878309,
            "star_index": 2803622
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670880620,
            "star_index": 2808458
          },
          "2": {
            "star_index": 2809149,
            "get_star_ts": 1670880965
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1671033024,
            "star_index": 3030363
          },
          "2": {
            "get_star_ts": 1671033054,
            "star_index": 3030408
          }
        },
        "6": {
          "1": {
            "star_index": 2912674,
            "get_star_ts": 1670950330
          },
          "2": {
            "get_star_ts": 1670950534,
            "star_index": 2913012
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1671032383,
            "star_index": 3029350
          },
          "2": {
            "get_star_ts": 1671032446,
            "star_index": 3029451
          }
        }
      }
    },
    "1550722": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 120477,
            "get_star_ts": 1669901490
          },
          "2": {
            "get_star_ts": 1669901695,
            "star_index": 121210
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669988574,
            "star_index": 431745
          },
          "2": {
            "get_star_ts": 1669990673,
            "star_index": 440640
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670046924,
            "star_index": 604214
          },
          "2": {
            "star_index": 610060,
            "get_star_ts": 1670048292
          }
        },
        "4": {
          "1": {
            "star_index": 1002618,
            "get_star_ts": 1670163350
          },
          "2": {
            "get_star_ts": 1670163657,
            "star_index": 1003800
          }
        },
        "5": {
          "1": {
            "star_index": 1340691,
            "get_star_ts": 1670264109
          },
          "2": {
            "star_index": 1342808,
            "get_star_ts": 1670264682
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670303719,
            "star_index": 1454551
          },
          "2": {
            "star_index": 1473558,
            "get_star_ts": 1670305748
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670422105,
            "star_index": 1835509
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670552259,
            "star_index": 2162564
          },
          "2": {
            "star_index": 2167922,
            "get_star_ts": 1670557947
          }
        },
        "9": {
          "1": {
            "star_index": 2304494,
            "get_star_ts": 1670614249
          }
        },
        "10": {
          "1": {
            "star_index": 2520760,
            "get_star_ts": 1670725839
          },
          "2": {
            "star_index": 2523226,
            "get_star_ts": 1670729078
          }
        },
        "11": {
          "1": {
            "star_index": 2539163,
            "get_star_ts": 1670738938
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670896910,
            "star_index": 2829985
          },
          "2": {
            "star_index": 2830007,
            "get_star_ts": 1670896931
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671066209,
            "star_index": 3074353
          }
        }
      },
      "global_score": 0,
      "local_score": 2883,
      "last_star_ts": 1671066209,
      "stars": 22,
      "id": 1550722,
      "name": "Anfer"
    },
    "1551392": {
      "stars": 0,
      "last_star_ts": 0,
      "local_score": 0,
      "completion_day_level": {},
      "global_score": 0,
      "name": "Christopher Maltusch",
      "id": 1551392
    },
    "1551553": {
      "name": "Drew Teachout",
      "id": 1551553,
      "local_score": 1739,
      "last_star_ts": 1673636755,
      "stars": 14,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 23710,
            "get_star_ts": 1669874168
          },
          "2": {
            "get_star_ts": 1669874426,
            "star_index": 24549
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669958187,
            "star_index": 276665
          },
          "2": {
            "star_index": 283594,
            "get_star_ts": 1669958680
          }
        },
        "3": {
          "1": {
            "star_index": 587886,
            "get_star_ts": 1670044799
          },
          "2": {
            "star_index": 591985,
            "get_star_ts": 1670045179
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670354311,
            "star_index": 1668878
          },
          "2": {
            "star_index": 1672644,
            "get_star_ts": 1670355511
          }
        },
        "5": {
          "1": {
            "star_index": 1401612,
            "get_star_ts": 1670280479
          },
          "2": {
            "get_star_ts": 1670280965,
            "star_index": 1403025
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670303906,
            "star_index": 1457471
          },
          "2": {
            "star_index": 1461544,
            "get_star_ts": 1670304221
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1673636491,
            "star_index": 4046058
          },
          "2": {
            "star_index": 4046074,
            "get_star_ts": 1673636755
          }
        }
      },
      "global_score": 0
    },
    "1551779": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669905630,
            "star_index": 135583
          },
          "2": {
            "get_star_ts": 1669906179,
            "star_index": 137725
          }
        },
        "2": {
          "1": {
            "star_index": 471437,
            "get_star_ts": 1669997637
          },
          "2": {
            "star_index": 474455,
            "get_star_ts": 1669998375
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670183341,
            "star_index": 1073399
          },
          "2": {
            "star_index": 1075351,
            "get_star_ts": 1670183929
          }
        },
        "4": {
          "1": {
            "star_index": 1078057,
            "get_star_ts": 1670184744
          },
          "2": {
            "get_star_ts": 1670185879,
            "star_index": 1081874
          }
        },
        "5": {
          "1": {
            "star_index": 1315006,
            "get_star_ts": 1670257330
          },
          "2": {
            "get_star_ts": 1670257751,
            "star_index": 1316675
          }
        },
        "6": {
          "1": {
            "star_index": 1613131,
            "get_star_ts": 1670337717
          },
          "2": {
            "star_index": 1613694,
            "get_star_ts": 1670337859
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670473855,
            "star_index": 1953511
          },
          "2": {
            "star_index": 1953554,
            "get_star_ts": 1670473904
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670537188,
            "star_index": 2140422
          },
          "2": {
            "get_star_ts": 1670538923,
            "star_index": 2144485
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671212873,
            "star_index": 3225316
          },
          "2": {
            "get_star_ts": 1671214158,
            "star_index": 3226528
          }
        },
        "10": {
          "1": {
            "star_index": 3234226,
            "get_star_ts": 1671221843
          },
          "2": {
            "star_index": 3235413,
            "get_star_ts": 1671222952
          }
        },
        "11": {
          "1": {
            "star_index": 3513186,
            "get_star_ts": 1671571239
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671567124,
            "star_index": 3509375
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1671571239,
      "local_score": 2445,
      "stars": 22,
      "id": 1551779,
      "name": "Graham Guthrie"
    },
    "1552420": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 157640,
            "get_star_ts": 1669911516
          },
          "2": {
            "star_index": 160337,
            "get_star_ts": 1669912233
          }
        },
        "2": {
          "1": {
            "star_index": 1736600,
            "get_star_ts": 1670389478
          },
          "2": {
            "star_index": 1738147,
            "get_star_ts": 1670390329
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1672007270,
            "star_index": 3793432
          },
          "2": {
            "star_index": 3795729,
            "get_star_ts": 1672012013
          }
        },
        "4": {
          "1": {
            "star_index": 3797041,
            "get_star_ts": 1672015695
          },
          "2": {
            "get_star_ts": 1672017074,
            "star_index": 3797426
          }
        },
        "5": {
          "1": {
            "star_index": 3819237,
            "get_star_ts": 1672085950
          },
          "2": {
            "get_star_ts": 1672088416,
            "star_index": 3820309
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1672093076,
            "star_index": 3822585
          },
          "2": {
            "get_star_ts": 1672093363,
            "star_index": 3822724
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1673669899,
            "star_index": 4048319
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1672784707,
            "star_index": 3963930
          },
          "2": {
            "star_index": 3965109,
            "get_star_ts": 1672792766
          }
        }
      },
      "global_score": 0,
      "stars": 15,
      "last_star_ts": 1673669899,
      "local_score": 1078,
      "id": 1552420,
      "name": "Dina Zhang"
    },
    "1552821": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 17777,
            "get_star_ts": 1669872648
          },
          "2": {
            "star_index": 20851,
            "get_star_ts": 1669873355
          }
        },
        "2": {
          "1": {
            "star_index": 356924,
            "get_star_ts": 1669972063
          },
          "2": {
            "star_index": 360979,
            "get_star_ts": 1669972776
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670082906,
            "star_index": 739928
          },
          "2": {
            "star_index": 742186,
            "get_star_ts": 1670083564
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670131408,
            "star_index": 864595
          },
          "2": {
            "star_index": 865969,
            "get_star_ts": 1670131551
          }
        },
        "5": {
          "1": {
            "star_index": 1349710,
            "get_star_ts": 1670266539
          },
          "2": {
            "get_star_ts": 1670267618,
            "star_index": 1353786
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670303293,
            "star_index": 1445294
          },
          "2": {
            "get_star_ts": 1670303320,
            "star_index": 1445999
          }
        },
        "7": {
          "1": {
            "star_index": 3218306,
            "get_star_ts": 1671206107
          },
          "2": {
            "star_index": 3218828,
            "get_star_ts": 1671206599
          }
        },
        "8": {
          "1": {
            "star_index": 2085519,
            "get_star_ts": 1670516278
          },
          "2": {
            "star_index": 2092092,
            "get_star_ts": 1670518630
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671209942,
            "star_index": 3222411
          },
          "2": {
            "get_star_ts": 1671212297,
            "star_index": 3224758
          }
        },
        "10": {
          "1": {
            "star_index": 3226459,
            "get_star_ts": 1671214087
          },
          "2": {
            "get_star_ts": 1671216030,
            "star_index": 3228358
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1671242666,
            "star_index": 3251239
          },
          "2": {
            "get_star_ts": 1671244229,
            "star_index": 3251927
          }
        }
      },
      "global_score": 0,
      "local_score": 2768,
      "last_star_ts": 1671244229,
      "stars": 22,
      "id": 1552821,
      "name": "Lily Li"
    },
    "1552913": {
      "stars": 5,
      "last_star_ts": 1670514304,
      "local_score": 322,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669922989,
            "star_index": 197309
          },
          "2": {
            "star_index": 197741,
            "get_star_ts": 1669923116
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670341857,
            "star_index": 1628677
          },
          "2": {
            "get_star_ts": 1670511586,
            "star_index": 2071914
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670514304,
            "star_index": 2079875
          }
        }
      },
      "global_score": 0,
      "name": "Jules Scheil",
      "id": 1552913
    },
    "1554163": {
      "last_star_ts": 1669996398,
      "stars": 4,
      "local_score": 330,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 214235,
            "get_star_ts": 1669928084
          },
          "2": {
            "star_index": 216551,
            "get_star_ts": 1669928815
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669996307,
            "star_index": 465799
          },
          "2": {
            "star_index": 466185,
            "get_star_ts": 1669996398
          }
        }
      },
      "name": "dtewell19",
      "id": 1554163
    },
    "1554509": {
      "id": 1554509,
      "name": "Gunnar Martin",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 78337,
            "get_star_ts": 1669889075
          },
          "2": {
            "star_index": 79461,
            "get_star_ts": 1669889359
          }
        },
        "2": {
          "1": {
            "star_index": 285956,
            "get_star_ts": 1669958885
          },
          "2": {
            "get_star_ts": 1669959448,
            "star_index": 291097
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670063066,
            "star_index": 664715
          },
          "2": {
            "get_star_ts": 1670063969,
            "star_index": 668490
          }
        },
        "4": {
          "1": {
            "star_index": 935254,
            "get_star_ts": 1670148144
          },
          "2": {
            "star_index": 937752,
            "get_star_ts": 1670148668
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670235871,
            "star_index": 1230014
          },
          "2": {
            "get_star_ts": 1670236161,
            "star_index": 1231310
          }
        },
        "6": {
          "1": {
            "star_index": 1548409,
            "get_star_ts": 1670320515
          },
          "2": {
            "get_star_ts": 1670320697,
            "star_index": 1549223
          }
        },
        "7": {
          "1": {
            "star_index": 1810851,
            "get_star_ts": 1670412796
          },
          "2": {
            "get_star_ts": 1670414079,
            "star_index": 1814148
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670495361,
            "star_index": 2027580
          },
          "2": {
            "star_index": 2036123,
            "get_star_ts": 1670498379
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670564862,
            "star_index": 2183185
          },
          "2": {
            "get_star_ts": 1670568184,
            "star_index": 2194493
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670666133,
            "star_index": 2401142
          },
          "2": {
            "get_star_ts": 1670667679,
            "star_index": 2405185
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670756684,
            "star_index": 2574735
          },
          "2": {
            "star_index": 2577612,
            "get_star_ts": 1670757953
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670844802,
            "star_index": 2739796
          },
          "2": {
            "star_index": 2743713,
            "get_star_ts": 1670847107
          }
        },
        "13": {
          "1": {
            "star_index": 2956573,
            "get_star_ts": 1670980806
          },
          "2": {
            "get_star_ts": 1670984749,
            "star_index": 2959079
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671017885,
            "star_index": 3008055
          },
          "2": {
            "get_star_ts": 1671075454,
            "star_index": 3079850
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671103593,
            "star_index": 3116365
          },
          "2": {
            "star_index": 3179793,
            "get_star_ts": 1671157941
          }
        },
        "16": {
          "1": {
            "star_index": 3947980,
            "get_star_ts": 1672687159
          },
          "2": {
            "get_star_ts": 1673173394,
            "star_index": 4007419
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1671296080,
            "star_index": 3291883
          },
          "2": {
            "star_index": 3348900,
            "get_star_ts": 1671361580
          }
        },
        "18": {
          "1": {
            "star_index": 3351970,
            "get_star_ts": 1671364403
          },
          "2": {
            "star_index": 3366670,
            "get_star_ts": 1671379061
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1673659159,
            "star_index": 4047915
          }
        },
        "20": {
          "1": {
            "star_index": 3508746,
            "get_star_ts": 1671566418
          },
          "2": {
            "get_star_ts": 1671566910,
            "star_index": 3509192
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1671618178,
            "star_index": 3549909
          },
          "2": {
            "star_index": 3576223,
            "get_star_ts": 1671647975
          }
        },
        "22": {
          "1": {
            "star_index": 3618493,
            "get_star_ts": 1671715466
          },
          "2": {
            "get_star_ts": 1673586867,
            "star_index": 4042431
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1673591624,
            "star_index": 4042641
          },
          "2": {
            "star_index": 4043678,
            "get_star_ts": 1673610689
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1673667555,
            "star_index": 4048229
          }
        }
      },
      "stars": 46,
      "last_star_ts": 1673667555,
      "local_score": 6761
    },
    "1554651": {
      "id": 1554651,
      "name": "Aidan Murphy",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 132113,
            "get_star_ts": 1669904718
          },
          "2": {
            "get_star_ts": 1669906435,
            "star_index": 138728
          }
        },
        "2": {
          "1": {
            "star_index": 479864,
            "get_star_ts": 1669999699
          },
          "2": {
            "get_star_ts": 1670000102,
            "star_index": 481441
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670084755,
            "star_index": 746201
          },
          "2": {
            "star_index": 753913,
            "get_star_ts": 1670086991
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670179695,
            "star_index": 1061425
          },
          "2": {
            "get_star_ts": 1670180813,
            "star_index": 1065144
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670267864,
            "star_index": 1354751
          },
          "2": {
            "get_star_ts": 1670268554,
            "star_index": 1357294
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670351478,
            "star_index": 1659893
          },
          "2": {
            "get_star_ts": 1670351509,
            "star_index": 1660000
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670527527,
            "star_index": 2114675
          },
          "2": {
            "star_index": 2118270,
            "get_star_ts": 1670529005
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670535305,
            "star_index": 2135557
          },
          "2": {
            "star_index": 2139523,
            "get_star_ts": 1670536830
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670618324,
            "star_index": 2312684
          }
        }
      },
      "last_star_ts": 1670618324,
      "local_score": 1890,
      "stars": 17
    },
    "1561945": {
      "id": 1561945,
      "name": "llbarnet",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 514421,
            "get_star_ts": 1670009916
          },
          "2": {
            "get_star_ts": 1670009940,
            "star_index": 514490
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670013013,
            "star_index": 523889
          },
          "2": {
            "get_star_ts": 1670013495,
            "star_index": 525324
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1672077385,
            "star_index": 3815395
          },
          "2": {
            "get_star_ts": 1672183234,
            "star_index": 3850532
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1672779353,
            "star_index": 3962765
          },
          "2": {
            "get_star_ts": 1672779581,
            "star_index": 3962805
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1673018643,
            "star_index": 3992287
          },
          "2": {
            "star_index": 3992296,
            "get_star_ts": 1673018696
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1673358179,
            "star_index": 4024399
          },
          "2": {
            "get_star_ts": 1673371324,
            "star_index": 4025833
          }
        }
      },
      "last_star_ts": 1673371324,
      "stars": 12,
      "local_score": 728
    },
    "1562296": {
      "name": "hali123",
      "id": 1562296,
      "last_star_ts": 1670641366,
      "local_score": 1159,
      "stars": 12,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669928651,
            "star_index": 216014
          },
          "2": {
            "star_index": 218465,
            "get_star_ts": 1669929435
          }
        },
        "2": {
          "1": {
            "star_index": 560911,
            "get_star_ts": 1670028830
          },
          "2": {
            "star_index": 572974,
            "get_star_ts": 1670040252
          }
        },
        "3": {
          "1": {
            "star_index": 600715,
            "get_star_ts": 1670046295
          },
          "2": {
            "star_index": 605313,
            "get_star_ts": 1670047157
          }
        },
        "4": {
          "1": {
            "star_index": 865989,
            "get_star_ts": 1670131553
          },
          "2": {
            "star_index": 870059,
            "get_star_ts": 1670132053
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670561022,
            "star_index": 2170546
          },
          "2": {
            "get_star_ts": 1670562217,
            "star_index": 2171481
          }
        },
        "6": {
          "1": {
            "star_index": 2344695,
            "get_star_ts": 1670641164
          },
          "2": {
            "star_index": 2344851,
            "get_star_ts": 1670641366
          }
        }
      },
      "global_score": 0
    },
    "1562700": {
      "stars": 0,
      "last_star_ts": 0,
      "local_score": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Jay Jung",
      "id": 1562700
    },
    "1562745": {
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Stephen Ilhardt",
      "id": 1562745
    },
    "1625150": {
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Amanda Yang",
      "id": 1625150
    },
    "1626439": {
      "local_score": 2669,
      "last_star_ts": 1670902940,
      "stars": 22,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669918266,
            "star_index": 181616
          },
          "2": {
            "star_index": 183044,
            "get_star_ts": 1669918666
          }
        },
        "2": {
          "1": {
            "star_index": 439638,
            "get_star_ts": 1669990438
          },
          "2": {
            "star_index": 458140,
            "get_star_ts": 1669994573
          }
        },
        "3": {
          "1": {
            "star_index": 682909,
            "get_star_ts": 1670067441
          },
          "2": {
            "star_index": 687111,
            "get_star_ts": 1670068513
          }
        },
        "4": {
          "1": {
            "star_index": 893560,
            "get_star_ts": 1670137954
          },
          "2": {
            "star_index": 896769,
            "get_star_ts": 1670138923
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670249592,
            "star_index": 1283478
          },
          "2": {
            "get_star_ts": 1670289229,
            "star_index": 1419105
          }
        },
        "6": {
          "1": {
            "star_index": 1559216,
            "get_star_ts": 1670323062
          },
          "2": {
            "star_index": 1559654,
            "get_star_ts": 1670323172
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670639896,
            "star_index": 2343801
          },
          "2": {
            "get_star_ts": 1670641122,
            "star_index": 2344669
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670679787,
            "star_index": 2435331
          },
          "2": {
            "star_index": 2438538,
            "get_star_ts": 1670681145
          }
        },
        "9": {
          "1": {
            "star_index": 2480105,
            "get_star_ts": 1670699633
          },
          "2": {
            "get_star_ts": 1670701649,
            "star_index": 2483942
          }
        },
        "10": {
          "1": {
            "star_index": 2491217,
            "get_star_ts": 1670705355
          },
          "2": {
            "get_star_ts": 1670710338,
            "star_index": 2501084
          }
        },
        "11": {
          "1": {
            "star_index": 2615926,
            "get_star_ts": 1670774675
          },
          "2": {
            "get_star_ts": 1670902940,
            "star_index": 2834517
          }
        }
      },
      "name": "Douglas Yoon",
      "id": 1626439
    },
    "1636057": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 137839,
            "get_star_ts": 1669906208
          },
          "2": {
            "star_index": 142450,
            "get_star_ts": 1669907425
          }
        },
        "2": {
          "1": {
            "star_index": 296095,
            "get_star_ts": 1669960154
          },
          "2": {
            "get_star_ts": 1669960792,
            "star_index": 299767
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670337417,
            "star_index": 1611958
          },
          "2": {
            "get_star_ts": 1670338086,
            "star_index": 1614556
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670422674,
            "star_index": 1837090
          },
          "2": {
            "star_index": 1837243,
            "get_star_ts": 1670422731
          }
        },
        "5": {
          "1": {
            "star_index": 2066682,
            "get_star_ts": 1670509740
          },
          "2": {
            "get_star_ts": 1670512192,
            "star_index": 2073682
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670516658,
            "star_index": 2086542
          },
          "2": {
            "star_index": 2086779,
            "get_star_ts": 1670516734
          }
        }
      },
      "local_score": 1122,
      "last_star_ts": 1670516734,
      "stars": 12,
      "id": 1636057,
      "name": "Jordan Leahey"
    },
    "1695980": {
      "id": 1695980,
      "name": "Miriam L",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669921822,
            "star_index": 193511
          },
          "2": {
            "get_star_ts": 1669921906,
            "star_index": 193785
          }
        },
        "2": {
          "1": {
            "star_index": 482640,
            "get_star_ts": 1670000415
          },
          "2": {
            "star_index": 483820,
            "get_star_ts": 1670000728
          }
        },
        "3": {
          "1": {
            "star_index": 1325325,
            "get_star_ts": 1670259906
          },
          "2": {
            "get_star_ts": 1670261082,
            "star_index": 1329732
          }
        },
        "4": {
          "1": {
            "star_index": 1333939,
            "get_star_ts": 1670262231
          },
          "2": {
            "star_index": 1335603,
            "get_star_ts": 1670262691
          }
        },
        "5": {
          "1": {
            "star_index": 1351643,
            "get_star_ts": 1670267039
          },
          "2": {
            "star_index": 1353438,
            "get_star_ts": 1670267518
          }
        },
        "6": {
          "1": {
            "star_index": 2126805,
            "get_star_ts": 1670532080
          },
          "2": {
            "star_index": 2127174,
            "get_star_ts": 1670532217
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670620592,
            "star_index": 2317401
          },
          "2": {
            "star_index": 2317985,
            "get_star_ts": 1670620877
          }
        },
        "8": {
          "1": {
            "star_index": 2915245,
            "get_star_ts": 1670951920
          },
          "2": {
            "star_index": 3033159,
            "get_star_ts": 1671034821
          }
        },
        "9": {
          "1": {
            "star_index": 3045783,
            "get_star_ts": 1671043398
          }
        },
        "10": {
          "1": {
            "star_index": 3051975,
            "get_star_ts": 1671047761
          },
          "2": {
            "get_star_ts": 1671049480,
            "star_index": 3054413
          }
        },
        "11": {
          "1": {
            "star_index": 3058775,
            "get_star_ts": 1671052406
          },
          "2": {
            "get_star_ts": 1671055846,
            "star_index": 3064044
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1671132822,
            "star_index": 3153961
          },
          "2": {
            "star_index": 3154729,
            "get_star_ts": 1671133413
          }
        },
        "13": {
          "1": {
            "star_index": 3237411,
            "get_star_ts": 1671224862
          },
          "2": {
            "star_index": 3238759,
            "get_star_ts": 1671226152
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671817770,
            "star_index": 3689164
          },
          "2": {
            "get_star_ts": 1671819102,
            "star_index": 3690150
          }
        },
        "15": {
          "1": {
            "star_index": 3441956,
            "get_star_ts": 1671480818
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1672958488,
            "star_index": 3986458
          },
          "2": {
            "star_index": 3995718,
            "get_star_ts": 1673041481
          }
        },
        "20": {
          "1": {
            "star_index": 4026874,
            "get_star_ts": 1673380464
          },
          "2": {
            "get_star_ts": 1673454897,
            "star_index": 4032619
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1673464859,
            "star_index": 4033558
          }
        },
        "25": {
          "1": {
            "star_index": 4040816,
            "get_star_ts": 1673558920
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1673558920,
      "stars": 34,
      "local_score": 3820
    },
    "1731038": {
      "name": "AliArdestaniSlalom",
      "id": 1731038,
      "stars": 6,
      "last_star_ts": 1670488249,
      "local_score": 345,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1293216,
            "get_star_ts": 1670251993
          },
          "2": {
            "star_index": 1299380,
            "get_star_ts": 1670253505
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670257063,
            "star_index": 1313919
          },
          "2": {
            "star_index": 1314999,
            "get_star_ts": 1670257328
          }
        },
        "4": {
          "1": {
            "star_index": 2002605,
            "get_star_ts": 1670487439
          },
          "2": {
            "get_star_ts": 1670488249,
            "star_index": 2005152
          }
        }
      }
    },
    "1854656": {
      "local_score": 1327,
      "last_star_ts": 1673506200,
      "stars": 15,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669958022,
            "star_index": 273951
          },
          "2": {
            "star_index": 275256,
            "get_star_ts": 1669958101
          }
        },
        "2": {
          "1": {
            "star_index": 288126,
            "get_star_ts": 1669959108
          },
          "2": {
            "get_star_ts": 1669959886,
            "star_index": 294395
          }
        },
        "3": {
          "1": {
            "star_index": 1428312,
            "get_star_ts": 1670295900
          },
          "2": {
            "get_star_ts": 1670297233,
            "star_index": 1430033
          }
        },
        "4": {
          "1": {
            "star_index": 1432093,
            "get_star_ts": 1670298872
          },
          "2": {
            "star_index": 1432673,
            "get_star_ts": 1670299346
          }
        },
        "5": {
          "1": {
            "star_index": 1721969,
            "get_star_ts": 1670375890
          },
          "2": {
            "get_star_ts": 1670389926,
            "star_index": 1737141
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670451781,
            "star_index": 1921178
          },
          "2": {
            "get_star_ts": 1670451854,
            "star_index": 1921382
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1671687058,
            "star_index": 3598472
          },
          "2": {
            "get_star_ts": 1671773693,
            "star_index": 3653943
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1673506200,
            "star_index": 4036465
          }
        }
      },
      "global_score": 0,
      "name": "Xiaona Hu",
      "id": 1854656
    },
    "1946955": {
      "id": 1946955,
      "name": "Foster Gorman",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 109434,
            "get_star_ts": 1669898129
          },
          "2": {
            "get_star_ts": 1669898523,
            "star_index": 110726
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669959028,
            "star_index": 287392
          },
          "2": {
            "get_star_ts": 1669959488,
            "star_index": 291429
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670044584,
            "star_index": 585252
          },
          "2": {
            "get_star_ts": 1670045762,
            "star_index": 597091
          }
        },
        "4": {
          "1": {
            "star_index": 854701,
            "get_star_ts": 1670130680
          },
          "2": {
            "star_index": 867675,
            "get_star_ts": 1670131741
          }
        },
        "5": {
          "1": {
            "star_index": 1275390,
            "get_star_ts": 1670247535
          },
          "2": {
            "get_star_ts": 1670248127,
            "star_index": 1277738
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670331901,
            "star_index": 1590594
          },
          "2": {
            "get_star_ts": 1670332120,
            "star_index": 1591366
          }
        },
        "7": {
          "1": {
            "star_index": 1923817,
            "get_star_ts": 1670452759
          },
          "2": {
            "get_star_ts": 1670453545,
            "star_index": 1925788
          }
        },
        "8": {
          "1": {
            "star_index": 2064877,
            "get_star_ts": 1670509133
          },
          "2": {
            "get_star_ts": 1670512268,
            "star_index": 2073887
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670596184,
            "star_index": 2263669
          },
          "2": {
            "star_index": 2301091,
            "get_star_ts": 1670612508
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670684668,
            "star_index": 2447098
          },
          "2": {
            "star_index": 2467285,
            "get_star_ts": 1670693500
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670799651,
            "star_index": 2671381
          },
          "2": {
            "get_star_ts": 1670810197,
            "star_index": 2683368
          }
        },
        "12": {
          "1": {
            "star_index": 2795717,
            "get_star_ts": 1670874487
          },
          "2": {
            "star_index": 2796864,
            "get_star_ts": 1670875038
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670962334,
            "star_index": 2932091
          },
          "2": {
            "star_index": 2940337,
            "get_star_ts": 1670967017
          }
        }
      },
      "last_star_ts": 1670967017,
      "local_score": 3654,
      "stars": 26
    },
    "1957456": {
      "id": 1957456,
      "name": "cbalusekslalom",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 127105,
            "get_star_ts": 1669903360
          },
          "2": {
            "get_star_ts": 1669903564,
            "star_index": 127829
          }
        },
        "2": {
          "1": {
            "star_index": 280224,
            "get_star_ts": 1669958424
          },
          "2": {
            "star_index": 290530,
            "get_star_ts": 1669959377
          }
        },
        "3": {
          "1": {
            "star_index": 602753,
            "get_star_ts": 1670046649
          },
          "2": {
            "get_star_ts": 1670047610,
            "star_index": 607285
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670202263,
            "star_index": 1120063
          },
          "2": {
            "get_star_ts": 1670202419,
            "star_index": 1120268
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670218956,
            "star_index": 1153626
          },
          "2": {
            "get_star_ts": 1670258109,
            "star_index": 1318125
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670304150,
            "star_index": 1460762
          },
          "2": {
            "star_index": 1465975,
            "get_star_ts": 1670304663
          }
        },
        "7": {
          "1": {
            "star_index": 4035452,
            "get_star_ts": 1673485103
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670515788,
            "star_index": 2084099
          },
          "2": {
            "star_index": 2090017,
            "get_star_ts": 1670517895
          }
        },
        "9": {
          "1": {
            "star_index": 2194995,
            "get_star_ts": 1670568370
          },
          "2": {
            "get_star_ts": 1670625565,
            "star_index": 2326753
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670694772,
            "star_index": 2470067
          },
          "2": {
            "star_index": 2474672,
            "get_star_ts": 1670697019
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1673531618,
            "star_index": 4038093
          },
          "2": {
            "star_index": 4038098,
            "get_star_ts": 1673531665
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670962714,
            "star_index": 2932767
          },
          "2": {
            "star_index": 2958321,
            "get_star_ts": 1670983563
          }
        },
        "15": {
          "1": {
            "star_index": 3131211,
            "get_star_ts": 1671115378
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671671450,
            "star_index": 3593054
          }
        },
        "21": {
          "1": {
            "star_index": 3632096,
            "get_star_ts": 1671733594
          }
        },
        "25": {
          "1": {
            "star_index": 4034288,
            "get_star_ts": 1673471073
          }
        }
      },
      "local_score": 3594,
      "last_star_ts": 1673531665,
      "stars": 27
    },
    "1986025": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669946676,
            "star_index": 253963
          },
          "2": {
            "get_star_ts": 1669946760,
            "star_index": 254071
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669959953,
            "star_index": 294838
          },
          "2": {
            "star_index": 298885,
            "get_star_ts": 1669960626
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670080843,
            "star_index": 732639
          },
          "2": {
            "get_star_ts": 1670083304,
            "star_index": 741358
          }
        },
        "4": {
          "1": {
            "star_index": 1026219,
            "get_star_ts": 1670169575
          },
          "2": {
            "star_index": 1028563,
            "get_star_ts": 1670170234
          }
        },
        "5": {
          "1": {
            "star_index": 1360731,
            "get_star_ts": 1670269452
          },
          "2": {
            "star_index": 1362805,
            "get_star_ts": 1670269992
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670303990,
            "star_index": 1458632
          },
          "2": {
            "star_index": 1461301,
            "get_star_ts": 1670304200
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670558100,
            "star_index": 2168044
          },
          "2": {
            "get_star_ts": 1670558366,
            "star_index": 2168267
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670560728,
            "star_index": 2170283
          },
          "2": {
            "star_index": 2489835,
            "get_star_ts": 1670704615
          }
        },
        "9": {
          "1": {
            "star_index": 2681192,
            "get_star_ts": 1670807818
          }
        },
        "10": {
          "1": {
            "star_index": 2957886,
            "get_star_ts": 1670982853
          },
          "2": {
            "get_star_ts": 1670997237,
            "star_index": 2973644
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1671203051,
            "star_index": 3214979
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1671389752,
            "star_index": 3376266
          },
          "2": {
            "star_index": 3390435,
            "get_star_ts": 1671403998
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1671403998,
      "stars": 22,
      "local_score": 2540,
      "id": 1986025,
      "name": "Ryan Bonilla"
    },
    "2039943": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669918986,
            "star_index": 184071
          },
          "2": {
            "star_index": 184712,
            "get_star_ts": 1669919172
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669958705,
            "star_index": 283892
          },
          "2": {
            "get_star_ts": 1669960723,
            "star_index": 299415
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670251160,
            "star_index": 1289693
          },
          "2": {
            "star_index": 1345858,
            "get_star_ts": 1670265513
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670336094,
            "star_index": 1606636
          },
          "2": {
            "get_star_ts": 1670336447,
            "star_index": 1608045
          }
        },
        "5": {
          "1": {
            "star_index": 3970898,
            "get_star_ts": 1672842777
          },
          "2": {
            "star_index": 3970912,
            "get_star_ts": 1672842853
          }
        },
        "6": {
          "1": {
            "star_index": 1915390,
            "get_star_ts": 1670449750
          },
          "2": {
            "star_index": 1915771,
            "get_star_ts": 1670449876
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1671459236,
            "star_index": 3423132
          },
          "2": {
            "star_index": 3423186,
            "get_star_ts": 1671459298
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1671723001,
            "star_index": 3624076
          },
          "2": {
            "get_star_ts": 1672146652,
            "star_index": 3835970
          }
        },
        "9": {
          "1": {
            "star_index": 4046414,
            "get_star_ts": 1673640586
          }
        }
      },
      "last_star_ts": 1673640586,
      "stars": 17,
      "local_score": 1564,
      "id": 2039943,
      "name": "Jordan Holland"
    },
    "2052936": {
      "stars": 0,
      "last_star_ts": 0,
      "local_score": 0,
      "completion_day_level": {},
      "global_score": 0,
      "name": "Kevin Ho",
      "id": 2052936
    },
    "2064476": {
      "id": 2064476,
      "name": "Kali Kimball",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669909880,
            "star_index": 151728
          },
          "2": {
            "get_star_ts": 1669911216,
            "star_index": 156607
          }
        }
      },
      "global_score": 0,
      "local_score": 202,
      "last_star_ts": 1669911216,
      "stars": 2
    },
    "2182443": {
      "name": "Lucia Melby",
      "id": 2182443,
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "global_score": 0,
      "completion_day_level": {}
    },
    "2182464": {
      "completion_day_level": {},
      "global_score": 0,
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "id": 2182464,
      "name": null
    },
    "2251856": {
      "id": 2251856,
      "name": "Christine Saw",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669955633,
            "star_index": 264401
          },
          "2": {
            "star_index": 264924,
            "get_star_ts": 1669956141
          }
        },
        "2": {
          "1": {
            "star_index": 291948,
            "get_star_ts": 1669959553
          },
          "2": {
            "star_index": 446293,
            "get_star_ts": 1669991941
          }
        },
        "3": {
          "1": {
            "star_index": 842118,
            "get_star_ts": 1670126075
          },
          "2": {
            "get_star_ts": 1670127224,
            "star_index": 843209
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670184908,
            "star_index": 1078620
          },
          "2": {
            "get_star_ts": 1670185799,
            "star_index": 1081604
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670267817,
            "star_index": 1354567
          },
          "2": {
            "get_star_ts": 1670268659,
            "star_index": 1357694
          }
        },
        "6": {
          "1": {
            "star_index": 2335112,
            "get_star_ts": 1670630801
          },
          "2": {
            "star_index": 2346291,
            "get_star_ts": 1670643294
          }
        },
        "8": {
          "1": {
            "star_index": 2825479,
            "get_star_ts": 1670891498
          },
          "2": {
            "get_star_ts": 1670894784,
            "star_index": 2828295
          }
        },
        "10": {
          "1": {
            "star_index": 2953343,
            "get_star_ts": 1670976506
          },
          "2": {
            "get_star_ts": 1670980946,
            "star_index": 2956664
          }
        }
      },
      "global_score": 0,
      "local_score": 1558,
      "last_star_ts": 1670980946,
      "stars": 16
    },
    "2251871": {
      "name": "sahasmehta",
      "id": 2251871,
      "last_star_ts": 1672163638,
      "stars": 24,
      "local_score": 2812,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669921906,
            "star_index": 193780
          },
          "2": {
            "get_star_ts": 1669922068,
            "star_index": 194305
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669991959,
            "star_index": 446385
          },
          "2": {
            "star_index": 449189,
            "get_star_ts": 1669992566
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670195623,
            "star_index": 1109815
          },
          "2": {
            "star_index": 1110833,
            "get_star_ts": 1670196159
          }
        },
        "4": {
          "1": {
            "star_index": 1112776,
            "get_star_ts": 1670197239
          },
          "2": {
            "star_index": 1113163,
            "get_star_ts": 1670197448
          }
        },
        "5": {
          "1": {
            "star_index": 1295071,
            "get_star_ts": 1670252446
          },
          "2": {
            "star_index": 1303848,
            "get_star_ts": 1670254631
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670335194,
            "star_index": 1603164
          },
          "2": {
            "star_index": 1612898,
            "get_star_ts": 1670337652
          }
        },
        "7": {
          "1": {
            "star_index": 1851071,
            "get_star_ts": 1670427427
          },
          "2": {
            "get_star_ts": 1670427745,
            "star_index": 1852006
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670526124,
            "star_index": 2111220
          },
          "2": {
            "star_index": 2115802,
            "get_star_ts": 1670527996
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670718750,
            "star_index": 2514250
          },
          "2": {
            "get_star_ts": 1670719112,
            "star_index": 2514651
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670721476,
            "star_index": 2517167
          },
          "2": {
            "star_index": 2520446,
            "get_star_ts": 1670725425
          }
        },
        "11": {
          "1": {
            "star_index": 2692167,
            "get_star_ts": 1670821572
          },
          "2": {
            "star_index": 2692774,
            "get_star_ts": 1670821890
          }
        },
        "13": {
          "1": {
            "star_index": 3842631,
            "get_star_ts": 1672163317
          },
          "2": {
            "star_index": 3842764,
            "get_star_ts": 1672163638
          }
        }
      }
    },
    "2251910": {
      "name": "Sean",
      "id": 2251910,
      "last_star_ts": 1671658834,
      "local_score": 4761,
      "stars": 35,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 122938,
            "get_star_ts": 1669902191
          },
          "2": {
            "get_star_ts": 1669902379,
            "star_index": 123625
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669987779,
            "star_index": 428514
          },
          "2": {
            "star_index": 431429,
            "get_star_ts": 1669988497
          }
        },
        "3": {
          "1": {
            "star_index": 759410,
            "get_star_ts": 1670088598
          },
          "2": {
            "get_star_ts": 1670089991,
            "star_index": 763993
          }
        },
        "4": {
          "1": {
            "star_index": 1007225,
            "get_star_ts": 1670164524
          },
          "2": {
            "get_star_ts": 1670165236,
            "star_index": 1010062
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670251886,
            "star_index": 1292737
          },
          "2": {
            "get_star_ts": 1670254259,
            "star_index": 1302375
          }
        },
        "6": {
          "1": {
            "star_index": 1612815,
            "get_star_ts": 1670337630
          },
          "2": {
            "get_star_ts": 1670337785,
            "star_index": 1613425
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670441291,
            "star_index": 1890245
          },
          "2": {
            "star_index": 1894560,
            "get_star_ts": 1670442776
          }
        },
        "8": {
          "1": {
            "star_index": 2080240,
            "get_star_ts": 1670514434
          },
          "2": {
            "star_index": 2105423,
            "get_star_ts": 1670523866
          }
        },
        "9": {
          "1": {
            "star_index": 2273563,
            "get_star_ts": 1670600024
          },
          "2": {
            "star_index": 2310259,
            "get_star_ts": 1670617103
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670678736,
            "star_index": 2432795
          },
          "2": {
            "star_index": 2448535,
            "get_star_ts": 1670685276
          }
        },
        "11": {
          "1": {
            "star_index": 2606195,
            "get_star_ts": 1670770495
          },
          "2": {
            "star_index": 2628396,
            "get_star_ts": 1670780009
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670878511,
            "star_index": 2804087
          },
          "2": {
            "star_index": 2809131,
            "get_star_ts": 1670880959
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670973406,
            "star_index": 2950114
          },
          "2": {
            "get_star_ts": 1670992233,
            "star_index": 2963821
          }
        },
        "14": {
          "1": {
            "star_index": 3057306,
            "get_star_ts": 1671051419
          },
          "2": {
            "get_star_ts": 1671055984,
            "star_index": 3064236
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671164925,
            "star_index": 3183289
          },
          "2": {
            "get_star_ts": 1671230184,
            "star_index": 3243010
          }
        },
        "17": {
          "1": {
            "star_index": 3375377,
            "get_star_ts": 1671388765
          }
        },
        "20": {
          "1": {
            "get_star_ts": 1671564259,
            "star_index": 3506863
          },
          "2": {
            "star_index": 3523999,
            "get_star_ts": 1671588876
          }
        },
        "21": {
          "1": {
            "star_index": 3574719,
            "get_star_ts": 1671646092
          },
          "2": {
            "get_star_ts": 1671658834,
            "star_index": 3585280
          }
        }
      },
      "global_score": 0
    },
    "2252096": {
      "name": "Crystal Meyers",
      "id": 2252096,
      "last_star_ts": 1670815343,
      "stars": 15,
      "local_score": 1535,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 242147,
            "get_star_ts": 1669938329
          },
          "2": {
            "get_star_ts": 1669938354,
            "star_index": 242199
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669994895,
            "star_index": 459583
          },
          "2": {
            "star_index": 463587,
            "get_star_ts": 1669995807
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670125403,
            "star_index": 841489
          },
          "2": {
            "star_index": 843433,
            "get_star_ts": 1670127478
          }
        },
        "4": {
          "1": {
            "star_index": 875728,
            "get_star_ts": 1670132974
          },
          "2": {
            "get_star_ts": 1670133186,
            "star_index": 876795
          }
        },
        "6": {
          "1": {
            "star_index": 1727086,
            "get_star_ts": 1670380292
          },
          "2": {
            "get_star_ts": 1670380730,
            "star_index": 1727523
          }
        },
        "7": {
          "1": {
            "star_index": 2349253,
            "get_star_ts": 1670647457
          },
          "2": {
            "get_star_ts": 1670647637,
            "star_index": 2349383
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670539144,
            "star_index": 2145002
          },
          "2": {
            "star_index": 2687469,
            "get_star_ts": 1670815343
          }
        },
        "10": {
          "1": {
            "star_index": 2619313,
            "get_star_ts": 1670776106
          }
        }
      }
    },
    "2253131": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 143253,
            "get_star_ts": 1669907632
          },
          "2": {
            "star_index": 144199,
            "get_star_ts": 1669907889
          }
        },
        "2": {
          "1": {
            "star_index": 442427,
            "get_star_ts": 1669991080
          },
          "2": {
            "star_index": 446622,
            "get_star_ts": 1669992013
          }
        },
        "3": {
          "1": {
            "star_index": 842482,
            "get_star_ts": 1670126470
          },
          "2": {
            "star_index": 843518,
            "get_star_ts": 1670127561
          }
        },
        "4": {
          "1": {
            "star_index": 3455292,
            "get_star_ts": 1671496861
          },
          "2": {
            "star_index": 3457031,
            "get_star_ts": 1671500946
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1673496708,
            "star_index": 4036048
          },
          "2": {
            "get_star_ts": 1673496881,
            "star_index": 4036057
          }
        }
      },
      "stars": 10,
      "last_star_ts": 1673496881,
      "local_score": 863,
      "id": 2253131,
      "name": "Anna McIntosh"
    },
    "2253146": {
      "last_star_ts": 0,
      "stars": 0,
      "local_score": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": null,
      "id": 2253146
    },
    "2253187": {
      "id": 2253187,
      "name": "trevor-corcoran",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669899957,
            "star_index": 115350
          },
          "2": {
            "get_star_ts": 1669900295,
            "star_index": 116538
          }
        },
        "2": {
          "1": {
            "star_index": 409079,
            "get_star_ts": 1669982862
          },
          "2": {
            "get_star_ts": 1669983169,
            "star_index": 410282
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670158492,
            "star_index": 982711
          },
          "2": {
            "get_star_ts": 1670159348,
            "star_index": 986270
          }
        },
        "4": {
          "1": {
            "star_index": 1125722,
            "get_star_ts": 1670206722
          },
          "2": {
            "star_index": 1127401,
            "get_star_ts": 1670208158
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670277417,
            "star_index": 1391300
          },
          "2": {
            "get_star_ts": 1670292009,
            "star_index": 1422991
          }
        },
        "6": {
          "1": {
            "star_index": 1584078,
            "get_star_ts": 1670330091
          },
          "2": {
            "star_index": 1586897,
            "get_star_ts": 1670330876
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1670330876,
      "local_score": 1340,
      "stars": 12
    },
    "2253198": {
      "completion_day_level": {},
      "global_score": 0,
      "last_star_ts": 0,
      "local_score": 0,
      "stars": 0,
      "id": 2253198,
      "name": "Steven French"
    },
    "2253216": {
      "name": "Jackie Wang",
      "id": 2253216,
      "stars": 50,
      "last_star_ts": 1671946624,
      "local_score": 6852,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 197893,
            "get_star_ts": 1669923163
          },
          "2": {
            "get_star_ts": 1669923949,
            "star_index": 200504
          }
        },
        "2": {
          "1": {
            "star_index": 477438,
            "get_star_ts": 1669999111
          },
          "2": {
            "get_star_ts": 1670000187,
            "star_index": 481755
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670082923,
            "star_index": 739989
          },
          "2": {
            "get_star_ts": 1670084627,
            "star_index": 745782
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670169864,
            "star_index": 1027204
          },
          "2": {
            "get_star_ts": 1670170208,
            "star_index": 1028468
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670270639,
            "star_index": 1365361
          },
          "2": {
            "star_index": 1368916,
            "get_star_ts": 1670271538
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670337834,
            "star_index": 1613607
          },
          "2": {
            "get_star_ts": 1670337981,
            "star_index": 1614154
          }
        },
        "7": {
          "1": {
            "star_index": 1880338,
            "get_star_ts": 1670437801
          },
          "2": {
            "star_index": 1885910,
            "get_star_ts": 1670439804
          }
        },
        "8": {
          "1": {
            "star_index": 2081861,
            "get_star_ts": 1670514990
          },
          "2": {
            "star_index": 2087776,
            "get_star_ts": 1670517082
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670603802,
            "star_index": 2282662
          },
          "2": {
            "get_star_ts": 1670607745,
            "star_index": 2291445
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670687970,
            "star_index": 2454756
          },
          "2": {
            "star_index": 2466208,
            "get_star_ts": 1670693000
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670777991,
            "star_index": 2623699
          },
          "2": {
            "get_star_ts": 1670781594,
            "star_index": 2631882
          }
        },
        "12": {
          "1": {
            "star_index": 2772098,
            "get_star_ts": 1670862064
          },
          "2": {
            "get_star_ts": 1670862324,
            "star_index": 2772593
          }
        },
        "13": {
          "1": {
            "star_index": 2907688,
            "get_star_ts": 1670947318
          },
          "2": {
            "star_index": 2909759,
            "get_star_ts": 1670948583
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671057909,
            "star_index": 3066814
          },
          "2": {
            "star_index": 3069234,
            "get_star_ts": 1671059974
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671119220,
            "star_index": 3136511
          },
          "2": {
            "get_star_ts": 1671124699,
            "star_index": 3143670
          }
        },
        "16": {
          "1": {
            "star_index": 3253082,
            "get_star_ts": 1671247052
          },
          "2": {
            "star_index": 3257910,
            "get_star_ts": 1671256315
          }
        },
        "17": {
          "1": {
            "star_index": 3398539,
            "get_star_ts": 1671420503
          },
          "2": {
            "get_star_ts": 1671423847,
            "star_index": 3399781
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671424797,
            "star_index": 3400126
          },
          "2": {
            "star_index": 3517784,
            "get_star_ts": 1671576399
          }
        },
        "19": {
          "1": {
            "star_index": 3459003,
            "get_star_ts": 1671506241
          },
          "2": {
            "star_index": 3459406,
            "get_star_ts": 1671507246
          }
        },
        "20": {
          "1": {
            "star_index": 3514421,
            "get_star_ts": 1671572460
          },
          "2": {
            "star_index": 3514754,
            "get_star_ts": 1671572850
          }
        },
        "21": {
          "1": {
            "star_index": 3575822,
            "get_star_ts": 1671647487
          },
          "2": {
            "star_index": 3577750,
            "get_star_ts": 1671649837
          }
        },
        "22": {
          "1": {
            "star_index": 3639669,
            "get_star_ts": 1671743920
          },
          "2": {
            "star_index": 3651333,
            "get_star_ts": 1671767967
          }
        },
        "23": {
          "1": {
            "star_index": 3693572,
            "get_star_ts": 1671824010
          },
          "2": {
            "get_star_ts": 1671824189,
            "star_index": 3693688
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1671901243,
            "star_index": 3736183
          },
          "2": {
            "get_star_ts": 1671902660,
            "star_index": 3736934
          }
        },
        "25": {
          "1": {
            "star_index": 3756910,
            "get_star_ts": 1671946611
          },
          "2": {
            "get_star_ts": 1671946624,
            "star_index": 3756935
          }
        }
      },
      "global_score": 0
    },
    "2253287": {
      "name": "Sam Grayson",
      "id": 2253287,
      "last_star_ts": 1673704677,
      "stars": 43,
      "local_score": 5664,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 141941,
            "get_star_ts": 1669907282
          },
          "2": {
            "get_star_ts": 1669908951,
            "star_index": 148300
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670098127,
            "star_index": 789375
          },
          "2": {
            "star_index": 793526,
            "get_star_ts": 1670099531
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670104005,
            "star_index": 806319
          },
          "2": {
            "get_star_ts": 1670106343,
            "star_index": 812834
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670171265,
            "star_index": 1032193
          },
          "2": {
            "get_star_ts": 1670171437,
            "star_index": 1032781
          }
        },
        "5": {
          "1": {
            "star_index": 1153036,
            "get_star_ts": 1670218877
          },
          "2": {
            "get_star_ts": 1670219030,
            "star_index": 1154161
          }
        },
        "6": {
          "1": {
            "star_index": 1611592,
            "get_star_ts": 1670337320
          },
          "2": {
            "get_star_ts": 1670337585,
            "star_index": 1612598
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670446022,
            "star_index": 1903670
          },
          "2": {
            "get_star_ts": 1670447466,
            "star_index": 1908365
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670515908,
            "star_index": 2084454
          },
          "2": {
            "get_star_ts": 1670520490,
            "star_index": 2096949
          }
        },
        "9": {
          "1": {
            "star_index": 2186993,
            "get_star_ts": 1670565796
          },
          "2": {
            "star_index": 2483725,
            "get_star_ts": 1670701546
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670716740,
            "star_index": 2511777
          },
          "2": {
            "get_star_ts": 1670724513,
            "star_index": 2519749
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670792958,
            "star_index": 2657704
          },
          "2": {
            "star_index": 2671431,
            "get_star_ts": 1670799680
          }
        },
        "12": {
          "1": {
            "star_index": 2900060,
            "get_star_ts": 1670942819
          },
          "2": {
            "get_star_ts": 1670944522,
            "star_index": 2902832
          }
        },
        "13": {
          "1": {
            "star_index": 2954651,
            "get_star_ts": 1670978169
          },
          "2": {
            "get_star_ts": 1670983839,
            "star_index": 2958488
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671118683,
            "star_index": 3135808
          },
          "2": {
            "star_index": 3147558,
            "get_star_ts": 1671127779
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671202752,
            "star_index": 3214641
          },
          "2": {
            "get_star_ts": 1671323618,
            "star_index": 3316948
          }
        },
        "16": {
          "1": {
            "star_index": 3441793,
            "get_star_ts": 1671480643
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1671636513,
            "star_index": 3566289
          }
        },
        "18": {
          "1": {
            "get_star_ts": 1671764143,
            "star_index": 3650237
          }
        },
        "20": {
          "1": {
            "star_index": 3741367,
            "get_star_ts": 1671911465
          },
          "2": {
            "get_star_ts": 1671912172,
            "star_index": 3741677
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1671920286,
            "star_index": 3745907
          },
          "2": {
            "get_star_ts": 1671934886,
            "star_index": 3751226
          }
        },
        "22": {
          "1": {
            "star_index": 3753077,
            "get_star_ts": 1671942627
          }
        },
        "23": {
          "1": {
            "star_index": 3780852,
            "get_star_ts": 1671985378
          },
          "2": {
            "get_star_ts": 1671986180,
            "star_index": 3781285
          }
        },
        "24": {
          "1": {
            "get_star_ts": 1673674903,
            "star_index": 4048476
          },
          "2": {
            "get_star_ts": 1673704677,
            "star_index": 4049935
          }
        },
        "25": {
          "1": {
            "star_index": 3810419,
            "get_star_ts": 1672065606
          }
        }
      },
      "global_score": 0
    },
    "2253561": {
      "id": 2253561,
      "name": "Chetsi Khare",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669909008,
            "star_index": 148535
          },
          "2": {
            "get_star_ts": 1669909507,
            "star_index": 150353
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669999352,
            "star_index": 478449
          },
          "2": {
            "star_index": 484347,
            "get_star_ts": 1670000876
          }
        },
        "3": {
          "1": {
            "star_index": 1130125,
            "get_star_ts": 1670210495
          },
          "2": {
            "get_star_ts": 1670353012,
            "star_index": 1664761
          }
        },
        "4": {
          "1": {
            "star_index": 1683526,
            "get_star_ts": 1670358882
          },
          "2": {
            "get_star_ts": 1670366310,
            "star_index": 1705971
          }
        },
        "6": {
          "1": {
            "star_index": 1730486,
            "get_star_ts": 1670383333
          },
          "2": {
            "star_index": 1730732,
            "get_star_ts": 1670383552
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670618067,
            "star_index": 2312188
          },
          "2": {
            "get_star_ts": 1670809677,
            "star_index": 2682862
          }
        }
      },
      "stars": 12,
      "last_star_ts": 1670809677,
      "local_score": 1081
    },
    "2253630": {
      "stars": 50,
      "last_star_ts": 1671972904,
      "local_score": 7285,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669871310,
            "star_index": 6873
          },
          "2": {
            "get_star_ts": 1669871468,
            "star_index": 9023
          }
        },
        "2": {
          "1": {
            "star_index": 274176,
            "get_star_ts": 1669958037
          },
          "2": {
            "star_index": 278473,
            "get_star_ts": 1669958304
          }
        },
        "3": {
          "1": {
            "star_index": 588472,
            "get_star_ts": 1670044847
          },
          "2": {
            "star_index": 600035,
            "get_star_ts": 1670046179
          }
        },
        "4": {
          "1": {
            "star_index": 1040584,
            "get_star_ts": 1670173657
          },
          "2": {
            "get_star_ts": 1670173788,
            "star_index": 1041032
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670218548,
            "star_index": 1150461
          },
          "2": {
            "get_star_ts": 1670218707,
            "star_index": 1151739
          }
        },
        "6": {
          "1": {
            "star_index": 1666114,
            "get_star_ts": 1670353433
          },
          "2": {
            "get_star_ts": 1670353465,
            "star_index": 1666213
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670443801,
            "star_index": 1897562
          },
          "2": {
            "star_index": 1901976,
            "get_star_ts": 1670445501
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670537917,
            "star_index": 2142215
          },
          "2": {
            "get_star_ts": 1670547505,
            "star_index": 2157980
          }
        },
        "9": {
          "1": {
            "star_index": 2287414,
            "get_star_ts": 1670605809
          },
          "2": {
            "star_index": 2287601,
            "get_star_ts": 1670605887
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670687405,
            "star_index": 2453481
          },
          "2": {
            "get_star_ts": 1670695700,
            "star_index": 2471985
          }
        },
        "11": {
          "1": {
            "star_index": 2613711,
            "get_star_ts": 1670773739
          },
          "2": {
            "star_index": 2614861,
            "get_star_ts": 1670774236
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670889374,
            "star_index": 2823247
          },
          "2": {
            "star_index": 2823640,
            "get_star_ts": 1670889687
          }
        },
        "13": {
          "1": {
            "star_index": 2859399,
            "get_star_ts": 1670917444
          },
          "2": {
            "star_index": 2861743,
            "get_star_ts": 1670918823
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1671044530,
            "star_index": 3047405
          },
          "2": {
            "star_index": 3048285,
            "get_star_ts": 1671045148
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671116123,
            "star_index": 3132256
          },
          "2": {
            "get_star_ts": 1671146289,
            "star_index": 3172202
          }
        },
        "16": {
          "1": {
            "star_index": 3245589,
            "get_star_ts": 1671233067
          },
          "2": {
            "star_index": 3249572,
            "get_star_ts": 1671239089
          }
        },
        "17": {
          "1": {
            "star_index": 3312078,
            "get_star_ts": 1671317154
          },
          "2": {
            "get_star_ts": 1671334182,
            "star_index": 3321824
          }
        },
        "18": {
          "1": {
            "star_index": 3357303,
            "get_star_ts": 1671369663
          },
          "2": {
            "star_index": 3359763,
            "get_star_ts": 1671372147
          }
        },
        "19": {
          "1": {
            "star_index": 3459207,
            "get_star_ts": 1671506740
          },
          "2": {
            "get_star_ts": 1671509475,
            "star_index": 3460251
          }
        },
        "20": {
          "1": {
            "star_index": 3467364,
            "get_star_ts": 1671517927
          },
          "2": {
            "get_star_ts": 1671550310,
            "star_index": 3494529
          }
        },
        "21": {
          "1": {
            "star_index": 3529407,
            "get_star_ts": 1671599790
          },
          "2": {
            "get_star_ts": 1671604035,
            "star_index": 3536129
          }
        },
        "22": {
          "1": {
            "star_index": 3629864,
            "get_star_ts": 1671730519
          },
          "2": {
            "star_index": 3693469,
            "get_star_ts": 1671823867
          }
        },
        "23": {
          "1": {
            "star_index": 3692702,
            "get_star_ts": 1671822716
          },
          "2": {
            "get_star_ts": 1671823123,
            "star_index": 3692982
          }
        },
        "24": {
          "1": {
            "star_index": 3733484,
            "get_star_ts": 1671896430
          },
          "2": {
            "get_star_ts": 1671902301,
            "star_index": 3736721
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1671972896,
            "star_index": 3774124
          },
          "2": {
            "star_index": 3774127,
            "get_star_ts": 1671972904
          }
        }
      },
      "global_score": 0,
      "name": "dewhite",
      "id": 2253630
    },
    "2253755": {
      "name": "fretzslalom",
      "id": 2253755,
      "last_star_ts": 1670533861,
      "local_score": 791,
      "stars": 12,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1648664,
            "get_star_ts": 1670347827
          },
          "2": {
            "star_index": 1665658,
            "get_star_ts": 1670353287
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670369272,
            "star_index": 1712310
          },
          "2": {
            "star_index": 1715101,
            "get_star_ts": 1670370913
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670428556,
            "star_index": 1854500
          },
          "2": {
            "get_star_ts": 1670434383,
            "star_index": 1871176
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670437766,
            "star_index": 1880226
          },
          "2": {
            "star_index": 1881110,
            "get_star_ts": 1670438083
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670516853,
            "star_index": 2087118
          },
          "2": {
            "star_index": 2089248,
            "get_star_ts": 1670517627
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670530399,
            "star_index": 2122015
          },
          "2": {
            "star_index": 2131615,
            "get_star_ts": 1670533861
          }
        }
      },
      "global_score": 0
    },
    "2253870": {
      "name": "Morgan",
      "id": 2253870,
      "last_star_ts": 0,
      "stars": 0,
      "local_score": 0,
      "completion_day_level": {},
      "global_score": 0
    },
    "2255133": {
      "last_star_ts": 1669991775,
      "stars": 4,
      "local_score": 456,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669903814,
            "star_index": 128725
          },
          "2": {
            "star_index": 133163,
            "get_star_ts": 1669905000
          }
        },
        "2": {
          "1": {
            "star_index": 442293,
            "get_star_ts": 1669991052
          },
          "2": {
            "get_star_ts": 1669991775,
            "star_index": 445577
          }
        }
      },
      "global_score": 0,
      "name": "Anna Park",
      "id": 2255133
    },
    "2255261": {
      "name": "Alex Rogers",
      "id": 2255261,
      "last_star_ts": 1670310533,
      "stars": 12,
      "local_score": 1590,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 140661,
            "get_star_ts": 1669906941
          },
          "2": {
            "star_index": 141883,
            "get_star_ts": 1669907268
          }
        },
        "2": {
          "1": {
            "star_index": 310112,
            "get_star_ts": 1669963027
          },
          "2": {
            "star_index": 311738,
            "get_star_ts": 1669963399
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670053251,
            "star_index": 626645
          },
          "2": {
            "get_star_ts": 1670054561,
            "star_index": 631083
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670140108,
            "star_index": 900833
          },
          "2": {
            "get_star_ts": 1670141127,
            "star_index": 904459
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670224101,
            "star_index": 1178403
          },
          "2": {
            "star_index": 1179450,
            "get_star_ts": 1670224386
          }
        },
        "6": {
          "1": {
            "star_index": 1495796,
            "get_star_ts": 1670310351
          },
          "2": {
            "star_index": 1496703,
            "get_star_ts": 1670310533
          }
        }
      }
    },
    "2255378": {
      "id": 2255378,
      "name": "John Cox",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 171889,
            "get_star_ts": 1669915518
          },
          "2": {
            "get_star_ts": 1669915572,
            "star_index": 172084
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669992422,
            "star_index": 448564
          },
          "2": {
            "star_index": 449859,
            "get_star_ts": 1669992705
          }
        }
      },
      "last_star_ts": 1669992705,
      "stars": 4,
      "local_score": 393
    },
    "2255597": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 123277,
            "get_star_ts": 1669902288
          },
          "2": {
            "star_index": 123978,
            "get_star_ts": 1669902470
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669959893,
            "star_index": 294437
          },
          "2": {
            "star_index": 298744,
            "get_star_ts": 1669960603
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670373402,
            "star_index": 1718666
          },
          "2": {
            "star_index": 1719327,
            "get_star_ts": 1670373891
          }
        },
        "4": {
          "1": {
            "star_index": 1136018,
            "get_star_ts": 1670215976
          },
          "2": {
            "get_star_ts": 1670218146,
            "star_index": 1147038
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670290412,
            "star_index": 1420793
          },
          "2": {
            "get_star_ts": 1670292635,
            "star_index": 1423823
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670371640,
            "star_index": 1716220
          },
          "2": {
            "star_index": 1716306,
            "get_star_ts": 1670371697
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670443190,
            "star_index": 1895822
          },
          "2": {
            "star_index": 1900598,
            "get_star_ts": 1670445095
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670552182,
            "star_index": 2162482
          },
          "2": {
            "get_star_ts": 1670553785,
            "star_index": 2163976
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670889387,
            "star_index": 2823264
          },
          "2": {
            "star_index": 2823421,
            "get_star_ts": 1670889523
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670810286,
            "star_index": 2683436
          },
          "2": {
            "star_index": 2757584,
            "get_star_ts": 1670854699
          }
        },
        "11": {
          "1": {
            "star_index": 2781546,
            "get_star_ts": 1670867079
          },
          "2": {
            "get_star_ts": 1670867536,
            "star_index": 2782463
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671022428,
            "star_index": 3014274
          },
          "2": {
            "star_index": 3031705,
            "get_star_ts": 1671033892
          }
        }
      },
      "local_score": 2751,
      "last_star_ts": 1671033892,
      "stars": 24,
      "id": 2255597,
      "name": "Chris Cobb"
    },
    "2255602": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 123966,
            "get_star_ts": 1669902466
          },
          "2": {
            "star_index": 125160,
            "get_star_ts": 1669902814
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669987561,
            "star_index": 427595
          },
          "2": {
            "get_star_ts": 1669988046,
            "star_index": 429591
          }
        },
        "3": {
          "1": {
            "star_index": 1024247,
            "get_star_ts": 1670169003
          },
          "2": {
            "get_star_ts": 1670170070,
            "star_index": 1027946
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670197996,
            "star_index": 1114060
          },
          "2": {
            "get_star_ts": 1670198195,
            "star_index": 1114391
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670254936,
            "star_index": 1305118
          },
          "2": {
            "get_star_ts": 1670256875,
            "star_index": 1313169
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670332432,
            "star_index": 1592543
          },
          "2": {
            "get_star_ts": 1670332470,
            "star_index": 1592689
          }
        },
        "7": {
          "1": {
            "star_index": 2152823,
            "get_star_ts": 1670543421
          },
          "2": {
            "star_index": 2154917,
            "get_star_ts": 1670544960
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670521440,
            "star_index": 2099394
          },
          "2": {
            "get_star_ts": 1670527822,
            "star_index": 2115387
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670790491,
            "star_index": 2651954
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670688188,
            "star_index": 2455277
          },
          "2": {
            "get_star_ts": 1670691035,
            "star_index": 2461884
          }
        }
      },
      "stars": 19,
      "last_star_ts": 1670790491,
      "local_score": 2267,
      "id": 2255602,
      "name": "Tom-Slalom"
    },
    "2255935": {
      "last_star_ts": 1670332638,
      "stars": 10,
      "local_score": 1007,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 206224,
            "get_star_ts": 1669925631
          },
          "2": {
            "star_index": 206347,
            "get_star_ts": 1669925669
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670018804,
            "star_index": 540833
          },
          "2": {
            "get_star_ts": 1670022873,
            "star_index": 550958
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670079011,
            "star_index": 726146
          },
          "2": {
            "star_index": 729243,
            "get_star_ts": 1670079874
          }
        },
        "4": {
          "1": {
            "star_index": 1013690,
            "get_star_ts": 1670166141
          },
          "2": {
            "get_star_ts": 1670187897,
            "star_index": 1088523
          }
        },
        "6": {
          "1": {
            "star_index": 1592455,
            "get_star_ts": 1670332403
          },
          "2": {
            "get_star_ts": 1670332638,
            "star_index": 1593301
          }
        }
      },
      "global_score": 0,
      "name": "Chazz Hall",
      "id": 2255935
    },
    "2256048": {
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Helena Chern",
      "id": 2256048
    },
    "2256140": {
      "name": "Morgan Goldberg Halinski",
      "id": 2256140,
      "last_star_ts": 1671120165,
      "local_score": 1078,
      "stars": 11,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669913278,
            "star_index": 164006
          },
          "2": {
            "star_index": 164613,
            "get_star_ts": 1669913457
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669989177,
            "star_index": 434323
          },
          "2": {
            "get_star_ts": 1669989812,
            "star_index": 436967
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670269485,
            "star_index": 1360851
          },
          "2": {
            "star_index": 1421084,
            "get_star_ts": 1670290626
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670253159,
            "star_index": 1297958
          },
          "2": {
            "get_star_ts": 1670254784,
            "star_index": 1304478
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670337104,
            "star_index": 1610680
          },
          "2": {
            "get_star_ts": 1670338061,
            "star_index": 1614456
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1671120165,
            "star_index": 3137835
          }
        }
      },
      "global_score": 0
    },
    "2256609": {
      "last_star_ts": 0,
      "local_score": 0,
      "stars": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Bishal Niroula",
      "id": 2256609
    },
    "2258496": {
      "local_score": 1450,
      "last_star_ts": 1670626013,
      "stars": 14,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669905302,
            "star_index": 134317
          },
          "2": {
            "star_index": 135702,
            "get_star_ts": 1669905658
          }
        },
        "2": {
          "1": {
            "star_index": 429248,
            "get_star_ts": 1669987960
          },
          "2": {
            "star_index": 430950,
            "get_star_ts": 1669988378
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670099985,
            "star_index": 794865
          },
          "2": {
            "get_star_ts": 1670100665,
            "star_index": 796875
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670184960,
            "star_index": 1078820
          },
          "2": {
            "get_star_ts": 1670185258,
            "star_index": 1079817
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670299585,
            "star_index": 1432953
          },
          "2": {
            "star_index": 1434525,
            "get_star_ts": 1670300920
          }
        },
        "6": {
          "1": {
            "star_index": 2260357,
            "get_star_ts": 1670594851
          },
          "2": {
            "star_index": 2260814,
            "get_star_ts": 1670595034
          }
        },
        "7": {
          "1": {
            "star_index": 2326641,
            "get_star_ts": 1670625499
          },
          "2": {
            "star_index": 2327583,
            "get_star_ts": 1670626013
          }
        }
      },
      "name": "petercdelaney",
      "id": 2258496
    },
    "2260011": {
      "id": 2260011,
      "name": "Davis Palmie",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669937895,
            "star_index": 241342
          },
          "2": {
            "star_index": 242551,
            "get_star_ts": 1669938570
          }
        },
        "2": {
          "1": {
            "star_index": 389523,
            "get_star_ts": 1669978146
          },
          "2": {
            "star_index": 391591,
            "get_star_ts": 1669978581
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670114650,
            "star_index": 829355
          },
          "2": {
            "star_index": 988194,
            "get_star_ts": 1670159825
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670160583,
            "star_index": 991322
          },
          "2": {
            "get_star_ts": 1670160765,
            "star_index": 992111
          }
        },
        "5": {
          "1": {
            "star_index": 1427531,
            "get_star_ts": 1670295338
          },
          "2": {
            "get_star_ts": 1670295822,
            "star_index": 1428207
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670418491,
            "star_index": 1825581
          },
          "2": {
            "get_star_ts": 1670418512,
            "star_index": 1825641
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670442967,
            "star_index": 1895135
          },
          "2": {
            "get_star_ts": 1672180921,
            "star_index": 3849729
          }
        }
      },
      "stars": 14,
      "last_star_ts": 1672180921,
      "local_score": 1435
    },
    "2261385": {
      "stars": 25,
      "last_star_ts": 1670981967,
      "local_score": 2937,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 160649,
            "get_star_ts": 1669912329
          },
          "2": {
            "star_index": 162954,
            "get_star_ts": 1669912979
          }
        },
        "2": {
          "1": {
            "star_index": 449002,
            "get_star_ts": 1669992522
          },
          "2": {
            "star_index": 450574,
            "get_star_ts": 1669992868
          }
        },
        "3": {
          "1": {
            "star_index": 883704,
            "get_star_ts": 1670134918
          },
          "2": {
            "star_index": 1016697,
            "get_star_ts": 1670166946
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670197934,
            "star_index": 1113964
          },
          "2": {
            "star_index": 1114936,
            "get_star_ts": 1670198520
          }
        },
        "5": {
          "1": {
            "star_index": 1673616,
            "get_star_ts": 1670355805
          },
          "2": {
            "star_index": 1676028,
            "get_star_ts": 1670356544
          }
        },
        "6": {
          "1": {
            "star_index": 1680684,
            "get_star_ts": 1670358002
          },
          "2": {
            "get_star_ts": 1670358083,
            "star_index": 1680935
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670400309,
            "star_index": 1774226
          },
          "2": {
            "star_index": 1776165,
            "get_star_ts": 1670400996
          }
        },
        "8": {
          "1": {
            "star_index": 2071345,
            "get_star_ts": 1670511379
          },
          "2": {
            "star_index": 2077699,
            "get_star_ts": 1670513566
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670618027,
            "star_index": 2312095
          },
          "2": {
            "get_star_ts": 1670797596,
            "star_index": 2667621
          }
        },
        "10": {
          "1": {
            "star_index": 2670742,
            "get_star_ts": 1670799271
          },
          "2": {
            "star_index": 2674211,
            "get_star_ts": 1670801525
          }
        },
        "11": {
          "1": {
            "star_index": 2676907,
            "get_star_ts": 1670803666
          },
          "2": {
            "star_index": 2766587,
            "get_star_ts": 1670859276
          }
        },
        "12": {
          "1": {
            "star_index": 2782863,
            "get_star_ts": 1670867748
          },
          "2": {
            "get_star_ts": 1670868679,
            "star_index": 2784584
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1670981967,
            "star_index": 2957317
          }
        }
      },
      "name": "Thomas Petrick",
      "id": 2261385
    },
    "2262456": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 12415,
            "get_star_ts": 1669871792
          },
          "2": {
            "star_index": 21532,
            "get_star_ts": 1669873536
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669959065,
            "star_index": 287737
          },
          "2": {
            "get_star_ts": 1669960223,
            "star_index": 296508
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670052424,
            "star_index": 623932
          },
          "2": {
            "star_index": 625972,
            "get_star_ts": 1670053044
          }
        },
        "4": {
          "1": {
            "star_index": 1117235,
            "get_star_ts": 1670200069
          },
          "2": {
            "star_index": 1131100,
            "get_star_ts": 1670211357
          }
        },
        "5": {
          "1": {
            "star_index": 1161739,
            "get_star_ts": 1670220227
          },
          "2": {
            "star_index": 1170327,
            "get_star_ts": 1670222001
          }
        },
        "6": {
          "1": {
            "star_index": 1606171,
            "get_star_ts": 1670335968
          },
          "2": {
            "get_star_ts": 1670337888,
            "star_index": 1613796
          }
        }
      },
      "local_score": 1546,
      "last_star_ts": 1670337888,
      "stars": 12,
      "id": 2262456,
      "name": "JoshPDavis"
    },
    "2265557": {
      "global_score": 0,
      "completion_day_level": {},
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "id": 2265557,
      "name": "Mark Podojil"
    },
    "2266717": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669906293,
            "star_index": 138174
          },
          "2": {
            "get_star_ts": 1669906352,
            "star_index": 138407
          }
        },
        "2": {
          "1": {
            "star_index": 448680,
            "get_star_ts": 1669992447
          },
          "2": {
            "star_index": 451076,
            "get_star_ts": 1669992978
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1669992978,
      "local_score": 434,
      "stars": 4,
      "id": 2266717,
      "name": "Evan H"
    },
    "2295100": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 7188,
            "get_star_ts": 1669871333
          },
          "2": {
            "get_star_ts": 1669872290,
            "star_index": 15876
          }
        },
        "2": {
          "1": {
            "star_index": 288273,
            "get_star_ts": 1669959124
          },
          "2": {
            "get_star_ts": 1669960470,
            "star_index": 297946
          }
        },
        "3": {
          "1": {
            "star_index": 603798,
            "get_star_ts": 1670046845
          },
          "2": {
            "get_star_ts": 1670048496,
            "star_index": 610809
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670131668,
            "star_index": 867032
          },
          "2": {
            "get_star_ts": 1670133713,
            "star_index": 879202
          }
        },
        "5": {
          "1": {
            "star_index": 1153883,
            "get_star_ts": 1670218990
          },
          "2": {
            "star_index": 1159259,
            "get_star_ts": 1670219799
          }
        },
        "6": {
          "1": {
            "star_index": 1457476,
            "get_star_ts": 1670303907
          },
          "2": {
            "get_star_ts": 1670303969,
            "star_index": 1458352
          }
        }
      },
      "stars": 12,
      "last_star_ts": 1670303969,
      "local_score": 1729,
      "id": 2295100,
      "name": "tfossum-bingo"
    },
    "2305886": {
      "stars": 16,
      "last_star_ts": 1670533307,
      "local_score": 2190,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669885760,
            "star_index": 64318
          },
          "2": {
            "get_star_ts": 1669886315,
            "star_index": 66706
          }
        },
        "2": {
          "1": {
            "star_index": 382947,
            "get_star_ts": 1669976796
          },
          "2": {
            "star_index": 398750,
            "get_star_ts": 1669980224
          }
        },
        "3": {
          "1": {
            "star_index": 682156,
            "get_star_ts": 1670067250
          },
          "2": {
            "star_index": 694493,
            "get_star_ts": 1670070432
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670150179,
            "star_index": 945355
          },
          "2": {
            "star_index": 950205,
            "get_star_ts": 1670151144
          }
        },
        "5": {
          "1": {
            "star_index": 1242964,
            "get_star_ts": 1670238940
          },
          "2": {
            "get_star_ts": 1670240520,
            "star_index": 1248972
          }
        },
        "6": {
          "1": {
            "star_index": 1555444,
            "get_star_ts": 1670322143
          },
          "2": {
            "get_star_ts": 1670322171,
            "star_index": 1555570
          }
        },
        "7": {
          "1": {
            "star_index": 1804099,
            "get_star_ts": 1670410342
          },
          "2": {
            "star_index": 1804277,
            "get_star_ts": 1670410406
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670503551,
            "star_index": 2049474
          },
          "2": {
            "star_index": 2130118,
            "get_star_ts": 1670533307
          }
        }
      },
      "global_score": 0,
      "name": "hunter k",
      "id": 2305886
    },
    "2309714": {
      "global_score": 0,
      "completion_day_level": {},
      "last_star_ts": 0,
      "stars": 0,
      "local_score": 0,
      "id": 2309714,
      "name": "Angelena Wilson"
    },
    "2310813": {
      "id": 2310813,
      "name": "Jared Schwartz",
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 232023,
            "get_star_ts": 1669933825
          },
          "2": {
            "get_star_ts": 1669934141,
            "star_index": 232918
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670017160,
            "star_index": 536113
          },
          "2": {
            "get_star_ts": 1670017994,
            "star_index": 538458
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670264716,
            "star_index": 1342933
          },
          "2": {
            "star_index": 1358846,
            "get_star_ts": 1670268970
          }
        },
        "4": {
          "1": {
            "star_index": 1901986,
            "get_star_ts": 1670445504
          },
          "2": {
            "get_star_ts": 1670445594,
            "star_index": 1902302
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670338391,
            "star_index": 1615773
          },
          "2": {
            "get_star_ts": 1670350565,
            "star_index": 1657012
          }
        }
      },
      "stars": 10,
      "last_star_ts": 1670445594,
      "local_score": 788
    },
    "2325318": {
      "last_star_ts": 0,
      "local_score": 0,
      "stars": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Allison Moberg",
      "id": 2325318
    },
    "2326955": {
      "name": "Adriana Gutierrez Sureza",
      "id": 2326955,
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "completion_day_level": {},
      "global_score": 0
    },
    "2331982": {
      "name": "Jim Wooley",
      "id": 2331982,
      "stars": 10,
      "last_star_ts": 1670475565,
      "local_score": 804,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 257774,
            "get_star_ts": 1669949887
          },
          "2": {
            "get_star_ts": 1669951676,
            "star_index": 259866
          }
        },
        "2": {
          "1": {
            "star_index": 576306,
            "get_star_ts": 1670043771
          },
          "2": {
            "get_star_ts": 1670046821,
            "star_index": 603669
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670125190,
            "star_index": 841256
          },
          "2": {
            "get_star_ts": 1670126624,
            "star_index": 842639
          }
        },
        "4": {
          "1": {
            "star_index": 1071289,
            "get_star_ts": 1670182689
          },
          "2": {
            "get_star_ts": 1670189376,
            "star_index": 1093206
          }
        },
        "6": {
          "1": {
            "star_index": 1953729,
            "get_star_ts": 1670474098
          },
          "2": {
            "star_index": 1955239,
            "get_star_ts": 1670475565
          }
        }
      }
    },
    "2339631": {
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669925714,
            "star_index": 206507
          },
          "2": {
            "get_star_ts": 1669926174,
            "star_index": 208034
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670020549,
            "star_index": 545485
          },
          "2": {
            "get_star_ts": 1670021923,
            "star_index": 548880
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670047459,
            "star_index": 606662
          },
          "2": {
            "get_star_ts": 1670048653,
            "star_index": 611425
          }
        },
        "4": {
          "1": {
            "star_index": 865216,
            "get_star_ts": 1670131473
          },
          "2": {
            "star_index": 872207,
            "get_star_ts": 1670132360
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670700555,
            "star_index": 2481930
          },
          "2": {
            "get_star_ts": 1670703121,
            "star_index": 2486882
          }
        },
        "6": {
          "1": {
            "star_index": 2490814,
            "get_star_ts": 1670705159
          },
          "2": {
            "get_star_ts": 1670706247,
            "star_index": 2492935
          }
        },
        "7": {
          "1": {
            "star_index": 4052230,
            "get_star_ts": 1673732991
          },
          "2": {
            "star_index": 4052314,
            "get_star_ts": 1673734018
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670800021,
            "star_index": 2671971
          },
          "2": {
            "get_star_ts": 1670803797,
            "star_index": 2677054
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671063470,
            "star_index": 3072455
          },
          "2": {
            "star_index": 3073546,
            "get_star_ts": 1671064953
          }
        },
        "10": {
          "1": {
            "star_index": 2688582,
            "get_star_ts": 1670816731
          },
          "2": {
            "star_index": 3076469,
            "get_star_ts": 1671069662
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1671508180,
            "star_index": 3459738
          },
          "2": {
            "star_index": 4013643,
            "get_star_ts": 1673227019
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1672195231,
            "star_index": 3853287
          },
          "2": {
            "star_index": 3854114,
            "get_star_ts": 1672200051
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671163343,
            "star_index": 3182523
          },
          "2": {
            "get_star_ts": 1671330209,
            "star_index": 3320186
          }
        },
        "14": {
          "1": {
            "star_index": 4005057,
            "get_star_ts": 1673136209
          },
          "2": {
            "get_star_ts": 1673139490,
            "star_index": 4005317
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1673145617,
            "star_index": 4005691
          },
          "2": {
            "get_star_ts": 1673235154,
            "star_index": 4014143
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1671415730,
            "star_index": 3396659
          }
        },
        "18": {
          "1": {
            "star_index": 3454784,
            "get_star_ts": 1671495852
          },
          "2": {
            "get_star_ts": 1673724036,
            "star_index": 4051461
          }
        },
        "19": {
          "1": {
            "get_star_ts": 1673751027,
            "star_index": 4053377
          }
        },
        "21": {
          "1": {
            "star_index": 3583829,
            "get_star_ts": 1671657133
          },
          "2": {
            "star_index": 3638911,
            "get_star_ts": 1671742930
          }
        },
        "25": {
          "1": {
            "star_index": 3824006,
            "get_star_ts": 1672096407
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1673751027,
      "local_score": 4273,
      "stars": 37,
      "id": 2339631,
      "name": "Jackson Reeves"
    },
    "2340007": {
      "local_score": 3023,
      "last_star_ts": 1673757165,
      "stars": 27,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669945202,
            "star_index": 252144
          },
          "2": {
            "star_index": 253128,
            "get_star_ts": 1669946011
          }
        },
        "2": {
          "1": {
            "star_index": 561287,
            "get_star_ts": 1670029106
          },
          "2": {
            "get_star_ts": 1670042432,
            "star_index": 575001
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670045877,
            "star_index": 597908
          },
          "2": {
            "get_star_ts": 1670047099,
            "star_index": 605059
          }
        },
        "4": {
          "1": {
            "star_index": 1076697,
            "get_star_ts": 1670184336
          },
          "2": {
            "get_star_ts": 1670184485,
            "star_index": 1077199
          }
        },
        "5": {
          "1": {
            "star_index": 1343382,
            "get_star_ts": 1670264833
          },
          "2": {
            "star_index": 1346353,
            "get_star_ts": 1670265641
          }
        },
        "6": {
          "1": {
            "star_index": 1456247,
            "get_star_ts": 1670303825
          },
          "2": {
            "get_star_ts": 1670303922,
            "star_index": 1457711
          }
        },
        "8": {
          "1": {
            "star_index": 3524909,
            "get_star_ts": 1671591575
          },
          "2": {
            "star_index": 3525759,
            "get_star_ts": 1671594058
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670986074,
            "star_index": 2959890
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1671632657,
            "star_index": 3562616
          },
          "2": {
            "get_star_ts": 1671635502,
            "star_index": 3565308
          }
        },
        "11": {
          "1": {
            "star_index": 3828118,
            "get_star_ts": 1672112500
          },
          "2": {
            "get_star_ts": 1672245195,
            "star_index": 3865125
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1672857801,
            "star_index": 3973479
          },
          "2": {
            "star_index": 3973551,
            "get_star_ts": 1672858210
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1672946765,
            "star_index": 3984648
          },
          "2": {
            "get_star_ts": 1672949224,
            "star_index": 3984995
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1673320896,
            "star_index": 4021961
          },
          "2": {
            "get_star_ts": 1673360284,
            "star_index": 4024625
          }
        },
        "16": {
          "1": {
            "star_index": 4053557,
            "get_star_ts": 1673755011
          },
          "2": {
            "get_star_ts": 1673757165,
            "star_index": 4053639
          }
        }
      },
      "name": "Evan Schaeffer",
      "id": 2340007
    },
    "2342115": {
      "name": "lance-grady",
      "id": 2342115,
      "last_star_ts": 1670990565,
      "stars": 24,
      "local_score": 2688,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669871227,
            "star_index": 5469
          },
          "2": {
            "star_index": 11902,
            "get_star_ts": 1669871733
          }
        },
        "2": {
          "1": {
            "star_index": 483345,
            "get_star_ts": 1670000592
          },
          "2": {
            "star_index": 483797,
            "get_star_ts": 1670000724
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670080584,
            "star_index": 731723
          },
          "2": {
            "star_index": 735164,
            "get_star_ts": 1670081562
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670167516,
            "star_index": 1018785
          },
          "2": {
            "star_index": 1019926,
            "get_star_ts": 1670167819
          }
        },
        "5": {
          "1": {
            "star_index": 2522299,
            "get_star_ts": 1670727881
          },
          "2": {
            "get_star_ts": 1670728134,
            "star_index": 2522486
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670728874,
            "star_index": 2523058
          },
          "2": {
            "get_star_ts": 1670729052,
            "star_index": 2523204
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670775705,
            "star_index": 2618366
          },
          "2": {
            "get_star_ts": 1670776625,
            "star_index": 2620487
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670780087,
            "star_index": 2628584
          },
          "2": {
            "get_star_ts": 1670781470,
            "star_index": 2631594
          }
        },
        "9": {
          "1": {
            "star_index": 2635580,
            "get_star_ts": 1670783248
          },
          "2": {
            "get_star_ts": 1670785208,
            "star_index": 2639841
          }
        },
        "10": {
          "1": {
            "star_index": 2645284,
            "get_star_ts": 1670787608
          },
          "2": {
            "get_star_ts": 1670788931,
            "star_index": 2648279
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670892806,
            "star_index": 2826646
          },
          "2": {
            "get_star_ts": 1670895250,
            "star_index": 2828654
          }
        },
        "12": {
          "1": {
            "star_index": 2961737,
            "get_star_ts": 1670988978
          },
          "2": {
            "get_star_ts": 1670990565,
            "star_index": 2962825
          }
        }
      },
      "global_score": 0
    },
    "2346547": {
      "stars": 8,
      "last_star_ts": 1670445440,
      "local_score": 470,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1648163,
            "get_star_ts": 1670347665
          },
          "2": {
            "get_star_ts": 1670347727,
            "star_index": 1648374
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670357169,
            "star_index": 1678112
          },
          "2": {
            "get_star_ts": 1670362842,
            "star_index": 1696110
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670426012,
            "star_index": 1846892
          },
          "2": {
            "get_star_ts": 1670429707,
            "star_index": 1857836
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670441705,
            "star_index": 1891469
          },
          "2": {
            "star_index": 1901742,
            "get_star_ts": 1670445440
          }
        }
      },
      "name": null,
      "id": 2346547
    },
    "2357230": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 28605,
            "get_star_ts": 1669875744
          },
          "2": {
            "star_index": 29814,
            "get_star_ts": 1669876130
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669958020,
            "star_index": 273915
          },
          "2": {
            "get_star_ts": 1669958465,
            "star_index": 280819
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670044317,
            "star_index": 581658
          },
          "2": {
            "get_star_ts": 1670044876,
            "star_index": 588803
          }
        },
        "4": {
          "1": {
            "star_index": 861008,
            "get_star_ts": 1670131097
          },
          "2": {
            "star_index": 864966,
            "get_star_ts": 1670131448
          }
        },
        "5": {
          "1": {
            "star_index": 1151163,
            "get_star_ts": 1670218634
          },
          "2": {
            "get_star_ts": 1670219563,
            "star_index": 1157865
          }
        },
        "6": {
          "1": {
            "star_index": 1598469,
            "get_star_ts": 1670334013
          },
          "2": {
            "star_index": 1598698,
            "get_star_ts": 1670334074
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670562882,
            "star_index": 2173011
          }
        }
      },
      "last_star_ts": 1670562882,
      "stars": 13,
      "local_score": 1867,
      "id": 2357230,
      "name": "Connie Reynolds"
    },
    "2426360": {
      "name": "Larry Anderson",
      "id": 2426360,
      "local_score": 376,
      "last_star_ts": 1669997932,
      "stars": 4,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 161144,
            "get_star_ts": 1669912466
          },
          "2": {
            "star_index": 163027,
            "get_star_ts": 1669912997
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669994582,
            "star_index": 458187
          },
          "2": {
            "star_index": 472629,
            "get_star_ts": 1669997932
          }
        }
      },
      "global_score": 0
    },
    "2430506": {
      "last_star_ts": 1673638020,
      "stars": 42,
      "local_score": 4766,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669922461,
            "star_index": 195550
          },
          "2": {
            "get_star_ts": 1669923146,
            "star_index": 197833
          }
        },
        "2": {
          "1": {
            "star_index": 2083145,
            "get_star_ts": 1670515440
          },
          "2": {
            "star_index": 2086479,
            "get_star_ts": 1670516637
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670528304,
            "star_index": 2116543
          },
          "2": {
            "get_star_ts": 1670530770,
            "star_index": 2123058
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670533260,
            "star_index": 2129988
          },
          "2": {
            "star_index": 2132572,
            "get_star_ts": 1670534219
          }
        },
        "5": {
          "1": {
            "star_index": 2140390,
            "get_star_ts": 1670537172
          },
          "2": {
            "get_star_ts": 1670539166,
            "star_index": 2145050
          }
        },
        "6": {
          "1": {
            "star_index": 2265935,
            "get_star_ts": 1670597037
          },
          "2": {
            "get_star_ts": 1670597076,
            "star_index": 2266025
          }
        },
        "7": {
          "1": {
            "star_index": 2286090,
            "get_star_ts": 1670605226
          },
          "2": {
            "star_index": 2287810,
            "get_star_ts": 1670605989
          }
        },
        "8": {
          "1": {
            "star_index": 2810079,
            "get_star_ts": 1670881429
          },
          "2": {
            "get_star_ts": 1670883796,
            "star_index": 2814819
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670951337,
            "star_index": 2914351
          },
          "2": {
            "get_star_ts": 1670955768,
            "star_index": 2921464
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670958152,
            "star_index": 2925365
          },
          "2": {
            "star_index": 2935369,
            "get_star_ts": 1670964197
          }
        },
        "11": {
          "1": {
            "star_index": 2945471,
            "get_star_ts": 1670970059
          },
          "2": {
            "star_index": 3038027,
            "get_star_ts": 1671037975
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1671217941,
            "star_index": 3230265
          },
          "2": {
            "star_index": 3231356,
            "get_star_ts": 1671219034
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1671555792,
            "star_index": 3499635
          },
          "2": {
            "get_star_ts": 1671562799,
            "star_index": 3505626
          }
        },
        "14": {
          "1": {
            "star_index": 3568801,
            "get_star_ts": 1671639104
          },
          "2": {
            "get_star_ts": 1671640316,
            "star_index": 3569869
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671661437,
            "star_index": 3587495
          },
          "2": {
            "star_index": 3628929,
            "get_star_ts": 1671729283
          }
        },
        "17": {
          "1": {
            "star_index": 4032836,
            "get_star_ts": 1673456988
          }
        },
        "18": {
          "1": {
            "star_index": 3642362,
            "get_star_ts": 1671747427
          },
          "2": {
            "get_star_ts": 1672248100,
            "star_index": 3866239
          }
        },
        "21": {
          "1": {
            "get_star_ts": 1671730268,
            "star_index": 3629660
          },
          "2": {
            "get_star_ts": 1671738920,
            "star_index": 3635834
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1672944233,
            "star_index": 3984285
          },
          "2": {
            "get_star_ts": 1673374287,
            "star_index": 4026154
          }
        },
        "23": {
          "1": {
            "star_index": 4041220,
            "get_star_ts": 1673562917
          },
          "2": {
            "star_index": 4041244,
            "get_star_ts": 1673563110
          }
        },
        "24": {
          "1": {
            "star_index": 4045600,
            "get_star_ts": 1673631134
          },
          "2": {
            "star_index": 4045718,
            "get_star_ts": 1673632309
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1673638020,
            "star_index": 4046174
          }
        }
      },
      "global_score": 0,
      "name": "aluaders",
      "id": 2430506
    },
    "2432361": {
      "name": "jackdalmolin",
      "id": 2432361,
      "local_score": 280,
      "last_star_ts": 1670535527,
      "stars": 4,
      "global_score": 0,
      "completion_day_level": {
        "2": {
          "1": {
            "get_star_ts": 1670006789,
            "star_index": 504716
          },
          "2": {
            "get_star_ts": 1670007832,
            "star_index": 508009
          }
        },
        "3": {
          "1": {
            "star_index": 2129156,
            "get_star_ts": 1670532957
          },
          "2": {
            "get_star_ts": 1670535527,
            "star_index": 2136161
          }
        }
      }
    },
    "2434371": {
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669914964,
            "star_index": 169888
          },
          "2": {
            "get_star_ts": 1669918710,
            "star_index": 183201
          }
        },
        "2": {
          "1": {
            "star_index": 1303149,
            "get_star_ts": 1670254453
          },
          "2": {
            "star_index": 1306871,
            "get_star_ts": 1670255350
          }
        }
      },
      "local_score": 294,
      "last_star_ts": 1670255350,
      "stars": 4,
      "id": 2434371,
      "name": "Luke Simpson"
    },
    "2435747": {
      "last_star_ts": 1670445602,
      "stars": 12,
      "local_score": 1020,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 178262,
            "get_star_ts": 1669917308
          },
          "2": {
            "get_star_ts": 1669917666,
            "star_index": 179570
          }
        },
        "2": {
          "1": {
            "star_index": 441373,
            "get_star_ts": 1669990838
          },
          "2": {
            "get_star_ts": 1669992222,
            "star_index": 447608
          }
        },
        "3": {
          "1": {
            "star_index": 1731655,
            "get_star_ts": 1670384419
          },
          "2": {
            "get_star_ts": 1670384985,
            "star_index": 1732211
          }
        },
        "4": {
          "1": {
            "star_index": 1864858,
            "get_star_ts": 1670432163
          },
          "2": {
            "get_star_ts": 1670432737,
            "star_index": 1866552
          }
        },
        "5": {
          "1": {
            "star_index": 1891742,
            "get_star_ts": 1670441798
          },
          "2": {
            "get_star_ts": 1670442530,
            "star_index": 1893853
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670445449,
            "star_index": 1901771
          },
          "2": {
            "star_index": 1902335,
            "get_star_ts": 1670445602
          }
        }
      },
      "global_score": 0,
      "name": "whatleymd",
      "id": 2435747
    },
    "2437579": {
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 146558,
            "get_star_ts": 1669908490
          },
          "2": {
            "star_index": 146996,
            "get_star_ts": 1669908601
          }
        },
        "2": {
          "1": {
            "star_index": 281016,
            "get_star_ts": 1669958481
          },
          "2": {
            "get_star_ts": 1669958796,
            "star_index": 284955
          }
        },
        "3": {
          "1": {
            "star_index": 597109,
            "get_star_ts": 1670045764
          },
          "2": {
            "get_star_ts": 1670046551,
            "star_index": 602241
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670131470,
            "star_index": 865179
          },
          "2": {
            "star_index": 865983,
            "get_star_ts": 1670131552
          }
        },
        "5": {
          "1": {
            "star_index": 1153006,
            "get_star_ts": 1670218873
          },
          "2": {
            "get_star_ts": 1670219147,
            "star_index": 1155002
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670307685,
            "star_index": 1483250
          },
          "2": {
            "star_index": 1483727,
            "get_star_ts": 1670307784
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670393604,
            "star_index": 1753083
          },
          "2": {
            "get_star_ts": 1670395531,
            "star_index": 1760152
          }
        },
        "8": {
          "1": {
            "star_index": 1987154,
            "get_star_ts": 1670482469
          },
          "2": {
            "star_index": 1995191,
            "get_star_ts": 1670485055
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670609422,
            "star_index": 2294778
          },
          "2": {
            "get_star_ts": 1670625022,
            "star_index": 2325790
          }
        },
        "10": {
          "1": {
            "star_index": 2365475,
            "get_star_ts": 1670651320
          },
          "2": {
            "star_index": 2371610,
            "get_star_ts": 1670653113
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670740859,
            "star_index": 2544168
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1670740859,
      "stars": 21,
      "local_score": 3028,
      "id": 2437579,
      "name": "Alex Sieland"
    },
    "2439864": {
      "id": 2439864,
      "name": "Samia Khan",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669909754,
            "star_index": 151269
          },
          "2": {
            "get_star_ts": 1669909833,
            "star_index": 151545
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1669909833,
      "stars": 2,
      "local_score": 205
    },
    "2440673": {
      "local_score": 6476,
      "last_star_ts": 1671985070,
      "stars": 50,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 187767,
            "get_star_ts": 1669920079
          },
          "2": {
            "star_index": 190908,
            "get_star_ts": 1669921028
          }
        },
        "2": {
          "1": {
            "star_index": 470961,
            "get_star_ts": 1669997525
          },
          "2": {
            "get_star_ts": 1669999521,
            "star_index": 479170
          }
        },
        "3": {
          "1": {
            "star_index": 820492,
            "get_star_ts": 1670109521
          },
          "2": {
            "get_star_ts": 1670114713,
            "star_index": 829465
          }
        },
        "4": {
          "1": {
            "star_index": 1032986,
            "get_star_ts": 1670171495
          },
          "2": {
            "get_star_ts": 1670172030,
            "star_index": 1034833
          }
        },
        "5": {
          "1": {
            "star_index": 1323206,
            "get_star_ts": 1670259371
          },
          "2": {
            "get_star_ts": 1670261893,
            "star_index": 1332733
          }
        },
        "6": {
          "1": {
            "star_index": 1619934,
            "get_star_ts": 1670339498
          },
          "2": {
            "star_index": 1622194,
            "get_star_ts": 1670340103
          }
        },
        "7": {
          "1": {
            "star_index": 2498883,
            "get_star_ts": 1670709258
          },
          "2": {
            "star_index": 2503531,
            "get_star_ts": 1670711653
          }
        },
        "8": {
          "1": {
            "star_index": 2519482,
            "get_star_ts": 1670724149
          },
          "2": {
            "star_index": 2648187,
            "get_star_ts": 1670788890
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1670962505,
            "star_index": 2932419
          },
          "2": {
            "star_index": 2932880,
            "get_star_ts": 1670962784
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1670810828,
            "star_index": 2683910
          },
          "2": {
            "get_star_ts": 1670818062,
            "star_index": 2689577
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1670797153,
            "star_index": 2666713
          },
          "2": {
            "get_star_ts": 1670806118,
            "star_index": 2679562
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1670974560,
            "star_index": 2951430
          },
          "2": {
            "star_index": 2951437,
            "get_star_ts": 1670974570
          }
        },
        "13": {
          "1": {
            "star_index": 2947291,
            "get_star_ts": 1670971282
          },
          "2": {
            "get_star_ts": 1670971295,
            "star_index": 2947308
          }
        },
        "14": {
          "1": {
            "star_index": 3458425,
            "get_star_ts": 1671504564
          },
          "2": {
            "get_star_ts": 1671504603,
            "star_index": 3458436
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1671553169,
            "star_index": 3497147
          },
          "2": {
            "get_star_ts": 1671553243,
            "star_index": 3497221
          }
        },
        "16": {
          "1": {
            "star_index": 3586167,
            "get_star_ts": 1671659870
          },
          "2": {
            "star_index": 3586813,
            "get_star_ts": 1671660632
          }
        },
        "17": {
          "1": {
            "get_star_ts": 1671661165,
            "star_index": 3587282
          },
          "2": {
            "star_index": 3587580,
            "get_star_ts": 1671661552
          }
        },
        "18": {
          "1": {
            "star_index": 3588062,
            "get_star_ts": 1671662165
          },
          "2": {
            "star_index": 3588152,
            "get_star_ts": 1671662288
          }
        },
        "19": {
          "1": {
            "star_index": 3593345,
            "get_star_ts": 1671672168
          },
          "2": {
            "star_index": 3593419,
            "get_star_ts": 1671672415
          }
        },
        "20": {
          "1": {
            "star_index": 3595237,
            "get_star_ts": 1671677774
          },
          "2": {
            "star_index": 3595277,
            "get_star_ts": 1671677894
          }
        },
        "21": {
          "1": {
            "star_index": 3628695,
            "get_star_ts": 1671728968
          },
          "2": {
            "star_index": 3628959,
            "get_star_ts": 1671729325
          }
        },
        "22": {
          "1": {
            "get_star_ts": 1671722685,
            "star_index": 3623818
          },
          "2": {
            "get_star_ts": 1671722822,
            "star_index": 3623927
          }
        },
        "23": {
          "1": {
            "get_star_ts": 1671814601,
            "star_index": 3686766
          },
          "2": {
            "star_index": 3687087,
            "get_star_ts": 1671814984
          }
        },
        "24": {
          "1": {
            "star_index": 3741691,
            "get_star_ts": 1671912190
          },
          "2": {
            "get_star_ts": 1671912356,
            "star_index": 3741784
          }
        },
        "25": {
          "1": {
            "get_star_ts": 1671985060,
            "star_index": 3780671
          },
          "2": {
            "get_star_ts": 1671985070,
            "star_index": 3780681
          }
        }
      },
      "global_score": 0,
      "name": "Alex Carstairs",
      "id": 2440673
    },
    "2441211": {
      "name": "Austin King",
      "id": 2441211,
      "stars": 10,
      "last_star_ts": 1673537756,
      "local_score": 734,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669910945,
            "star_index": 155619
          },
          "2": {
            "get_star_ts": 1669911576,
            "star_index": 157847
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669992460,
            "star_index": 448742
          },
          "2": {
            "get_star_ts": 1669993433,
            "star_index": 453132
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1673537747,
            "star_index": 4038704
          },
          "2": {
            "get_star_ts": 1673537756,
            "star_index": 4038707
          }
        },
        "4": {
          "1": {
            "star_index": 4034352,
            "get_star_ts": 1673471513
          },
          "2": {
            "star_index": 4034443,
            "get_star_ts": 1673472521
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1673474321,
            "star_index": 4034633
          },
          "2": {
            "get_star_ts": 1673488424,
            "star_index": 4035621
          }
        }
      },
      "global_score": 0
    },
    "2447689": {
      "name": "Destiny Wilson",
      "id": 2447689,
      "last_star_ts": 1670092124,
      "stars": 6,
      "local_score": 534,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669934040,
            "star_index": 232645
          },
          "2": {
            "star_index": 233581,
            "get_star_ts": 1669934375
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669996524,
            "star_index": 466743
          },
          "2": {
            "get_star_ts": 1669998797,
            "star_index": 476167
          }
        },
        "3": {
          "1": {
            "star_index": 761036,
            "get_star_ts": 1670089092
          },
          "2": {
            "get_star_ts": 1670092124,
            "star_index": 770983
          }
        }
      }
    },
    "2447988": {
      "name": "Keith Sullivan",
      "id": 2447988,
      "last_star_ts": 1671818617,
      "stars": 22,
      "local_score": 2499,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 188335,
            "get_star_ts": 1669920244
          },
          "2": {
            "get_star_ts": 1669921954,
            "star_index": 193932
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1669985921,
            "star_index": 421006
          },
          "2": {
            "star_index": 423946,
            "get_star_ts": 1669986670
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670079591,
            "star_index": 728174
          },
          "2": {
            "get_star_ts": 1670091192,
            "star_index": 768002
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670245371,
            "star_index": 1267009
          },
          "2": {
            "get_star_ts": 1670245761,
            "star_index": 1268500
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670250405,
            "star_index": 1286664
          },
          "2": {
            "get_star_ts": 1670251317,
            "star_index": 1290326
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1670336089,
            "star_index": 1606618
          },
          "2": {
            "get_star_ts": 1670339488,
            "star_index": 1619886
          }
        },
        "7": {
          "1": {
            "star_index": 2072672,
            "get_star_ts": 1670511851
          },
          "2": {
            "star_index": 2076571,
            "get_star_ts": 1670513187
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670590099,
            "star_index": 2248654
          },
          "2": {
            "star_index": 2251125,
            "get_star_ts": 1670591125
          }
        },
        "9": {
          "1": {
            "star_index": 2260422,
            "get_star_ts": 1670594879
          },
          "2": {
            "get_star_ts": 1670595493,
            "star_index": 2261943
          }
        },
        "10": {
          "1": {
            "get_star_ts": 1671559138,
            "star_index": 3502611
          },
          "2": {
            "get_star_ts": 1671560801,
            "star_index": 3503974
          }
        },
        "11": {
          "1": {
            "star_index": 3687688,
            "get_star_ts": 1671815742
          },
          "2": {
            "get_star_ts": 1671818617,
            "star_index": 3689807
          }
        }
      }
    },
    "2450410": {
      "id": 2450410,
      "name": "Mark Adcock",
      "global_score": 0,
      "completion_day_level": {},
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0
    },
    "2461779": {
      "last_star_ts": 0,
      "local_score": 0,
      "stars": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Lara Reedick",
      "id": 2461779
    },
    "2475938": {
      "last_star_ts": 1671063143,
      "local_score": 1279,
      "stars": 17,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 1843410,
            "get_star_ts": 1670424824
          },
          "2": {
            "star_index": 1855971,
            "get_star_ts": 1670429055
          }
        },
        "2": {
          "1": {
            "star_index": 1895829,
            "get_star_ts": 1670443191
          },
          "2": {
            "get_star_ts": 1670446627,
            "star_index": 1905696
          }
        },
        "3": {
          "1": {
            "star_index": 2144412,
            "get_star_ts": 1670538888
          },
          "2": {
            "star_index": 2146460,
            "get_star_ts": 1670539825
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670540700,
            "star_index": 2148203
          },
          "2": {
            "star_index": 2148503,
            "get_star_ts": 1670540891
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1670602857,
            "star_index": 2280427
          },
          "2": {
            "star_index": 2285069,
            "get_star_ts": 1670604800
          }
        },
        "6": {
          "1": {
            "star_index": 2300894,
            "get_star_ts": 1670612394
          },
          "2": {
            "get_star_ts": 1670615186,
            "star_index": 2306353
          }
        },
        "7": {
          "1": {
            "star_index": 3018840,
            "get_star_ts": 1671025606
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1670863843,
            "star_index": 2775576
          },
          "2": {
            "get_star_ts": 1671033058,
            "star_index": 3030415
          }
        },
        "10": {
          "1": {
            "star_index": 3069902,
            "get_star_ts": 1671060588
          }
        },
        "11": {
          "1": {
            "star_index": 3072177,
            "get_star_ts": 1671063143
          }
        }
      },
      "global_score": 0,
      "name": "Rachel Wiseley",
      "id": 2475938
    },
    "2480491": {
      "last_star_ts": 0,
      "stars": 0,
      "local_score": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Khoi Le",
      "id": 2480491
    },
    "2481184": {
      "name": "Alden Nail",
      "id": 2481184,
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "completion_day_level": {},
      "global_score": 0
    },
    "2482979": {
      "global_score": 0,
      "completion_day_level": {},
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "id": 2482979,
      "name": "Keelan Johnson"
    },
    "2493439": {
      "id": 2493439,
      "name": "Hunter Maloof",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1669936241,
            "star_index": 238118
          },
          "2": {
            "get_star_ts": 1669937984,
            "star_index": 241514
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670004332,
            "star_index": 496642
          },
          "2": {
            "star_index": 498434,
            "get_star_ts": 1670004862
          }
        },
        "3": {
          "1": {
            "star_index": 4041799,
            "get_star_ts": 1673572128
          },
          "2": {
            "get_star_ts": 1673573272,
            "star_index": 4041851
          }
        },
        "4": {
          "1": {
            "star_index": 4042001,
            "get_star_ts": 1673576422
          },
          "2": {
            "get_star_ts": 1673577499,
            "star_index": 4042057
          }
        }
      },
      "global_score": 0,
      "last_star_ts": 1673577499,
      "local_score": 492,
      "stars": 8
    },
    "2498209": {
      "last_star_ts": 1670566746,
      "local_score": 2342,
      "stars": 17,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 237500,
            "get_star_ts": 1669935954
          },
          "2": {
            "star_index": 241925,
            "get_star_ts": 1669938195
          }
        },
        "2": {
          "1": {
            "star_index": 344268,
            "get_star_ts": 1669969914
          },
          "2": {
            "get_star_ts": 1669971025,
            "star_index": 350834
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670045045,
            "star_index": 590613
          },
          "2": {
            "get_star_ts": 1670045924,
            "star_index": 598267
          }
        },
        "4": {
          "1": {
            "get_star_ts": 1670132377,
            "star_index": 872312
          },
          "2": {
            "get_star_ts": 1670132444,
            "star_index": 872719
          }
        },
        "5": {
          "1": {
            "star_index": 1157186,
            "get_star_ts": 1670219458
          },
          "2": {
            "get_star_ts": 1670219593,
            "star_index": 1158039
          }
        },
        "6": {
          "1": {
            "star_index": 1446733,
            "get_star_ts": 1670303351
          },
          "2": {
            "star_index": 1450656,
            "get_star_ts": 1670303520
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1670396582,
            "star_index": 1763420
          },
          "2": {
            "star_index": 1766331,
            "get_star_ts": 1670397556
          }
        },
        "8": {
          "1": {
            "star_index": 1970651,
            "get_star_ts": 1670478409
          },
          "2": {
            "get_star_ts": 1670479907,
            "star_index": 1978009
          }
        },
        "9": {
          "1": {
            "star_index": 2190294,
            "get_star_ts": 1670566746
          }
        }
      },
      "global_score": 0,
      "name": "Brandon Comiter",
      "id": 2498209
    },
    "2565107": {
      "last_star_ts": 1670610034,
      "local_score": 336,
      "stars": 6,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 494294,
            "get_star_ts": 1670003631
          },
          "2": {
            "get_star_ts": 1670004529,
            "star_index": 497309
          }
        },
        "2": {
          "1": {
            "star_index": 1630042,
            "get_star_ts": 1670342231
          },
          "2": {
            "star_index": 1667443,
            "get_star_ts": 1670353853
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1670592378,
            "star_index": 2253964
          }
        },
        "4": {
          "1": {
            "star_index": 2295996,
            "get_star_ts": 1670610034
          }
        }
      },
      "name": "Jordan Remer",
      "id": 2565107
    },
    "2571105": {
      "id": 2571105,
      "name": "Ahmad Solomon",
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1671048644,
            "star_index": 3053241
          },
          "2": {
            "get_star_ts": 1671049176,
            "star_index": 3053955
          }
        },
        "2": {
          "1": {
            "star_index": 3129749,
            "get_star_ts": 1671114339
          },
          "2": {
            "get_star_ts": 1671121561,
            "star_index": 3139647
          }
        },
        "3": {
          "1": {
            "get_star_ts": 1671465845,
            "star_index": 3429025
          },
          "2": {
            "star_index": 3434109,
            "get_star_ts": 1671471584
          }
        },
        "4": {
          "1": {
            "star_index": 3562689,
            "get_star_ts": 1671632747
          },
          "2": {
            "get_star_ts": 1671634607,
            "star_index": 3564498
          }
        },
        "5": {
          "1": {
            "star_index": 3689129,
            "get_star_ts": 1671817717
          },
          "2": {
            "star_index": 3691019,
            "get_star_ts": 1671820271
          }
        },
        "6": {
          "1": {
            "star_index": 3867576,
            "get_star_ts": 1672251308
          },
          "2": {
            "star_index": 3867676,
            "get_star_ts": 1672251538
          }
        }
      },
      "global_score": 0,
      "local_score": 658,
      "last_star_ts": 1672251538,
      "stars": 12
    },
    "2583280": {
      "local_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "global_score": 0,
      "completion_day_level": {},
      "name": "Afolabi Cardoso",
      "id": 2583280
    },
    "2681684": {
      "id": 2681684,
      "name": "Adi Raina",
      "completion_day_level": {},
      "global_score": 0,
      "last_star_ts": 0,
      "stars": 0,
      "local_score": 0
    },
    "2727426": {
      "name": "Devin Sabo",
      "id": 2727426,
      "last_star_ts": 1672288054,
      "local_score": 2738,
      "stars": 30,
      "completion_day_level": {
        "1": {
          "1": {
            "star_index": 3173136,
            "get_star_ts": 1671147253
          },
          "2": {
            "get_star_ts": 1671147714,
            "star_index": 3173562
          }
        },
        "2": {
          "1": {
            "star_index": 3174656,
            "get_star_ts": 1671149131
          },
          "2": {
            "star_index": 3175073,
            "get_star_ts": 1671149695
          }
        },
        "3": {
          "1": {
            "star_index": 3175857,
            "get_star_ts": 1671150880
          },
          "2": {
            "get_star_ts": 1671151531,
            "star_index": 3176265
          }
        },
        "4": {
          "1": {
            "star_index": 3176990,
            "get_star_ts": 1671152648
          },
          "2": {
            "get_star_ts": 1671155762,
            "star_index": 3178706
          }
        },
        "5": {
          "1": {
            "get_star_ts": 1671203329,
            "star_index": 3215299
          },
          "2": {
            "star_index": 3215377,
            "get_star_ts": 1671203397
          }
        },
        "6": {
          "1": {
            "get_star_ts": 1671204398,
            "star_index": 3216460
          },
          "2": {
            "star_index": 3216578,
            "get_star_ts": 1671204494
          }
        },
        "7": {
          "1": {
            "get_star_ts": 1671316170,
            "star_index": 3311106
          },
          "2": {
            "star_index": 3311770,
            "get_star_ts": 1671316840
          }
        },
        "8": {
          "1": {
            "get_star_ts": 1671318526,
            "star_index": 3313303
          },
          "2": {
            "get_star_ts": 1671320727,
            "star_index": 3315065
          }
        },
        "9": {
          "1": {
            "get_star_ts": 1671473164,
            "star_index": 3435417
          },
          "2": {
            "star_index": 3445782,
            "get_star_ts": 1671484740
          }
        },
        "10": {
          "1": {
            "star_index": 3447951,
            "get_star_ts": 1671486908
          },
          "2": {
            "star_index": 3490839,
            "get_star_ts": 1671546264
          }
        },
        "11": {
          "1": {
            "get_star_ts": 1671552981,
            "star_index": 3496977
          },
          "2": {
            "get_star_ts": 1671560803,
            "star_index": 3503975
          }
        },
        "12": {
          "1": {
            "get_star_ts": 1671801010,
            "star_index": 3675942
          },
          "2": {
            "get_star_ts": 1671822265,
            "star_index": 3692397
          }
        },
        "13": {
          "1": {
            "get_star_ts": 1672208125,
            "star_index": 3855262
          },
          "2": {
            "get_star_ts": 1672209333,
            "star_index": 3855426
          }
        },
        "14": {
          "1": {
            "get_star_ts": 1672243322,
            "star_index": 3864442
          },
          "2": {
            "get_star_ts": 1672252949,
            "star_index": 3868217
          }
        },
        "15": {
          "1": {
            "get_star_ts": 1672286082,
            "star_index": 3877621
          },
          "2": {
            "get_star_ts": 1672288054,
            "star_index": 3877927
          }
        }
      },
      "global_score": 0
    },
    "2757251": {
      "name": "Eric Schwartz",
      "id": 2757251,
      "local_score": 174,
      "last_star_ts": 1670511009,
      "stars": 4,
      "global_score": 0,
      "completion_day_level": {
        "1": {
          "1": {
            "get_star_ts": 1670507154,
            "star_index": 2059327
          },
          "2": {
            "get_star_ts": 1670511009,
            "star_index": 2070315
          }
        },
        "2": {
          "1": {
            "get_star_ts": 1670508606,
            "star_index": 2063417
          },
          "2": {
            "get_star_ts": 1670509563,
            "star_index": 2066146
          }
        }
      }
    }
  },
  "owner_id": 186556,
  "event": "2022"
};

export default Object.values(raw.members)
  .filter(({stars}) => stars)
  .map(member => {
    if(!member.name) {
      member.name = `unknown -- ${member.id}`
    }
    return member;
  });